import React, { useState, useRef, useEffect, useMemo } from "react"
import {
  CardBody,
  Col,
  Container,
  Row,
  // Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
} from "reactstrap"
import { Dropdown } from "primereact/dropdown"
import { TabView, TabPanel } from "primereact/tabview"
import { Link, useLocation } from "react-router-dom"
import moment from "moment"
import { FilterMatchMode } from "primereact/api"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { InputText } from "primereact/inputtext"
import { Button } from "primereact/button"
import { Sidebar } from "primereact/sidebar"
import { InputNumber } from "primereact/inputnumber"
import { InputTextarea } from "primereact/inputtextarea"
import { Editor } from "primereact/editor"
import { Chips } from "primereact/chips"
import * as XLSX from "xlsx"
import jsPDF from "jspdf"
import { MultiSelect } from "primereact/multiselect" // Make sure to import MultiSelect correctly
import "jspdf-autotable"
import { Calendar } from "primereact/calendar"

import { Controller, useForm } from "react-hook-form"
import axios from "axios"
import { getProjects, createProject, updateProject, deleteProject, getCompanies, getContacts, getEmployees, getProject } from "../../helpers/backend-helper"
import LinkWorkType from "./LinkWorkType"
// import { Toast } from 'primereact/toast';
import { Accordion, AccordionTab } from "primereact/accordion"
import { Badge } from "primereact/badge"
import { TreeTable } from "primereact/treetable"
import { Card } from "primereact/card"
import { CascadeSelect } from "primereact/cascadeselect"
import AddMenu from "components/CommonForBoth/topbar-dropdown/AddMenu"
import { TreeSelect } from "primereact/treeselect"
import Select from "react-select"
import { Dialog } from "primereact/dialog"
import { useNavigate } from "react-router-dom"
import NotesJobs from "../common-for-all/NotesProjects"
import NotesJobs1 from "../common-for-all/NotesJobsNames"
import { Tooltip } from "primereact/tooltip"
import { Checkbox } from "primereact/checkbox"
import LinkContactsPopup from "pms/common-for-all/LinkContactsPopup"
import LinkJobsPopup from "pms/common-for-all/LinkWorkTypePopup"
import LinkContact2Popup from "pms/common-for-all/LinkContact2Popup"
import { SelectButton } from "primereact/selectbutton"

import { ContextMenu } from "primereact/contextmenu"
import { Toast } from "primereact/toast"
import SubmitProjecttoWorkType from "./SubmitProjecttoWorkType"

import { useDispatch, useSelector } from "react-redux"
import WorkTypeManager from "./WorkTypeManager"
import WorkType from "pms/common-for-all/WorkType"
import WorkType1 from "pms/common-for-all/WorkTypeOne"
import DateRangePicker from "pms/common-for-all/DateRangePicker"
import EstimateTable from "./EstimateTable"
import WorkTypeSidebar from "pms/resources/WorkTypeSidebar"
import { getCookie } from "../../helpers/cookie"
import { FileUpload } from "primereact/fileupload"
import { setPageData } from "../../store/actions"
import { ColorPicker } from "primereact/colorpicker";
import { get, set } from "lodash"
import { NOTIFICATION_API_STATUS_FALSE, NOTIFICATION_API_STATUS_TRUE } from "../../store/calendar/actionTypes"

const ProjectAllActive = ({ toggleSidebar }) => {
  const token = getCookie('access_token');
  const UserInfo = JSON.parse(getCookie('user_info'));
  const dispatch = useDispatch();
  const { register: StageRegister, trigger: StageTrigger, formState: { errors: StageErrors }, reset: resetStageForm, setValue: setStageValue, handleSubmit: stageSubmit } = useForm();
   const { register: sendRegister,handleSubmit: sendHandleSubmit,reset: sendReset,formState: { errors: sendErrors },setValue: sendSetValue} = useForm();
    const [sendReportDialog,setSendReportDialog] = useState(false)
  const formatDate = (date) => date ? new Date(date).toLocaleDateString('en-GB').replace(/\//g, '-') : '';  
  const [PoliciesfilesErrorMessagepan, setPoliciesfilesErrorMessagepan] = useState()
  const [selectedProjectStatus, setSelectedProjectStatus] = useState("Active")
  const { first, rows } = useSelector(state => state?.calendar?.pagination)
  const apiStatus = useSelector(state => state.calendar.apiStatus)
  const isTeamAdded = useSelector(state => state.calendar.isTeamAdded)
  const [apiLoader, setapiLoader] = useState(false)
  const [documentTypes, setDocumentTypes] = useState([]);
  const [subject, setSubject] = useState('');
  const [displayDialog, setDisplayDialog] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(null)
  const [ShowGrouppopup, setShowGrouppopup] = useState(false);
  const [scheduleText, setScheduleText] = useState("The Minutes of Meeting (MoM) document captures the key points discussed, decisions made, and action items agreed upon during the meeting. It serves as a record for reference and accountability, ensuring all participants are aligned on the outcomes and next steps.")
  const fileUploadRef = useRef(null) // 👈 create ref
  const [imageNamepan, setImageNamepan] = useState('');
  const [HaveImagePan, setHaveImagePan] = useState(false);
  const removeFileFromHerepan = () => {
    setValue("attachment_file", "");
    setHaveImagePan(false);
    setImageNamepan('')
  }
  const onSelect = (e) => {
    setUploadedFiles(e.files)
  }
  const [selectedGroupKey, setSelectedGroupKey] = useState(null)
  const [description, setdescription] = useState('')
  const [selectedStatusWorkType, setSelectedStatusWorkType] = useState(null)
  const [selectedManager, setSelectedManager] = useState(null)
  const [selectedProjectManagerCompany, setSelectedProjectManagerCompany] = useState(null)
  const [selectedManagerCompany, setSelectedManagerCompany] = useState(null)
  const [manageroptions, setManageroptions] = useState([])
  const [activeWorkTypeTabIndex, setActiveWorkTypeTabIndex] = useState(0)
  const [workTypeStatus, setWorkTypeStatus] = useState([])
  const statusId = workTypeStatus[activeWorkTypeTabIndex]?.id;
  const onClear = () => {
    setUploadedFiles([])
  }
  //Tasks Status
  const [taskstatusloading, setTaskstatusloading] = useState(false);
  const [showStatuspopup, setShowStatuspopup] = useState(false);
  const [TasksStatusList, setTasksStatusList] = useState([])
  const [taskstatuspage, setTaskstatuspage] = useState(1);
  const [taskstatusperpage, setTaskstatusperpage] = useState(10);
  const [totalTaskstatusCount, setTotalTaskstatusCount] = useState(0);
  ///// Approval Status
  const [approvalstatusloading, setApprovalstatusloading] = useState(false);
  const [ApprovalStatusList, setApprovalStatusList] = useState([])
  const [showApprovalStatuspopup, setShowApprovalStatuspopup] = useState(false);
  const [ApprovalStatusid, setApprovalStatusid] = useState(null);
  const [approvalstatuspage, setApprovalstatuspage] = useState(1);
  const [approvalstatusperpage, setApprovalstatusperpage] = useState(10);
  const [totalApprovalstatusCount, setTotalApprovalstatusCount] = useState(0);
  //Modules
  const [modulesloading, setModulesloading] = useState(false);
  const [showModulepopup, setShowModulepopup] = useState(false);
  const [ModulesList, setModulesList] = useState([])
  const [modulepage, setModulepage] = useState(1);
  const [modulesperpage, setModulesperpage] = useState(10);
  const [totalModulesCount, setTotalModulesCount] = useState(0);
  // Stages
  const [stagesLoading, setStagesLoading] = useState(false);
  const [stageList, setstageList] = useState("")
  const [totalStagesCount, setTotalStagesCount] = useState(0);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  // Groups
  const [GroupsList, setGroupsList] = useState([])
  const [groupLoading, setGroupLoading] = useState(false);
  const [grouppage, setGrouppage] = useState(1);
  const [groupperPage, setGroupperPage] = useState(10);
  const [totalGroupsCount, setTotalGroupsCount] = useState(0);
  // Employees
  const [employeeLoading, setEmployeeLoading] = useState(false);
  const [employeepage, setEmployeepage] = useState(1);
  const [employeeperPage, setEmployeeperPage] = useState(10);
  const [totalEmployeesCount, setTotalEmployeesCount] = useState(0);
  //Tasks
  const [taskLoading, setTaskLoading] = useState(false);
  const [totalTasksCount, setTotalTasksCount] = useState(0);
  console.log(totalTasksCount,'totalTasksCount');
  
  const [tasksperpage, setTasksperpage] = useState(10);
  const [taskpage, setTaskpage] = useState(1);
  //  const stageList = [
  //   {
  //     id: 1,
  //     stage_name: "Requirement Gathering",
  //     group_name: "Business Analysts",
  //     responsible: "Aarush Advane",
  //     member_count: 8
  //   },
  //   {
  //     id: 2,
  //     stage_name: "Planning & Estimation",
  //     group_name: "Project Management",
  //     responsible: "Pranathi",
  //     member_count: 6
  //   },
  //   {
  //     id: 3,
  //     stage_name: "Design",
  //     group_name: "UI/UX Team",
  //     responsible: "Rohit Kumar",
  //     member_count: 5
  //   },
  //   {
  //     id: 4,
  //     stage_name: "Development",
  //     group_name: "Development Team",
  //     responsible: "Vinay Penta",
  //     member_count: 12
  //   },
  //   {
  //     id: 5,
  //     stage_name: "Testing",
  //     group_name: "QA Team",
  //     responsible: "Varun",
  //     member_count: 7
  //   },
  //   {
  //     id: 6,
  //     stage_name: "Deployment",
  //     group_name: "DevOps Team",
  //     responsible: "Sandeep",
  //     member_count: 4
  //   },
  //   {
  //     id: 7,
  //     stage_name: "Maintenance & Support",
  //     group_name: "Support Team",
  //     responsible: "Kiran",
  //     member_count: 5
  //   }
  // ];
  const getStages = async (id,page,perPage) => {
    try {
      setStagesLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_Company_Contact}/company/projects/${id}/stages/?limit=${perPage}&offset=${(page-1) * perPage}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      if (response.status === 200) {
        setstageList(response.data.results || response.data || []);
        setTotalStagesCount(response.data.results.length || response.data.length || 0);
        setStagesLoading(false);
      }
    } catch (err) {
      console.log("Error fetching stages:", err);
      setStagesLoading(false);
    }

  }
  const [showStagepopup, setshowStagepopup] = useState(false);
  const [selectedresponsiblePerson, setSelectedresponsiblePerson] = useState(null)
  const [selectedresponsiblePersonCompany, setSelectedresponsiblePersonCompany] = useState(null)
  const [responsiblePersonOptions, setResponsiblePersonOptions] = useState([])
  const [selectedGroup, setSelectedGroup] = useState(null)
  const [groupOptions, setGroupOptions] = useState([])

  const handleCancelStagePopup = () => {
    setshowStagepopup(false);
    setSelectedresponsiblePersonCompany(null);
    setSelectedresponsiblePerson(null);
    setSelectedGroup(null);
    resetStageForm();
    setStageEditId(null)
  }
 const [expandedRows, setExpandedRows] = useState({});
  
   const handleStagePageChange = (e) => {
    const newPage = e.page + 1; 
    const newRows = e.rows;
    setPage(newPage);
    setPerPage(newRows);
    getStages(EditId,newPage,newRows);
  }
  const handleGroupPageChange = (e) => {
    const newPage = e.page + 1;
    const newRows = e.rows;
    setGrouppage(newPage);
    setGroupperPage(newRows);
    GetGroups(EditId,newPage,newRows);
  }
  const handleEmployeePageChange = (e) => {
    const newPage = e.page + 1;
    const newRows = e.rows;
    setEmployeepage(newPage);
    setEmployeeperPage(newRows);
    getEmployees(EditId,newPage,newRows);
  }
  const handleTaskPageChange = (e) => {
    const newPage = e.page + 1;
    const newRows = e.rows;
    setTaskpage(newPage);
    setTasksperpage(newRows);
    getWorktypes(EditId,newPage,newRows);
  }
  const handleModulePageChange = (e) => {
    const newPage = e.page + 1;
    const newRows = e.rows;
    setModulepage(newPage);
    setModulesperpage(newRows);
    GetModuleStatus(EditId,newPage,newRows);
  }
  const handleTaskStatusPageChange = (e) => {
    const newPage = e.page + 1;
    const newRows = e.rows;
    setTaskstatuspage(newPage);
    setTaskstatusperpage(newRows);
    GetTaskStatus(EditId,newPage,newRows);
  }
  const handleApprovalStatusPageChange = (e) => {
    const newPage = e.page + 1;
    const newRows = e.rows;
    setApprovalstatuspage(newPage);
    setApprovalstatusperpage(newRows);
    GetApprovalStatus(EditId,newPage,newRows);
  }
  const [StageEditId, setStageEditId] = useState(null)

  const onSubmitStages = async (data) => {
    if (!selectedresponsiblePerson) {
      alert("Please select Responsible Person");
      return;
    }
    const formData = new FormData();
    formData.append("stage_name", data.statusName || "");
    formData.append("responsible_person_company", selectedresponsiblePersonCompany || "");
    formData.append("responsible_person", selectedresponsiblePerson || "");
    formData.append("group", selectedGroup || "");
    try {
      const isEdit = Boolean(StageEditId);

      const url = isEdit
        ? `${process.env.REACT_APP_Company_Contact}/company/projects/${selectedJobsData[0]?.__raw?.id}/stages/${StageEditId}/`
        : `${process.env.REACT_APP_Company_Contact}/company/projects/${selectedJobsData[0]?.__raw?.id}/stages/`;

      const method = isEdit ? 'put' : 'post';

      const response = await axios({
        method,
        url,
        data: formData,
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      if (response.status === 200 || response.status === 201) {
        handleCancelStagePopup();
        setshowStagepopup(false);
        getStages(EditId,page,perPage)
      }
    } catch (err) {
      console.log("Error fetching stages:", err);
    }

  }
  const {
    register: taskRegister,
    handleSubmit: taskSubmit,
    control: taskControl,
    formState: { errors: taskErrors },
    reset: resetTaskForm,
    setValue: setTaskValue,
  } = useForm({
    defaultValues: {
      statusName: "",
      description: "",
      color: "#000000"
    }
  });
  const { register: moduleRegister, trigger: moduleTrigger, formState: { errors: moduleErrors }, reset: resetModuleForm, setValue: setModuleValue, handleSubmit: moduleSubmit } = useForm();
  const { register: groupRegister, trigger: groupTrigger, formState: { errors: groupErrors }, reset: resetGroupForm, setValue: setGroupValue, handleSubmit: groupSubmit } = useForm();
  const { register: approvalRegister, trigger: approvalTrigger, formState: { errors: approvalErrors }, reset: resetApprovalForm, setValue: setApprovalValue, handleSubmit: approvalSubmit, control: approvalControl } = useForm({
    defaultValues: {
      statusName: "",
      description: "",
      color: "#000000"
    }
  });
  const GetTaskStatus = async (id,page,perPage) => {
    try {
      setTaskstatusloading(true);
      const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/task-status/?project_id=${id}&limit=${perPage}&offset=${(page-1) * perPage}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      let tasksStatus = response.data.results || response.data || response.data.data || response.data.data.results;
      setTasksStatusList(tasksStatus)
      setTaskstatusloading(false);
    }
    catch (err) {
      console.log("Error fetching task status:", err);
      setTaskstatusloading(false);
    }
  }
  const GetApprovalStatus = async (id,page,perPage) => {
    try {
      setApprovalstatusloading(true);
      const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/approval-status/?project_id=${id}&limit=${perPage}&offset=${(page-1) * perPage}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      let tasksStatus = response.data.results || response.data || response.data.data || response.data.data.results;
      setApprovalStatusList(tasksStatus)
      setApprovalstatusloading(false);
    }
    catch (err) {
      console.log("Error fetching task status:", err);
      setApprovalstatusloading(false);
    }
  }
  const GetModuleStatus = async (id,page,perPage) => {
    try {
      setModulesloading(true);
      const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/modules/?project_id=${id}&limit=${perPage}&offset=${(page-1) * perPage}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      let tasksStatus = response.data.results || response.data || response.data.data || response.data.data.results;
      setModulesList(tasksStatus)
      setTotalModulesCount(response.data.length || 0);
      setModulesloading(false);
    }
    catch (err) {
      console.log("Error fetching task status:", err);
      setModulesloading(false);
    }
  }
  const GetGroups = async (id,page,perPage) => {
    try {
      setGroupLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/${id}/groups/?limit=${perPage}&offset=${(page-1) * perPage}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(response,'reponsue');
      
      let tasksStatus = response.data.results || response.data || response.data.data || response.data.data.results;
      setGroupsList(tasksStatus)
      setGroupLoading(false);
      setTotalGroupsCount(response.data.length || 0);
    }
    catch (err) {
      console.log("Error fetching task status:", err);
      setGroupLoading(false);
    }
  }
  const [showWorkTypeSidebar, setShowWorkTypeSidebar] = useState(false);

  // tab active index view start

  const [activeTabIndex, setActiveTabIndex] = useState(0); // 0 = first tab, 1 = second tab, etc.

  const {
    register,
    handleSubmit,
    reset,
    trigger,
    clearErrors,
    formState: { errors },
    setValue,
    getValues,
    control,
    watch,
  } = useForm()
  const startDateWatch = watch("startDate");
  // action items

  const [selectedEmailOption, setSelectedEmailOption] = useState(null)
  const emailOptions = [
    { label: "New Email", icon: "pi pi-envelope" },
    { label: "Selected", icon: "pi pi-check-circle" },
    { label: "Searched", icon: "pi pi-search" },
    { label: "All", icon: "pi pi-inbox" },
    { label: "Jobs", icon: "pi pi-briefcase" },
  ]

  const customWorkTypes1 = [
    {
      name: "Discovery / Initiation",
      color: "#000000",
      id: "active1",
      statuses: ["Pending", "Processing", "Completed"],
    },
    {
      name: "Planning / Requirements",
      color: "#000000",
      id: "active2",
      statuses: ["Pending", "Processing", "Completed"],
    },

    {
      name: " Design",
      color: "#000000",
      id: "active3",
      statuses: ["Pending", "Processing", "Completed"],
    },

    {
      name: "Development",
      color: "#000000",
      id: "active1",
      statuses: ["Pending", "Processing", "Completed"],
    },
  ]

  const customWorkTypes4 = [
    {
      name: "BA",
      color: "#000000",
      id: "active1",
      statuses: ["Pending", "Processing", "Completed"],
    },
    {
      name: "Development",
      color: "#000000",
      id: "active2",
      statuses: ["Pending", "Processing", "Completed"],
    },

    {
      name: "QA",
      color: "#000000",
      id: "active3",
      statuses: ["Pending", "Processing", "Completed"],
    },

    {
      name: "DevOps",
      color: "#000000",
      id: "active1",
      statuses: ["Pending", "Processing", "Completed"],
    },

    {
      name: "Design",
      color: "#000000",
      id: "active1",
      statuses: ["Pending", "Processing", "Completed"],
    },
  ]
  const selectedEmailTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <i className={`${option.icon} mr-2`}></i>
          <div>{option.label}</div>
        </div>
      )
    }
    return (
      <div className="flex align-items-center">
        <i className="pi pi-envelope mr-2"></i>
        <span>{props.placeholder}</span>
      </div>
    )
  }

  const emailOptionTemplate = option => {
    return (
      <div className="flex align-items-center">
        <i className={`${option.icon} mr-2`}></i>
        <div>{option.label}</div>
      </div>
    )
  }
  // sms
  const [selectedSmsOption, setSelectedSmsOption] = useState(null)
  const smsOptions = [
    { label: "Selected", icon: "pi pi-check-circle" },
    { label: "Searched", icon: "pi pi-search" },
    { label: "All", icon: "pi pi-inbox" },
  ]

  const selectedSmsTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <i className={`${option.icon} mr-2`}></i>
          <div>{option.label}</div>
        </div>
      )
    }
    return (
      <div className="flex align-items-center">
        <i className="pi pi-comment mr-2"></i>
        <span>{props.placeholder}</span>
      </div>
    )
  }

  const smsOptionTemplate = option => {
    return (
      <div className="flex align-items-center">
        <i className={`${option.icon} mr-2`}></i>
        <div>{option.label}</div>
      </div>
    )
  }

  //schedule

  const [selectedScheduleOption, setSelectedScheduleOption] = useState(null)

  const scheduleOptions = [
    { label: "Interview", icon: "pi pi-calendar-plus" },
    { label: "Call", icon: "pi pi-phone" },
    { label: "Meeting", icon: "pi pi-users" },
    { label: "Task", icon: "pi pi-check-square" },
    { label: "Event", icon: "pi pi-calendar" },
    { label: "Other", icon: "pi pi-cog" },
  ]

  const selectedScheduleTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <i className={`${option.icon} mr-2`} />
          <div>{option.label}</div>
        </div>
      )
    }
    return (
      <div className="flex align-items-center">
        <i className="pi pi-calendar mr-2" />{" "}
        {/* Default icon for placeholder */}
        <span>{props.placeholder}</span>
      </div>
    )
  }

  const scheduleOptionTemplate = option => {
    return (
      <div className="flex align-items-center">
        <i className={`${option.icon} mr-2`} />
        <div>{option.label}</div>
      </div>
    )
  }

  const items = [
    {
      label: "Add",
      icon: "pi pi-pencil",
      command: () => {
        toast.current.show({
          severity: "info",
          summary: "Add",
          detail: "Data Added",
        })
      },
    },
    {
      label: "Update",
      icon: "pi pi-refresh",
      command: () => {
        toast.current.show({
          severity: "success",
          summary: "Update",
          detail: "Data Updated",
        })
      },
    },
    {
      label: "Delete",
      icon: "pi pi-trash",
      command: () => {
        toast.current.show({
          severity: "error",
          summary: "Delete",
          detail: "Data Deleted",
        })
      },
    },
  ]

  const [tabs, setTabs] = useState([
    {
      key: "tab1",
      header: "Home",
      content: "Content for Home tab",
      iconClass: "pi pi-home",
    },
    {
      key: "tab2",
      header: "All Active",
      content: "Content for All Active tab",
      iconClass: "pi pi-list",
    },
    {
      key: "tab3",
      header: "Achieved",
      content: "Content for Achieved tab",
      iconClass: "pi pi-check-circle",
    },
  ])
  const [activeIndex, setActiveIndex] = useState(0)

  document.title = "PMS - All Active Projects"

  const [customers, setCustomers] = useState([])
  const [teamData, setTeamData] = useState([])
  const [Employees, setEmployees] = useState([])
  const getTeam = async (id) => {
    try {
      setapiLoader(true)
      const response = await axios.get(
        `${process.env.REACT_APP_Company_Contact}/company/employees/?company=${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.status === 200) {
        const mappedData = response.data.results.map((emp) => ({
          id: emp.id,
          name: emp.full_name,
          description: emp.designation_name || "-",
          role: emp.project_membership?.role || "Not Assigned",
          email: emp.primary_email,
          phone: emp.office_phone,
          is_in_project_team: emp.project_membership?.is_in_project_team || false,
        }));
        const sortedData = mappedData.sort(
          (a, b) => b.is_in_project_team - a.is_in_project_team
        );

        setTeamData(sortedData);
        setapiLoader(false)
      }
    } catch (err) {
      console.error("Error fetching team data:", err);
      setapiLoader(false)
    }
  };

  const getEmployees = async (id,page,perPage) => {
    try {
      setEmployeeLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_Company_Contact}/company/employees/?project_team=${id}&limit=${perPage}&offset=${(page-1) * perPage}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        setEmployees(response.data?.results);
        setTotalEmployeesCount(response.data.results.length || response.data.count || response.data.results);
        setEmployeeLoading(false);
      }
    } catch (err) {
      console.error("Failed to load modules:", err);
      setEmployeeLoading(false);
    }
  };
  // const [teamData, setTeamData] = useState([
  //   {
  //     name: "Mahesh Kumar Bhoga",
  //     description: "UI/UX Designer",
  //     role: "Manager",
  //     email: "maheshkumar@varundigitalmedia.com",
  //     phone: "9876543210",
  //   },
  //   {
  //     name: "Pavan Kumar",
  //     description: "Software Developer",
  //     role: "Team Lead",
  //     email: "pavankumar@varundigitalmedia.com",
  //     phone: "9876543214",
  //   },
  //   {
  //     name: "Ravi Teja",
  //     description: "Business Analyst",
  //     role: "BA",
  //     email: "ravi@varundigitalmedia.com",
  //     phone: "9876543212",
  //   },
  //   {
  //     name: "Lavan Kumar",
  //     description: "Frontend Developer",
  //     role: "Developer",
  //     email: "lavankumar@pranathsoftwareservices.com",
  //     phone: "9876543211",
  //   },
  //   {
  //     name: "Teja",
  //     description: "Backend Developer",
  //     role: "Developer",
  //     email: "teja@varundigitalmedia.com",
  //     phone: "9876543219",
  //   },
  //   {
  //     name: "Ashok",
  //     description: "Test Engineer",
  //     role: "QA",
  //     email: "ashok@varundigitalmedia.com",
  //     phone: "9876543215",
  //   },
  // ])

  const [selectedTeamMembers, setSelectedTeamMembers] = useState([])

  const onGlobalFilterChange = e => {
    const value = e.target.value
    let _filters = { ...filters }
    _filters["global"].value = value
    setFilters(_filters)
    setGlobalFilterValue(value)
  }
  const onSelectionChange = e => {
    setSelectedCustomers(e.value)
  }
  const onRowReorder = e => {
    setCustomers(e.value)
  }
  const exportCSV = () => {
    if (dt.current) {
      dt.current.exportCSV()
    }
  }
  const exportExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(customers)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, "Customers")
    XLSX.writeFile(workbook, "customers_data.xlsx")
  }
  const exportPdf = () => {
    const doc = new jsPDF()
    doc.text("Customer Data", 14, 10)
    doc.autoTable({
      head: [
        [
          "ID",
          "JobId",
          "First Name",
          "Status",
          "Last Name",
          "Job Title",
          "Email",
          "Phone",
          "Company",
          "Experience",
          "ProjectStartDate",
          "ProjectEndDate",
          "JobLocation",
          "WorkplaceType",
          "ProjectType",
          "Categories",
          "Groups",
          "ResumeAttachment",
          "PrimarySkills",
          "CreatedBy",
          "EditDate",
          "CreateDate",
        ],
      ],
      body: customers.map(customer => [
        customer.id,
        customer.JobTitle,
        customer.Status,
        customer.HiringManager,
        customer.Lastname,
        customer.Email,
        customer.MobPhone,
        customer.Company,
        customer.Openings,
        customer.JobLocation,
        customer.WorkplaceType,
        customer.Categories,
        customer.ProjectType,
        customer.JobId,

        customer.Groups,
        customer.Department,
        customer.ProjectStartDate,
        customer.ProjectEndDate,
        customer.Seniority,
        customer.JobFunction,
        customer.ExperienceRequired,
        customer.MinSalary,
        customer.MaxSalary,
      ]),
    })
    doc.save("customers_data.pdf")
  }

  {
    /* Side bar start */
  }

  const [visibleRight, setVisibleRight] = useState(false)
  const [jobTitle, setJobTitle] = useState("")

  // Toggle dropdown open/close
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen)

  const [hiringManager, setHiringManager] = useState(null)
  const [company, setCompany] = useState("Varun Digital Media")
  const [compamyitem, setcompamyitem] = useState([])
  const [jobLocation, setJobLocation] = useState(null)
  const [experience, setExperience] = useState()

  // Example data for each field
  const hiringManagers = [
    { name: "John", code: "J1" },
    { name: "Michael", code: "M1" },
    { name: "Sarah", code: "S1" },
    { name: "James", code: "J2" },
  ]

  // use `compamyitem` populated from API; fallback to small default when empty
  const companies = compamyitem.length ? compamyitem : []

  const jobLocations = [
    { name: "Hyderabad", code: "HYD" },
    { name: "Chennai", code: "CHN" },
    { name: "Mumbai", code: "MUM" },
    { name: "Bangalore", code: "BLR" },
    { name: "Delhi", code: "DEL" },
  ]

  const [ProjectStartDate, setProjectStartDate] = useState(null)
  const [ProjectEndDate, setProjectEndDate] = useState(null)

  // files uploaded via the Create sidebar
  const [uploadedFiles, setUploadedFiles] = useState(null)

  //des

  const [text, setText] = useState()

  const renderHeader = () => {
    return (
      <span className="ql-formats">
        <button className="ql-bold" aria-label="Bold"></button>
        <button className="ql-italic" aria-label="Italic"></button>
        <button className="ql-underline" aria-label="Underline"></button>
      </span>
    )
  }

  const header = renderHeader()

  const [skills, setSkills] = useState([])
  const [isAddingSkill, setIsAddingSkill] = useState(false)
  const [primartkey, setprimartkey] = useState([])
  const [successAlert, setSuccessAlert] = useState(false)

  const handleAddSkill = () => {
    setIsAddingSkill(true)
  }

  const handleSkillChange = e => {
    const newSkills = e.value.filter(skill => !skills.includes(skill))
    if (newSkills.length > 0) {
      setSkills(prevSkills => [...prevSkills, ...newSkills]) // Add new skills
      setIsAddingSkill(false) // Hide the input field after a skill is added
    }
  }

  const removeSkill = skillToRemove => {
    setSkills(skills.filter(skill => skill !== skillToRemove))
  }

  {
    /* Side bar end */
  }

  const handleJobStatusChange = e => {
    setSelectedJobs(e.value)
  }

  ////////////////////////
  const [deleteRowId, setDeleteRowID] = useState(null) // end date value
  const [loader, setLoader] = useState(true)
  const getallactivejobs = async (page, size) => {
    try {
      // const response = selectedCompanyid === undefined ? await getProjects({is_archived:false}) : await getProject({ company_id: selectedCompanyid ,is_archived:false});
      const response = await getProject({ company_id: selectedModule, is_archived: false, limit: rows, offset: first });
      // normalize different possible response shapes
      let projects = []
      if (Array.isArray(response)) projects = response
      else if (response && Array.isArray(response.results)) projects = response.results
      else if (response && Array.isArray(response.data)) projects = response.data``
      else if (response && Array.isArray(response.projects)) projects = response.projects
      dispatch(
        setPageData({
          first: first,
          rows: rows,
          totalRecords: response.count,
        })
      )

      // Map backend project fields to the shape used by this table
      const mapped = projects.map(p => ({
        // frontend expects `job_id`, `job_title`, `company`, `hiring_manager`, etc.
        job_id: p.code || p.job_id || (p.id ? `PROJ${String(p.id).padStart(6, '0')}` : undefined),
        job_title: p.name || p.job_title || p.title || "",
        company: p.company_name || p.company || (p.company?.name) || "",
        company_id: p.company_id || (p.company_id?.id) || null,
        hiring_manager: p.project_manager_name || p.hiring_manager || p.project_manager || "",
        openings: p.project_manager_name || "",
        delivery_manager: p.delivery_manager_name || p.delivery_manager || "",
        workplace_type: p.reason_for_delay || p.workplace_type || "",
        status: p?.project_status_name,
        job_start_date: p.start_date || p.job_start_date || p.job_start || null,
        job_end_date: p.end_date || p.job_end_date || p.job_end || null,
        job_type: p.extended_end_date || p.job_type || "",
        // keep original payload for any additional fields
        __raw: p,
      }))

      setLoader(false)
      setJobsData(mapped)
    } catch (error) {
      console.error("Error fetching projects:", error);
      setLoader(false)
    }
  }
  const getProjectGroups = async (id) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/lookups/?name=project_groups`, {
        headers: { Authorization: `Bearer ${token}` },
      }
      );
      setgroups(response.data.results.results)
    } catch (err) {
      console.log(err);

    }
  }
  useEffect(() => {
    if (selectedGroupKey === lookupAddSentinel) {
      setEditingLookup(false)
      setLookupFormValue('')
      setLookupModalContext('project_groups')
      setLookupModalVisible(true)
    } else if (selectedGroupKey === lookupEditSentinel) {
      const selected = groups.find(g => g.id === lastSelectedLookupId)
      setEditingLookup(true)
      setLookupFormValue(selected ? selected.value : '')
      setSelectedGroupKey(selected ? selected.id : '')
      setLookupModalContext('project_groups')
      setLookupModalVisible(true)
      setSelectedEditdrop(lastSelectedLookupId)
    } else if (selectedGroupKey && selectedGroupKey !== lookupAddSentinel && selectedGroupKey !== lookupEditSentinel) {
      setLastSelectedLookupId(selectedGroupKey)
      setSelectedGroupKey(selectedGroupKey)
    }
  }, [selectedGroupKey])
  useEffect(() => {
    if (selectedStatusWorkType === lookupAddSentinel) {
      setEditingLookup(false)
      setLookupFormValue('')
      setLookupModalContext('project_status')
      setLookupModalVisible(true)
    } else if (selectedStatusWorkType === lookupEditSentinel) {
      const selected = statusWorkTypes.find(g => g.id === lastSelectedLookupId)
      setEditingLookup(true)
      setLookupFormValue(selected ? selected.name : '')
      setSelectedStatusWorkType(selected ? selected.id : '')
      setLookupModalContext('project_status')
      setSelectedEditdrop(lastSelectedLookupId)
      setLookupModalVisible(true)
    } else if (selectedStatusWorkType && selectedStatusWorkType !== lookupAddSentinel && selectedStatusWorkType !== lookupEditSentinel) {
      setLastSelectedLookupId(selectedStatusWorkType)
      setSelectedStatusWorkType(selectedStatusWorkType)
    }
  }, [selectedStatusWorkType])
  const handleLookupSave = async () => {
    try {
      if (lookupFormValue?.trim() === '') {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Value cannot be empty' })
        return

      }
      const token = getCookie('access_token')
      const payload = { value: lookupFormValue, name: lookupModalContext, description: description }
      if (editingLookup && lastSelectedLookupId) {
        await axios.patch(`${process.env.REACT_APP_Company_Contact}/company/lookups/${lastSelectedLookupId}/`, payload, { headers: { Authorization: `Bearer ${token}` } })
      } else {
        await axios.post(`${process.env.REACT_APP_Company_Contact}/company/lookups/`, { name: lookupModalContext, ...payload }, { headers: { Authorization: `Bearer ${token}` } })
      }
      // Refresh relevant lists depending on context
      if (lookupModalContext === 'project_groups') {
        await getProjectGroups()
      } else if (lookupModalContext === 'project_status') {
        await getProjectStatus()
      }
      setLookupModalVisible(false)
      setdescription('')
      setSuccessAlert(true)
    } catch (err) {
      console.error('Error saving lookup', err)
    }
  }
  const getdeliveryManager = async (companyId) => {
    try {
      setapiLoader(true)
      const response = await axios.get(
        `${process.env.REACT_APP_Company_Contact}/company/employees/?company=${companyId}&status=Active`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setManageroptions(response.data.results);
      setapiLoader(false)
    } catch (err) {
      console.log("Error fetching categories:", err);
      setapiLoader(false)
    }
  }
  const getProjectCategories = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Company_Contact}/company/lookups/?name=project_categories`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // Transform the API response to match TreeSelect format
      const transformedCategories = response.data.results.results.map(category => ({
        key: category.id.toString(),
        label: category.value,
        value: category.id,
      }));

      setCategories(transformedCategories);
    } catch (err) {
      console.log("Error fetching categories:", err);
    }
  }

  const getProjectStatus = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Company_Contact}/company/lookups/?name=project_status`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // Transform the API response to match WorkType1 format
      const transformedStatus = response.data.results.results.map(status => ({
        name: status.value,
        color: '#000000',
        id: status.id.toString(),
        statuses: ['Pending', 'Processing', 'Completed'],
        __original: status
      }));

      setStatusWorkTypes(transformedStatus);
    } catch (err) {
      console.log("Error fetching project status:", err);
    }
  }

  const getProjectManagersByCompany = async (companyId) => {
    try {
      if (!companyId) {
        setProjectManagerWorkTypes([]);
        return;
      }

      // Get all employees for the selected company
      const response = await getEmployees({ company: companyId, employeepage: employeepage, employeeperPage: employeeperPage,});
      let employees = [];
      if (response && response.results) {
        employees = response.results;
      } else if (Array.isArray(response)) {
        employees = response;
      }
      const transformedEmployees = employees.map(employee => ({
        name: `${employee.first_name || ''} ${employee.last_name || ''}(${employee.primary_email || ''})`,
        color: '#000000',
        id: employee.id.toString(),
        statuses: ['Pending', 'Processing', 'Completed'],
        __original: employee
      }));

      setProjectManagerWorkTypes(transformedEmployees);

    } catch (err) {
      console.log("Error fetching employees:", err);
      setProjectManagerWorkTypes([]);
    }
  }
  // useEffect(() => {
  //   getProjectGroups()
  //   getProjectCategories()
  //   getProjectStatus()
  // }, [apiStatus])
  const getCompanydata = async () => {
    try {
      const response = await getCompanies();
      // normalize possible response shapes
      let items = []
      if (Array.isArray(response)) items = response
      else if (response && Array.isArray(response.results)) items = response.results
      else if (response && Array.isArray(response.data)) items = response.data

      // map companies to a consistent shape used by the UI
      const mapped = items.map(c => ({
        id: c.id || c.pk || c.company_id,
        name: c.name || c.company_name || c.title || "",
        code: c.code || c.company_code || null,
        label: c.name || c.company_name || c.title || "",
        value: c.id || c.pk || c.company_id || c.name || null,
        __raw: c,
      }))

      setcompamyitem(mapped);
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  }

  const getHirringmanager = async () => {
    try {
      const response = await getContacts();
      if (response.results) {
        // sethirringdata(response.results);
      }
    } catch (error) {
      console.error("Error fetching contacts:", error);
    }
  }

  const deleteHandler = async () => {
    try {
      let id = deleteRowId;
      await deleteProject(id);
      setSmShow(false);
      getallactivejobs(selectedModule);
      setSuccessAlert(true);
    } catch (error) {
      console.error("Error deleting project:", error);
      setSmShow(false);
    }
  }
  const resetForm = () => {
    setJobtitle("")
    setText("")
    setSelectedCompany(null)
    setSelectedProjectManager(null)
    setProjectStartDate(null)
    setProjectEndDate(null)
    setSelectedCategoryKey(null)
    setSelectedGroupKey(null)
    setPopchecked2(false)
    setSelectedManager(null)
    setSelectedStatusWorkType(null)
    setUploadedFiles(null)
    setPrivetDropdownValues([])
    setPrivateDrop(null)
  }


  // const createProjectSubmit = async () => {
  //   try {
  //     setLoading(true)
  //     if (jobtitle === "") {
  //         toast.current.show({ severity: 'error', summary: 'Error', detail: 'Please enter Project Name', life: 3000 });
  //         setLoading(false);
  //         return;
  //     }
  //     const formData = new FormData();
  //     if (uploadedFiles && uploadedFiles.length > 0) {
  //       uploadedFiles.forEach((file) => {
  //         formData.append("documents", file);
  //       });
  //     }

  //     formData.append("name", jobtitle);
  //     // formData.append("code", jobid);
  //     formData.append("description", text);
  //     formData.append("company", selectedCompany?.id || selectedCompany?.value || selectedCompany || "");
  //     formData.append("project_manager", selectedProjectManager);
  //     formData.append("start_date", ProjectStartDate ? moment(ProjectStartDate).format("YYYY-MM-DD") : "");
  //     formData.append("end_date", ProjectEndDate ? moment(ProjectEndDate).format("YYYY-MM-DD") : "");
  //     formData.append("category", selectedCategoryKey || "");
  //     formData.append("group", selectedGroupKey || "");
  //     formData.append("is_private", popchecked2 ? "true" : "false");
  //     formData.append("delivery_manager", selectedManager || "");
  //     formData.append("project_status", selectedStatusWorkType || "");
  //     formData.append("private_users", popchecked2 ? [privateDrop] : []);
  //     await createProject(formData)

  //     // close sidebar and refresh list
  //     setVisibleRight(false)
  //     await getallactivejobs()
  //     setSuccessAlert(true)
  //    resetForm()
  //   } catch (error) {
  //     console.error("Error creating project:", error)
  //     setSuccessAlert(false)
  //   } finally {
  //     setLoading(false)
  //   }
  // }
  const [Projecterror, setProjecterror] = useState('')
  const createProjectSubmit = async (data) => {

    try {
      setLoading(true);
      const payload1 = {
        name: jobtitle,
        description: text || "",
        company: selectedCompany?.id || selectedCompany?.value || selectedCompany || "",
        project_manager: selectedProjectManager || "",
        start_date: ProjectStartDate ? moment(ProjectStartDate).format("YYYY-MM-DD") : "",
        end_date: ProjectEndDate ? moment(ProjectEndDate).format("YYYY-MM-DD") : "",
        category: selectedCategoryKey || "",
        group: selectedGroupKey || "",
        is_private: popchecked2 ? true : false,
        delivery_manager_company: selectedManagerCompany || "",
        project_manager_company: selectedProjectManagerCompany || "",
        delivery_manager: selectedManager || "",
        project_status: selectedStatusWorkType || "",
        private_users: popchecked2 ? (Array.isArray(privateDrop) ? privateDrop : [privateDrop]) : [],
        documents: uploadedFiles || [] // optional if backend accepts file URLs/base64 or separate upload
      };
      const payload =
      {
        name: data.projectName,
        description: data.description || "",
        company: data.company,
        project_manager: data.projectManager || "",
        project_manager_company: data.projectManagerCompany || "",
        delivery_manager: data.deliveryManager || "",
        delivery_manager_company: data.deliveryManagerCompany || "",
        start_date: data.startDate ? moment(data.startDate).format("YYYY-MM-DD") : "",
        end_date: data.endDate ? moment(data.endDate).format("YYYY-MM-DD") : "",
        attachment_file: uploadedFiles?.[0],
        stages: (data.stages || []).map(s => ({
          stage_name: s.stage_name || "",
          responsible_person_company: s.company || s.responsible_person_company || null,
          responsible_person: s.person || s.responsible_person_name || null
        }))

      }

      const formData = new FormData();

      formData.append("name", data.projectName);
      formData.append("description", data.description || "");
      formData.append("company", data.company);

      formData.append(
        "project_manager",
        data.projectManager?.id ?? data.projectManager ?? ""
      );
      formData.append(
        "project_manager_company",
        data.projectManagerCompany?.id ?? data.projectManagerCompany ?? ""
      );

      formData.append(
        "delivery_manager",
        data.deliveryManager?.id ?? data.deliveryManager ?? ""
      );
      formData.append(
        "delivery_manager_company",
        data.deliveryManagerCompany?.id ?? data.deliveryManagerCompany ?? ""
      );

      formData.append(
        "start_date",
        data.startDate ? moment(data.startDate).format("YYYY-MM-DD") : ""
      );
      formData.append(
        "end_date",
        data.endDate ? moment(data.endDate).format("YYYY-MM-DD") : ""
      );

      /* ✅ FILE */
      if (uploadedFiles?.length > 0) {
        formData.append("attachment_file", uploadedFiles[0]);
      }

      /* ✅ STAGES (FIXED) */
      formData.append(
        "stages",
        JSON.stringify(
          (data.stages || []).map((s) => ({
            stage_name: s.stage_name || "",

            responsible_person_company:
              s.company ??
              s.responsible_person_company ??
              null,

            responsible_person:
              s.person ??
              s.responsible_person_name ??
              null,
          }))
        )
      );




      await createProject(formData);
      dispatch({ type: NOTIFICATION_API_STATUS_TRUE });

      setTimeout(() => {
        dispatch({ type: NOTIFICATION_API_STATUS_FALSE });
      }, 2000);
      // close sidebar and refresh list
      setVisibleRight(false);
      await getallactivejobs(selectedModule);
      setSuccessAlert(true);
      resetForm();
    } catch (error) {

      let errorMessage = "Something went wrong";

      if (error.response?.data?.errors) {
        const errors = error.response.data.errors;
        const firstKey = Object.keys(errors)[0]; // e.g. "name", "email"
        const errorArray = errors[firstKey];
        errorMessage = errorArray[errorArray.length - 1]; // last string
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      }

      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: errorMessage,
        life: 3000
      });

      setSuccessAlert(false);
    }
    finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCompanydata()
    getHirringmanager()
    if (selectedCompany) {
      getProjectManager()
    }
  }, [])

  // jobs datatable

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    job_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    job_title: { value: null, matchMode: FilterMatchMode.CONTAINS },
    job_status: { value: null, matchMode: FilterMatchMode.CONTAINS },
    openings: { value: null, matchMode: FilterMatchMode.CONTAINS },
    hiring_manager: { value: null, matchMode: FilterMatchMode.CONTAINS },
    company: { value: null, matchMode: FilterMatchMode.CONTAINS },
    job_location: { value: null, matchMode: FilterMatchMode.CONTAINS },
    workplace_type: { value: null, matchMode: FilterMatchMode.CONTAINS },
    job_type: { value: null, matchMode: FilterMatchMode.CONTAINS },
    primary_skills: { value: null, matchMode: FilterMatchMode.CONTAINS },
    experience_required: { value: null, matchMode: FilterMatchMode.CONTAINS },
    min_salary: { value: null, matchMode: FilterMatchMode.CONTAINS },
    max_salary: { value: null, matchMode: FilterMatchMode.CONTAINS },
    department: { value: null, matchMode: FilterMatchMode.CONTAINS },
    job_start_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
    job_end_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
    job_hiring_goal: { value: null, matchMode: FilterMatchMode.CONTAINS },
    job_function: { value: null, matchMode: FilterMatchMode.CONTAINS },
    seniority: { value: null, matchMode: FilterMatchMode.CONTAINS },
    category: { value: null, matchMode: FilterMatchMode.CONTAINS },
    group: { value: null, matchMode: FilterMatchMode.CONTAINS },
    create_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
    edit_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
    created_by: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.CONTAINS },
    workplace_type: { value: null, matchMode: FilterMatchMode.CONTAINS },
  })

  const [jobsData, setJobsData] = useState([])

  const [selectedJobsData, setSelectedJobsData] = useState([])
  const [loading, setLoading] = useState(false)
  const [pageState, setPageState] = useState({ rows: 10, first: 0 })
  const navigate = useNavigate()

  const onPage = e => {
    setPageState({
      first: e.first,
      rows: e.rows,
    })
  }
  // clear search start
  const [tasksData, setTasksData] = useState([])
    const [selectedTasksData, setSelectedTasksData] = useState([])
    console.log(selectedTasksData,'selectedTasksDataselectedTasksData');
    
    const getSelectedTaskData = () => {
    return selectedTasksData.length ? selectedTasksData[0] : selectedTask
  }
  const handlegetEmail = async () => {
      try {
        if (selectedTasksData.length === 0) {
          toast.current && toast.current.show({
            severity: 'warn',
            summary: 'No Task Selected',
            detail: 'Please select a task to send report'
          })
          return
        }
        const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/custom-user/task-report/?project_id=${getSelectedTaskData()?._raw?.project}&employee_id=${getSelectedTaskData()?._raw?.assigned_to}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.status === 200) {
         let  toemails = response.data.to_emails.join(',')
          sendSetValue('toemails', toemails)
          setSendReportDialog(true)
        }
      }
      catch (error) {
        console.log(error);
      }
    }
  const onSendReport = (data) => {
    const taskIds = selectedTasksData.map(task => task._raw.id);
    let req =
    {
      "project_id": getSelectedTaskData()?._raw?.project,
      "employee_id": UserInfo.employee.id,
      "task_ids": taskIds,
      "comments": data.comments,
      cc_emails: data.ccemails,
    }
    try {
      axios.post(`${process.env.REACT_APP_Company_Contact}/custom-user/task-report/`, req, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setSendReportDialog(false)
      sendReset()
      setSelectedTasksData([])
      toast.current && toast.current.show({
        severity: 'success',
        summary: 'Success',
        detail: 'Report sent successfully'
      })
    } catch (error) {
      console.log(error);
    }
  }
  const getWorktypes = async (id, page, perPage) => {
    try {
      setTaskLoading(true)
      const params = {
        // is_archived: false,
        limit: perPage,
        offset: (page-1) * perPage,
        // ...(selectedCompanyid && { company_id: selectedCompanyid }),
      };
      const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/worktypes/?company_id=${selectedModule}&is_archived=false&project_id=${id}`, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      // dispatch(
      //   setPageData({
      //     first: first,
      //     rows: rows,
      //     totalRecords: response.data.count,
      //   })
      // )
      setTotalTasksCount(response.data.count)
      if (response.data) {
        setTaskLoading(false);
        let results = response.data.results;
        if (Array.isArray(results)) {
          const mapped = results.map(item => ({
            task_code: item.code || item.task_code || item.id,
            task_type: item.task_name || item.task_type || '',
            task_name: item.summary|| '',
            project_name: item.project_name || (item.project && item.project.name) || '',
            assigned_to: item.assigned_to_employee_name || item.assigned_to || (item.assigned_to && item.assigned_to.name) || null,
            assigned_by: item.assigned_by_employee_name || '',
            task_status: item.work_type_status_name || item.task_status || item.status || '',
            approval_status: item.approval_status_name || '',
            project_manager: item.project_manager_name || '',
            priority: item.priority || '',
            watchers: item.watchers?.map(w => w.name).join(", ") || '',
            work_hours: item.work_hours || '',
            start_date: item.start_date || '',
            end_date: item.end_date || '',
            // keep raw item for detail view
            _raw: item
          }))
          setTasksData(mapped)
        } else {
          if (Array.isArray(response.data)) {
            const mapped = response.data.map(item => ({
              task_code: item.code || item.task_code || item.id,
              task_type: item.work_type_name || item.task_type || '',
              task_name: item.summary || item.task_name || item.title || '',
              project_name: item.project_name || (item.project && item.project.name) || '',
              assigned_to: item.assigned_to_employee_name || item.assigned_to || (item.assigned_to && item.assigned_to.name) || null,
              task_status: item.work_type_status_name || item.task_status || item.status || '',
              assigned_by: item.assigned_by_employee_name || '',
              approval_status: item.approval_status_name || '',
              priority: item.priority || '',
              start_date: item.start_date || '',
              end_date: item.end_date || '',
              _raw: item
            }))
            setTasksData(mapped)
          } else {
            console.warn('Unexpected worktypes payload', response.data)
            setTaskLoading(false);
          }
        }
      }
    } catch (error) {
      console.error('Failed to load worktypes', error)

    }
  };

  const handleClearSearchJobs = () => {
    setFilters({
      job_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      job_title: { value: null, matchMode: FilterMatchMode.CONTAINS },
      job_status: { value: null, matchMode: FilterMatchMode.CONTAINS },
      openings: { value: null, matchMode: FilterMatchMode.CONTAINS },
      hiring_manager: { value: null, matchMode: FilterMatchMode.CONTAINS },
      company: { value: null, matchMode: FilterMatchMode.CONTAINS },
      job_location: { value: null, matchMode: FilterMatchMode.CONTAINS },
      workplace_type: { value: null, matchMode: FilterMatchMode.CONTAINS },
      job_type: { value: null, matchMode: FilterMatchMode.CONTAINS },
      primary_skills: { value: null, matchMode: FilterMatchMode.CONTAINS },
      experience_required: { value: null, matchMode: FilterMatchMode.CONTAINS },
      min_salary: { value: null, matchMode: FilterMatchMode.CONTAINS },
      max_salary: { value: null, matchMode: FilterMatchMode.CONTAINS },
      department: { value: null, matchMode: FilterMatchMode.CONTAINS },
      job_start_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
      job_end_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
      job_hiring_goal: { value: null, matchMode: FilterMatchMode.CONTAINS },
      job_function: { value: null, matchMode: FilterMatchMode.CONTAINS },
      seniority: { value: null, matchMode: FilterMatchMode.CONTAINS },
      category: { value: null, matchMode: FilterMatchMode.CONTAINS },
      group: { value: null, matchMode: FilterMatchMode.CONTAINS },
      create_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
      edit_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
      created_by: { value: null, matchMode: FilterMatchMode.CONTAINS },
    })
  }

  const dt = useRef(null)

  const [selectedJob, setSelectedJob] = useState(null) // State to track the right-clicked job

  const toast = useRef(null) // Reference for Toast notifications
  const cm = useRef(null) // Reference for ContextMenu
  const menuModel = [
    {
      label: "View",
      icon: "pi pi-fw pi-eye",
      command: () => {
        if (selectedJob) {
          viewJob(selectedJob) // Use viewJob function
        }
      }
    },
    {
      label: "Edit",
      icon: "pi pi-fw pi-pencil",
      command: () => {
        navigate(`/project-editform?id=${selectedJobsData[0]?.__raw?.id}`)
      },
    },
    { label: "Archive", icon: "pi pi-check-circle" },
    {
      label: "Delete",
      icon: "pi pi-fw pi-trash",
      command: () => handleDeleteProject(selectedJob?.__raw?.id),
    },
    {
      label: "Schedule",
      icon: "pi pi-calendar-clock",
      items: [
        // Subitems for "Schedule"
        // {
        //   label: "Interview",
        //   icon: "pi pi-calendar-plus",
        //   command: () => SetInterviewpop(true),
        // },
        {
          label: "Call",
          icon: "pi pi-phone",
          command: () => SetInterviewpopCall(true),
        },
        {
          label: "Meeting",
          icon: "pi pi-users",
          command: () => SetInterviewpopMeeting(true),
        },
        // {
        //   label: "Task",
        //   icon: "pi pi-list",
        //   command: () => SetInterviewpopTask(true),
        // },
        {
          label: "Event",
          icon: "pi pi-calendar-clock",
          command: () => SetInterviewpopEvent(true),
        },
        {
          label: "Other",
          icon: "pi pi-ellipsis-h",
          command: () => SetInterviewpopOther(true),
        },
      ],
    },
    {
      label: "More",
      icon: "pi pi-ellipsis-h",
      items: [
        // Subitems for "More"
        // {
        //   label: "Link Candidates",
        //   icon: "pi pi-link",
        //   items: [
        //     // Subitems for "More"
        //     { label: "Received", icon: "pi pi-link" },
        //     { label: "Potential", icon: "pi pi-sync" },
        //     { label: "Submitted", icon: "pi pi-link" },
        //   ],
        // },
        // { label: "Match Candidates", icon: "pi pi-sync" },
        { label: "Change Status", icon: "pi pi-link" },
        { label: "Attachments", icon: "pi pi-paperclip" },
      ],
    },
    { label: "Notes", icon: "pi pi-clipboard" },
    {
      label: "Add Work Type",
      icon: "pi pi-user",
      command: () => setShowWorkTypeSidebar(true)
    },
    {
      label: "Clear",
      icon: "pi pi-filter-slash",
      command: handleClearSearchJobs,
    },
  ]

  // Function to handle viewing a job
  const viewJob = job => {
    setSelectedProjectForView(job) // Store the selected project data
    setVisibleViewRight(true) // Open the view sidebar
    // toast.current.show({
    //   severity: "info",
    //   summary: "Project Selected",
    //   detail: job.job_title,
    // })
  }

  // Function to handle editing a job
  const editJob = job => {
    toast.current.show({
      severity: "success",
      summary: "Edit Job",
      detail: `Editing ${job.job_title}`,
    })
    // Add your edit logic here
  }

  // Function to handle deleting a job
  const deleteJob = job => {
    let _jobs = [...jobsData]
    _jobs = _jobs.filter(j => j.job_id !== job.job_id)
    setJobsData(_jobs) // Update the jobs data state
    toast.current.show({
      severity: "error",
      summary: "Job Deleted",
      detail: `Deleted ${job.job_title}`,
    })
  }

  // view page starts

  // view form pipeline starts

  const [receivedJobsFilters, setReceivedJobsFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    task_code: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    task_type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    project_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    project_manager: { value: null, matchMode: FilterMatchMode.CONTAINS },
    module_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    task_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    task_description: { value: null, matchMode: FilterMatchMode.CONTAINS },
    created_by: { value: null, matchMode: FilterMatchMode.CONTAINS },
    assigned_by: { value: null, matchMode: FilterMatchMode.CONTAINS },
    assigned_to: { value: null, matchMode: FilterMatchMode.CONTAINS },
    watchers: { value: null, matchMode: FilterMatchMode.CONTAINS },
    start_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    work_hours: { value: null, matchMode: FilterMatchMode.EQUALS },
    end_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    actual_end_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    task_status: { value: null, matchMode: FilterMatchMode.EQUALS },
    priority: { value: null, matchMode: FilterMatchMode.EQUALS },
    approval_status: { value: null, matchMode: FilterMatchMode.EQUALS },
  })
  const [receivedJobs, setreceivedJobs] = useState([])
  const [receivedJobsLength, setreceivedJobsLength] = useState([])
  const getWorkTypeLength = async (id) => {
    try {

      const response = await axios.get(
        `${process.env.REACT_APP_Company_Contact}/company/projects/?project_id=${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.status === 200) {
        setreceivedJobsLength(response.data.results)
      }
    } catch (err) {
      console.log(err);
    }
  };
  const availableColumns = [
    // { field: 'project_name', header: 'Project Name', minWidth: '10rem', },
    { field: 'task_code', header: 'Task Code', minWidth: '10rem', },
    { field: 'task_type', header: 'Task Name', minWidth: '12rem' },
    //  { field: 'task_code', header: 'Work Type Code', minWidth: '10rem', },
    // { field: 'task_type', header: 'Work Type', minWidth: '12rem' },
    // { field: 'module_name', header: 'Module Name', minWidth: '12rem' },
    { field: 'task_name', header: 'Summary', minWidth: '12rem' },
    { field: 'assigned_by', header: 'Assigned By', minWidth: '10rem' },
    { field: 'assigned_to', header: 'Assigned To', minWidth: '10rem' },
    // { field: 'created_by', header: 'Created By', minWidth: '10rem' },
    { field: 'project_manager', header: 'Project Manager', minWidth: '12rem' },
    { field: 'work_hours', header: 'Work Hours (in hours)', minWidth: '14rem' },
    { field: 'start_date', header: 'Start Date', minWidth: '10rem' },
    { field: 'end_date', header: 'End Date', minWidth: '10rem' },
    { field: 'actual_end_date', header: 'Actual End Date', minWidth: '12rem' },
    { field: 'watchers', header: 'Watchers', minWidth: '10rem' },
    { field: 'task_status', header: 'Status', minWidth: '10rem' },
    { field: 'approval_status', header: 'Approval Status', minWidth: '12rem' },
    { field: 'priority', header: 'Priority', minWidth: '10rem' },
  ]
  const getWorkType = async (id, statusId) => {
    try {

      const response = await axios.get(
        `${process.env.REACT_APP_Company_Contact}/company/projects/?project_id=${id}&work_type_status=${statusId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.status === 200) {
        const mappedData = response.data.results.map((wt) => ({
          task_code: wt?.code,
          task_type: wt?.work_type_name,
          project_name: `${wt?.name} (${wt?.code})`,
          project_manager: wt?.project_manager_name,
          delivery_manager: wt?.delivery_manager_name,
          module_name: wt?.module_name,
          task_name: wt?.summary,
          task_description: wt?.summary, // or use another field if available
          created_by: wt?.created_by_name, // depends if API gives creator
          assigned_by: wt?.assigned_by_name, // if backend sends it
          assigned_to: wt?.assigned_to_employee_name,
          watchers: wt?.watchers_names?.join(", "),// unless API provides watchers
          start_date: wt?.start_date,
          work_hours: wt?.work_hours || 0, // if API has planned/actual hours, map here
          end_date: wt?.end_date,
          actual_end_date: wt?.actual_end_date,
          task_status: wt?.work_type_status_name,
          priority: wt?.priority, // you might want to map "63" → "High/Medium/Low"
          approval_status: wt?.approval_status_name, // if your API has approval status, map here
        }));

        setreceivedJobs(mappedData);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (selectedJobsData[0]?.__raw?.id) {
      let id = selectedJobsData[0]?.__raw?.id
      getWorkType(id, statusId)
      getWorkTypeLength(id)
      GetTaskStatus(id, taskstatuspage, taskstatusperpage)
      GetModuleStatus(id, modulepage, modulesperpage)
      GetGroups(id,grouppage,groupperPage);
      GetApprovalStatus(id, approvalstatuspage, approvalstatusperpage)
      getNotes(id)
      getTeam(id)
      getEmployees(id,employeepage,employeeperPage)
      getStages(id,page,perPage)
      // getProjectPhases(id)
      getDocuments(id)
      getWorktypes(id,taskpage,tasksperpage)
    }
  }, [selectedJobsData[0]?.__raw?.id, apiStatus, statusId,])
  useEffect(() => {
    if (selectedJobsData[0]?.__raw?.id) {
      let id = selectedJobsData[0]?.__raw?.id
       getEmployees(id,employeepage,employeeperPage)
    }
  }, [isTeamAdded])
 
  const [selectedReceivedJobs, setSelectedReceivedJobs] = useState([])
  const [potentialJobsFilters, setPotentialJobsFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    task_status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    task_code: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    task_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    EstimatedWorkHours: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    start_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    end_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    project_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    assigned_to: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  })

  const potentialJobs = [
    {
      task_status: "Task",
      task_code: "Task-103",
      task_name: "Fix Login Timeout Bug",
      "Estimated Work Hours": "5",
      start_date: "02-05-2025",
      end_date: "03-05-2025",
      project_name: "Security Enhancement",
      assigned_to: "Vikram Joshi",
    },
    {
      task_status: "Bug",
      task_code: "Bug-104",
      task_name: "Integrate PF Calculation",
      "Estimated Work Hours": "10",
      start_date: "04-05-2025",
      end_date: "06-05-2025",
      project_name: "Payroll System",
      assigned_to: "Sanjay Mishra",
    },
  ]

  const [selectedPotentialJobs, setSelectedPotentialJobs] = useState([])
  const [rejectedJobsFilters, setRejectedJobsFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    task_status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    task_code: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    task_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    EstimatedWorkHours: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    start_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    end_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    project_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    assigned_to: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  })

  const rejectedJobs = [
    {
      task_status: "Task",
      task_code: "Task-105",
      task_name: "Connect with GSTN APIs",
      "Estimated Work Hours": "16",
      start_date: "03-05-2025",
      end_date: "07-05-2025",
      project_name: "Tax Compliance (Proj-105)",
      assigned_to: "Rajeev Menon",
    },
    {
      task_status: "Bug",
      task_code: "Bug-106",
      task_name: "Add Biometric Sync",
      "Estimated Work Hours": "6",
      start_date: "01-05-2025",
      end_date: "02-05-2025",
      project_name: "HR Automation (Proj-106)",
      assigned_to: "Nikhil Kapoor",
    },
  ]

  const [selectedRejectedJobs, setSelectedRejectedJobs] = useState([])

  // interview

  const [interviewJobsFilters, setInterviewJobsFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    task_status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    task_code: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    task_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    "Estimated Work Hours": {
      value: null,
      matchMode: FilterMatchMode.STARTS_WITH,
    },
    start_date: { value: null, matchMode: FilterMatchMode.DATE_IS },
    end_date: { value: null, matchMode: FilterMatchMode.DATE_IS },
    project_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    assigned_to: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  })

  const interviewJobs = [
    {
      task_status: "Task",
      task_code: "Task-105",
      task_name: "Connect with GSTN APIs",
      "Estimated Work Hours": "16",
      start_date: "03-05-2025",
      end_date: "07-05-2025",
      project_name: "Tax Compliance (Proj-105)",
      assigned_to: "Rajeev Menon",
    },
    {
      task_status: "Bug",
      task_code: "Bug-106",
      task_name: "Add Biometric Sync",
      "Estimated Work Hours": "6",
      start_date: "01-05-2025",
      end_date: "02-05-2025",
      project_name: "HR Automation (Proj-106)",
      assigned_to: "Nikhil Kapoor",
    },
  ]

  const [selectedInterviewJobs, setSelectedInterviewJobs] = useState([])

  // submitted start

  const [submittedJobsFilters, setSubmittedJobsFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    task_status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    task_code: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    task_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    "Estimated Work Hours": {
      value: null,
      matchMode: FilterMatchMode.STARTS_WITH,
    },
    start_date: { value: null, matchMode: FilterMatchMode.DATE_IS },
    end_date: { value: null, matchMode: FilterMatchMode.DATE_IS },
    project_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    assigned_to: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  })

  const submittedJobs = [
    {
      task_status: "Task",
      task_code: "Task-105",
      task_name: "Connect with GSTN APIs",
      "Estimated Work Hours": "16",
      start_date: "03-05-2025",
      end_date: "07-05-2025",
      project_name: "Tax Compliance (Proj-105)",
      assigned_to: "Rajeev Menon",
    },
    {
      task_status: "Bug",
      task_code: "Bug-106",
      task_name: "Add Biometric Sync",
      "Estimated Work Hours": "6",
      start_date: "01-05-2025",
      end_date: "02-05-2025",
      project_name: "HR Automation (Proj-106)",
      assigned_to: "Nikhil Kapoor",
    },
  ]

  const [selectedSubmittedJobs, setSelectedSubmittedJobs] = useState([])

  const [offerJobsFilters, setOfferJobsFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    task_status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    task_code: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    task_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    "Estimated Work Hours": {
      value: null,
      matchMode: FilterMatchMode.STARTS_WITH,
    },
    start_date: { value: null, matchMode: FilterMatchMode.DATE_IS },
    end_date: { value: null, matchMode: FilterMatchMode.DATE_IS },
    project_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    assigned_to: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  })

  const offerJobs = [
    {
      task_status: "Task",
      task_code: "Task-105",
      task_name: "Connect with GSTN APIs",
      "Estimated Work Hours": "16",
      start_date: "03-05-2025",
      end_date: "07-05-2025",
      project_name: "Tax Compliance (Proj-105)",
      assigned_to: "Rajeev Menon",
    },
    {
      task_status: "Bug",
      task_code: "Bug-106",
      task_name: "Add Biometric Sync",
      "Estimated Work Hours": "6",
      start_date: "01-05-2025",
      end_date: "02-05-2025",
      project_name: "HR Automation (Proj-106)",
      assigned_to: "Nikhil Kapoor",
    },
  ]

  const [selectedOfferJobs, setSelectedOfferJobs] = useState([])

  // placed start

  const [placedJobsFilters, setPlacedJobsFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    task_status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    task_code: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    task_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    "Estimated Work Hours": {
      value: null,
      matchMode: FilterMatchMode.STARTS_WITH,
    },
    start_date: { value: null, matchMode: FilterMatchMode.DATE_IS },
    end_date: { value: null, matchMode: FilterMatchMode.DATE_IS },
    project_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    assigned_to: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  })

  const placedJobs = [
    {
      task_status: "Task",
      task_code: "Task-105",
      task_name: "Connect with GSTN APIs",
      "Estimated Work Hours": "16",
      start_date: "03-05-2025",
      end_date: "07-05-2025",
      project_name: "Tax Compliance (Proj-105)",
      assigned_to: "Rajeev Menon",
    },
    {
      task_status: "Bug",
      task_code: "Bug-106",
      task_name: "Add Biometric Sync",
      "Estimated Work Hours": "6",
      start_date: "01-05-2025",
      end_date: "02-05-2025",
      project_name: "HR Automation (Proj-106)",
      assigned_to: "Nikhil Kapoor",
    },
  ]

  const [selectedPlacedJobs, setSelectedPlacedJobs] = useState([])

  // view form pipeline ends
  // view form activities starts

  const [activitiesFilters, setActivitiesFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    sub_type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    priority: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    subject: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    date_time: { value: null, matchMode: FilterMatchMode.DATE_IS },
    user_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  })

  const activities = [
    {
      type: "Technical",
      sub_type: "Software",
      priority: "High",
      subject: "Job Interview",
      date_time: "2025-01-01 10:00",
      user_id: "12345",
    },
    {
      type: "Technical",
      sub_type: "Project Management",
      priority: "Medium",
      subject: "Project Kickoff",
      date_time: "2024-12-05 09:00",
      user_id: "54321",
    },
    {
      type: "Technical",
      sub_type: "Data Analysis",
      priority: "Low",
      subject: "Data Review",
      date_time: "2025-01-15 14:00",
      user_id: "98765",
    },
    {
      type: "Non-Technical",
      sub_type: "Marketing",
      priority: "High",
      subject: "Strategy Discussion",
      date_time: "2025-02-01 11:00",
      user_id: "67890",
    },
    {
      type: "Non-Technical",
      sub_type: "Human Resources",
      priority: "Critical",
      subject: "Employee Review",
      date_time: "2025-03-01 13:00",
      user_id: "11223",
    },
  ]

  const [selectedActivities, setSelectedActivities] = useState([])
  const [isEditorVisible, setEditorVisible] = useState(false) // Manage editor visibility
  const [editorContent, setEditorContent] = useState("") // Manage editor content
  const [editIndex, setEditIndex] = useState(null)
  const [candidateNotes, setCandidateNotes] = useState([]) // Store notes in an array

  const handleAddNotes = () => {
    setEditorVisible(true); // Show the editor
    setEditorContent(''); // Clear any previous content
    setEditIndex(null); // Reset editIndex when adding a new note
  };
  const getNotes = async (id) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/projects/${id}/notes/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setCandidateNotes(response.data.data);
      }

    } catch (error) {
      console.error("Error fetching notes:", error);
    }
  };
  const handleSaveNotes = async () => {
    if (editorContent.trim()) {
      let Payload = {
        title: "Note",
        content: editorContent,
        is_important: true,
      };

      try {
        let response;

        if (editIndex?.id) {
          // If editing → PATCH
          response = await axios.put(
            `${process.env.REACT_APP_Company_Contact}/company/projects/${selectedJobsData[0]?.__raw?.id}/notes/${editIndex.id}/`,
            Payload,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          if (response.status === 200) {
            toast.current?.show({
              severity: "success",
              summary: "Updated",
              detail: "Note updated successfully",
            });
          }
        } else {
          // If new note → POST
          response = await axios.post(
            `${process.env.REACT_APP_Company_Contact}/company/projects/${selectedJobsData[0]?.__raw?.id}/notes/`,
            Payload,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          if (response.status === 201) {
            toast.current?.show({
              severity: "success",
              summary: "Added",
              detail: "Note added successfully",
            });
          }
        }

        if (response?.status === 200 || response?.status === 201) {
          getNotes(selectedJobsData[0]?.__raw?.id);
          setEditorVisible(false);
          setEditorContent("");
          setEditIndex(null);
        }
      } catch (error) {
        console.error("Error saving note:", error);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: "Failed to save note",
        });
      }
    }
  };

  const handleCancelNotes = () => {
    setEditorContent(''); // Clear editor content
    setEditIndex(null);
    setEditorVisible(false); // Hide the editor
  };
  const handleEditNote = async (index) => {
    setEditorVisible(true);
    setEditorContent(index.content);
    setEditIndex(index);
  };

  const handleDeleteNote = async (index) => {
    try {
      const response = await axios.delete(`${process.env.REACT_APP_Company_Contact}/company/contacts/${selectedJobsData[0]?.__raw?.id}/notes/${index}/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      if (response.status === 200) {
        toast.current && toast.current.show({
          severity: 'success',
          summary: 'Deleted',
          detail: 'Note deleted successfully'
        })
      }
      getNotes(selectedJobsData[0]?.__raw?.id);
    } catch (error) {
      console.error("Error deleting note:", error);
    }
  };

  // view form notes ends

  // view form history starts

  const [historyFilters, setHistoryFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    sub_type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    priority: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    subject: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    date_time: { value: null, matchMode: FilterMatchMode.DATE_IS },
    user_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  })

  const history = [
    {
      type: "Technical",
      sub_type: "Software",
      priority: "High",
      subject: "Job Interview",
      date_time: "2025-01-01 10:00",
      user_id: "12345",
    },
    {
      type: "Technical",
      sub_type: "Project Management",
      priority: "Medium",
      subject: "Project Kickoff",
      date_time: "2024-12-05 09:00",
      user_id: "54321",
    },
    {
      type: "Technical",
      sub_type: "Data Analysis",
      priority: "Low",
      subject: "Data Review",
      date_time: "2025-01-15 14:00",
      user_id: "98765",
    },
    {
      type: "Non-Technical",
      sub_type: "Marketing",
      priority: "High",
      subject: "Strategy Discussion",
      date_time: "2025-02-01 11:00",
      user_id: "67890",
    },
    {
      type: "Non-Technical",
      sub_type: "Human Resources",
      priority: "Critical",
      subject: "Employee Review",
      date_time: "2025-03-01 13:00",
      user_id: "11223",
    },
  ]

  const [selectedHistory, setSelectedHistory] = useState([])

  // view form history ends

  const [visibleViewRight, setVisibleViewRight] = useState(false)
  const [selectedProjectForView, setSelectedProjectForView] = useState(null)
  // State to store selected project data
  const [editingRow, setEditingRow] = useState(null)
  const [documents, setDocuments] = useState([])
  // const [documents, setDocuments] = useState([
  //   {
  //     key: "1",
  //     data: {
  //       id: "1",
  //       certificate_name: "Discovery / Initiation",
  //       docSubject: [
  //         "Project charter",
  //         "Goals & scope",
  //         "Stakeholder identification",
  //       ],
  //       created_at: "Jun 20 - July 15 2025",
  //       responsible: "BA Team",
  //     },
  //   },
  //   {
  //     key: "2",
  //     data: {
  //       id: "2",
  //       certificate_name: "Planning / Requirements",
  //       docSubject: [
  //         "Job Feedback Report for Lavankumar Kalvala - Web Developer",
  //       ],
  //       created_at: "May 20 - Jun 15 2025",
  //       responsible: "Development Team",
  //     },
  //   },
  // ])
  const getDocuments = async (id) => {
    try {
      const EditId = selectedJobsData[0]?.__raw?.id;
      const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/projects/${EditId}/documents/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        const apiData = response.data.data;
        setDocuments(apiData);
      }
    } catch (err) {
      console.log(err);

    }
  }
  const keyDeliverablesTemplate = rowData => {
    if (Array.isArray(rowData.docSubject)) {
      return (
        <div className="key-deliverables">
          {rowData.docSubject.map((item, index) => (
            <div key={index} className="deliverable-item">
              - {item}
            </div>
          ))}
        </div>
      )
    }
    return rowData.docSubject
  }

  const handleSave = (rowKey, field, value) => {
    setDocuments(prevDocuments =>
      prevDocuments.map(doc =>
        doc.key === rowKey
          ? { ...doc, data: { ...doc.data, [field]: value } }
          : doc
      )
    )
  }

  const editableTemplate = (rowData, field) => {
    return editingRow === rowData.key ? (
      <input
        type="text"
        value={rowData.data[field]}
        onChange={e => handleSave(rowData.key, field, e.target.value)}
        onBlur={() => setEditingRow(null)}
        className="p-2 border border-gray-300 rounded w-full"
      />
    ) : (
      <span>{rowData.data[field]}</span>
    )
  }

  // Action template for buttons
  const actionTemplate = rowData => {
    return (
      <div className="flex gap-2">
        <Button
          icon="pi pi-pencil"
          rounded
          outlined
          aria-label="Edit"
          className="document-btn"
          onClick={() => handleEdit(rowData.key)}
        />
        <Button
          icon="pi pi-trash"
          rounded
          outlined
          aria-label="Delete"
          className="document-btn"
          onClick={() => handleDelete(rowData.key)}
        />
      </div>
    )
  }

  // view page ends

  const [selectedSchedule, setSelectedSchedule] = useState(null)

  const actScheduleOptions = [
    {
      name: "Call",
      code: "SCH-CA",
      icon: "pi pi-phone",
      action: () => SetInterviewpopCall(true),
    },
    {
      name: "Meeting",
      code: "SCH-ME",
      icon: "pi pi-calendar",
      action: () => SetInterviewpopMeeting(true),
    },
    {
      name: "Event",
      code: "SCH-TA",
      icon: "pi pi-check-square",
      action: () => SetInterviewpopEvent(true),
    },

    {
      name: "Other",
      code: "SCH-OT",
      icon: "pi pi-ellipsis-h",
      action: () => SetInterviewpopOther(true),
    },
  ]

  const handleScheduleChange = e => {
    setSelectedSchedule(e.value)

    if (e.value && e.value.action) {
      e.value.action() // Execute the custom action
    }
  }

  const [selectedLinkJob, setSelectedLinkJob] = useState(null)
  const moreoptions = [
    {
      name: "Link Candidates",
      jobs: [
        {
          name: "Received",
          // onClick: () => { handleresend() }
        },
        {
          name: "Potential",
          // onClick: () => { handleresend() }
        },
        {
          name: "Submitted",
          onClick: () => {
            handleresend()
          },
        },
      ],
    },
    {
      name: "Change Status",
    },
    {
      name: "Attachments",
    },
    {
      name: "Delete",
    },
  ]

  // short form strats
  const [companyOptions, setCompanyOptions] = useState([]);
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [companyDropdownData, setCompanyDropdownData] = useState({});
  const [selectedWatchersids, setSelectedWatchersids] = useState([])

  const getEmployeesbyid = async (company) => {
    try {
      setapiLoader(true);
      const response = await axios.get(
        `${process.env.REACT_APP_Company_Contact}/company/employees/?company_id=${company}&is_active=true`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        setapiLoader(false);
        return Array.isArray(response.data?.results) ? response.data?.results : [];
      }
    } catch (err) {
      console.log(err);
      setapiLoader(true);
    }
  };
  const getSortedOptions = (companyId) => {
  const companyData = companyDropdownData[companyId];
  if (!companyData) return [];

  const selectedIds = companyData.selected || [];

  const options = Object.values(companyData).filter(
    item => item && typeof item === "object" && item.id
  );

  return [
    // selected first
    ...options.filter(opt => selectedIds.includes(opt.id)),
    // unselected later
    ...options.filter(opt => !selectedIds.includes(opt.id)),
  ];
};

  const handleCompanySelect = async (e, companyId) => {
    if (e.target.checked) {
      setSelectedCompanies(prev => [...prev, companyId]);
      const data = await getEmployeesbyid(companyId);
      setCompanyDropdownData(prev => ({
        ...prev,
        [companyId]: data
      }));
    } else {
      setSelectedCompanies(prev => prev.filter(id => id !== companyId));
      setCompanyDropdownData(prev => {
        const updated = { ...prev };
        delete updated[companyId];
        return updated;
      });
    }
  };
  const handleMultiSelectChange = (companyId, e) => {
    const selectedIds = e.value;

    setCompanyDropdownData(prev => {
      const updated = {
        ...prev,
        [companyId]: {
          ...prev[companyId],
          selected: selectedIds,
        }
      };

      // NOW updated has the latest values
      const finalPayload = Object.entries(updated).map(([id, data]) => ({
        company_id: Number(id),
        employee_ids: data.selected
      }));

      const allEmployeeIds = finalPayload.flatMap(item => item.employee_ids);

      setSelectedWatchersids(allEmployeeIds);
      return updated;
    });
  };
  // const companyOptions = [
  //   { name: "Varun Digital Media", code: "VDM" },
  //   { name: "Pranathi Software Services", code: "PSS" },
  //   { name: "Green Ventures pvt Ltd", code: "GV" },
  //   { name: "Future Tech Solutions", code: "FTS" },
  //   { name: "Healthify Solutions pvt Ltd", code: "MS" },
  // ]

  const [selectedPerson, setSelectedPerson] = useState(null)

  const personOptions = [
    { name: "Mahesh Kumar Bhoga", role: "UI/UX Manager", code: "HR" },
    { name: "Giri Jalagam", role: "Hr Recruiter", code: "MGR" },
    { name: "Salmanuddin", role: "Sales Manager", code: "TL" },
    { name: "Suresh Reddy", role: "SEO Manager", code: "CEO" },
    { name: "Aman Kumar", role: "AIML Lead", code: "INT" },
  ]

  const [skillsOptions, setSkillsOptions] = useState([
    { value: "HTML", label: "HTML" },
    { value: "CSS", label: "CSS" },
    { value: "Java Script", label: "Java Script" },
    { value: "java", label: "Java" },
    { value: "react", label: "React" },
    { value: "nodejs", label: "Node.js" },
    // Add more skill options as needed
  ])

  const [selectedPrimarySkills, setSelectedPrimarySkills] = useState([])
  // Handle Primary Skills Selection
  const handlePrimarySkillsChange = selectedOptions => {
    setSelectedPrimarySkills(
      selectedOptions ? selectedOptions.map(option => option.value) : []
    )
  }

  const [categories, setCategories] = useState([])

  const [selectedCategoryKey, setSelectedCategoryKey] = useState(null)

  //groups
  const [groups, setgroups] = useState([])
  // const [groups] = useState([
  //   {
  //     key: "0",
  //     label: "Project Domain",
  //     children: [
  //       { key: "0-0-0", label: "AI ML" },
  //       { key: "0-0-1", label: "AI Phone" },
  //       { key: "0-0-2", label: "Digital Marketing" },
  //       { key: "0-0-3", label: "Ecommerce" },
  //       { key: "0-0-4", label: "Others" },
  //       // {
  //       //   key: "0-0",
  //       //   label: "Frontend",
  //       //   children: [
  //       //     { key: "0-0-0", label: "React" },
  //       //     { key: "0-0-1", label: "Angular" },
  //       //     { key: "0-0-2", label: "Bootstrap" },
  //       //   ],
  //       // },
  //       // {
  //       //   key: "0-1",
  //       //   label: "Backend",
  //       //   children: [
  //       //     { key: "0-1-0", label: "Python" },
  //       //     { key: "0-1-1", label: "Java" },
  //       //     { key: "0-1-2", label: "C#" },
  //       //   ],
  //       // },
  //       // {
  //       //   key: "0-2",
  //       //   label: "QA",
  //       //   children: [
  //       //     { key: "0-2-0", label: "Manual" },
  //       //     { key: "0-2-1", label: "Automation" },
  //       //   ],
  //       // },
  //     ],
  //   },
  // ])



  // Shared dynamic lookup modal state (used for Groups, Status, etc.)
  const lookupAddSentinel = 'add'
  const lookupEditSentinel = 'edit'
  const [lookupModalVisible, setLookupModalVisible] = useState(false)
  const [lookupModalContext, setLookupModalContext] = useState('') // e.g., 'project_groups' or 'project_status'
  const [lookupFormValue, setLookupFormValue] = useState('')
  const [editingLookup, setEditingLookup] = useState(false)
  const [lastSelectedLookupId, setLastSelectedLookupId] = useState(null)
  const [importCsvIcons, setImportCsvIcons] = useState(false)

  const exportCSVBtn = selectionOnly => {
    dt.current.exportCSV({ selectionOnly })
  }

  const exportPdfBtn = () => {
    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default("landscape") // Use landscape for better width

        const exportColumns = columns.map(col => col.header) // Headers
        const exportData = jobsData.map(
          row => columns.map(col => row[col.field] ?? "-") // Replace undefined/null with '-'
        )

        doc.autoTable({
          head: [exportColumns], // Column headers
          body: exportData, // Data rows
          startY: 20, // Adjust table position
          styles: { fontSize: 8, cellPadding: 2 }, // Adjust text size for better fit
          theme: "grid", // Add grid lines
          margin: { top: 10, left: 5, right: 5 }, // Adjust margins
          columnStyles: { 0: { cellWidth: 30 } }, // Set width for the first column
        })

        doc.save("jobs_data.pdf")
      })
    })
  }

  const exportExcelBtn = () => {
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(jobsData)
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] }
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      })
      saveAsExcelFile(excelBuffer, "jobs_data")
    })
  }

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then(module => {
      if (module && module.default) {
        const EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
        const EXCEL_EXTENSION = ".xlsx"
        const data = new Blob([buffer], { type: EXCEL_TYPE })

        module.default.saveAs(
          data,
          `${fileName}_export_${new Date().getTime()}${EXCEL_EXTENSION}`
        )
      }
    })
  }

  const columns = [
    { field: "job_id", header: "Project Code" },
    { field: "job_title", header: "Project Name" },
    { field: "job_status", header: "Job Status" },
    { field: "openings", header: "Openings" },
    { field: "hiring_manager", header: "Hiring Manager" },
    { field: "company", header: "Company" },
    { field: "job_location", header: "Location" },
    { field: "workplace_type", header: "Workplace Type" },
    { field: "job_type", header: "Job Type" },
    { field: "primary_skills", header: "Primary Skills" },
    { field: "experience_required", header: "Experience Required" },
    { field: "min_salary", header: "Min Salary" },
    { field: "max_salary", header: "Max Salary" },
    { field: "department", header: "Department" },
    { field: "job_start_date", header: "Start Date" },
    { field: "job_end_date", header: "End Date" },
    { field: "job_hiring_goal", header: "Hiring Goal" },
    { field: "job_function", header: "Function" },
    { field: "seniority", header: "Seniority" },
    { field: "category", header: "Category" },
    { field: "group", header: "Group" },
    { field: "create_date", header: "Create Date" },
    { field: "edit_date", header: "Edit Date" },
    { field: "created_by", header: "Created By" },
  ]

  const headerBtn = (
    <div className="flex align-items-center justify-content-end gap-1 actionitem-import">
      <Button
        className="csvbtn p-button"
        icon="pi pi-file"
        rounded
        onClick={() => exportCSVBtn(false)}
        data-pr-tooltip="CSV"
      />
      <Button
        className="xlsbtn p-button"
        icon="pi pi-file-excel"
        severity="success"
        rounded
        onClick={exportExcelBtn}
        data-pr-tooltip="XLS"
      />
      <Button
        className="pdfbtn p-button me-2"
        icon="pi pi-file-pdf"
        severity="warning"
        rounded
        onClick={exportPdfBtn}
        data-pr-tooltip="PDF"
      />
    </div>
  )

  // Export end

  // interview popup starts
  const [interviewpop, SetInterviewpop] = useState(false)
  const [interviewpopCall, SetInterviewpopCall] = useState(false)
  const [interviewpopMeeting, SetInterviewpopMeeting] = useState(false)
  const [interviewpopTask, SetInterviewpopTask] = useState(false)
  const [interviewpopEvent, SetInterviewpopEvent] = useState(false)
  const [interviewpopOther, SetInterviewpopOther] = useState(false)

  const [intertype, setintertype] = useState("Interview")
  const [intertype1, setintertype1] = useState("Task")
  const [intertype2, setintertype2] = useState("Meeting")
  const [intertype3, setintertype3] = useState("Call")
  const [intertype4, setintertype4] = useState("Event")
  const [intertype5, setintertype5] = useState("Other")

  const [subtype, setSubtype] = useState(null)
  const [subtypeget, setsubtypeget] = useState(null)
  const [startdate, setStartdate] = useState(() => {
    return new Date(2025, 6, 25);
  })
  const [starttime, setStarttime] = useState(() => {
    const nowstart = new Date();
    nowstart.setHours(14, 30, 0, 0);
    return nowstart;
  })
  // const [endtime, setendtime] = useState(null)
  const [endtime, setendtime] = useState(() => {
    // Set default to today at 15:30 (3:30 PM)
    const now = new Date();
    now.setHours(15, 30, 0, 0);
    return now;
  });

  const [enddate, setenddate] = useState(() => {
    return new Date(2025, 6, 25);
  })
  const [popTextares, setPopTextares] = useState("")
  const [priority, setPriority] = useState(null)
  const [prioritycontact, setprioritycontact] = useState(null)
  const [condidatevalu, setcondidatevalu] = useState([])

  const typeInterview = [
    { name: "Screening Interviews", value: "SI" },
    { name: "One-on-One Interviews", value: "OOI" },
    { name: "Technical Interviews", value: "TI" },
    { name: "Final Round Interviews ", value: "FRI" },
    { name: "Video/Virtual Interviews", value: "VVI" },
  ]
  const typeCall = [
    { name: "Initial Screening Calls", value: "ISC" },
    { name: "Technical Assessment Calls", value: "TAC" },
    { name: "Behavioral Interview Calls ", value: "BIC" },
    { name: "Hiring Manager Calls", value: "HMC" },
    { name: "HR/Benefits Discussion Calls", value: "HRBDC" },
    { name: "Reference Check Calls", value: "RCC" },
    { name: "Panel Interview Calls", value: "PIC" },
    { name: "Follow-up Calls ", value: "FC" },
    { name: "Offer Discussion Calls ", value: "ODC" },
    { name: "Onboarding Coordination Calls", value: "OCC" },
    { name: "Status Update Calls", value: "SUC" },
    { name: "Candidate Feedback Calls", value: "CFC" },
  ]

  const typeMeeting = [
    { name: "Planning Meetings", value: "PM" },
    { name: "Job Requirements Meetings", value: "JRM" },
    { name: "Recruitment Team Sync-ups", value: "RTS" },
    { name: "Hiring Committee Meetings", value: "HCM" },
    { name: "Interview Panel Briefings", value: "IPB" },
    { name: "Candidate Feedback Meetings", value: "CFM" },
    { name: "Selection Meetings", value: "SM" },
    { name: "Budget Meetings", value: "BM" },
    { name: "Stakeholder Updates", value: "SU" },
    { name: "Recruitment Vendor Meetings", value: "RVM" },
    { name: "Onboarding Planning Meetings", value: "OPM" },
    { name: "Process Improvement Meetings", value: "PIM" },
    { name: "Training Meetings", value: "TM" },
    { name: "Compliance Meetings", value: "CM" },
  ]

  const jobStatusDrop = [
    { name: "Open", value: "Open" },
    { name: "Closed", value: "Closed" },
    { name: "On Hold", value: "On Hold" },
  ]

  const typeInterview1 = [
    { name: "Inperson", value: "low" },
    { name: "Audio", value: "medium" },
    { name: "Video", value: "high" },
  ]

  const priorityValue = [
    { name: "Low", value: "low" },
    { name: "Medium", value: "medium" },
    { name: "High", value: "high" },
  ]
  const [reminder, setReminder] = useState(null)
  const reminderOptions = [
    { name: "0 mins", value: "0 mins" },
    { name: "5 mins", value: "5 mins" },
    { name: "10 mins", value: "10 mins" },
    { name: "15 mins", value: "15 mins" },
    { name: "30 mins", value: "30 mins" },
  ]
  const [repeat, setRepeat] = useState(null)
  const repeatOptions = [
    { name: "Do not repeat", value: "none" },
    { name: "Daily", value: "daily" },
    { name: "Weekly", value: "weekly" },
    { name: "Mon-Fri", value: "mon-fri" },
  ]

  const [followup, setFollowup] = useState(null)

  // Dropdown options
  const followupOptions = [
    { name: "None", value: "none" },
    { name: "1 Day", value: "1 Day" },
    { name: "2 Days", value: "2 Day" },
    { name: "3 Days", value: "3 Day" },
  ]

  const [typeInterviewcondi, settypeInterviewcondi] = useState([])
  const [subjectval, setsubjectval] = useState(null)
  const [popchecked2, setPopchecked2] = useState(false)
  const handlePopupCheckbox2 = e => {
    setPopchecked2(e.checked)
  }


  const [PrivetDropdownValues, setPrivetDropdownValues] = useState([]);

  const getPrivateOptions = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/private-users/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data) {
        let results = response.data.data;
        const options = results.map((category) => ({
          name: category.name
            .replace(/_/g, ' ')
            .replace(/\b\w/g, (char) => char.toUpperCase()),
          code: category.id,
          email: category.email,
        }));
        setPrivetDropdownValues(options);
      }
    } catch (error) {

    }
  };
  // useEffect(() => {
  //   getPrivateOptions();
  // }, []);
  const typeInterviewcontact = [
    { name: "harish", value: "Harish" },
    { name: "giri", value: "Giri" },
    { name: "pavan", value: "Pavan" },
  ]

  const typeInterviewval = [
    { name: "Open", value: "Open" },
    { name: "Closed", value: "1 Day" },
    { name: "On Hold", value: "2 Day" },
    // { name: '3 Days', value: '3 Day' },
  ]

  const [userid, setUserid] = useState(['Harish'])
  const customChip = item => {
    return (
      <div>
        <span>{item}</span>
        {/* <i className="pi pi-user-plus"></i> */}
      </div>
    )
  }
  const [popchecked, setPopchecked] = useState(true)


  const handlePopupCheckbox = e => {
    setPopchecked(e.checked)
  }

  const [jobid, setJobid] = useState("Proj-101")
  const [jobtitle, setJobtitle] = useState("")
  const [expyears, setExpyears] = useState("3 Years")
  const [userids, setUserids] = useState("Harish")
  const [hiringmanager1, setHiringManager1] = useState("Mahesh Kumar Bhoga")
  const [jobloc, setJobloc] = useState("Hyderabad")
  const [workplace, setWorkplace] = useState("Work From Office")
  const [jobstart, setJobstart] = useState("01-01-2025")
  const [projectDateRange, setProjectDateRange] = useState(null)
  const [jobend, setJobend] = useState("31-12-2025")
  const [primskills, setPrimskills] = useState("HTML, CSS, Javascript")
  const [categ, setCateg] = useState("Frontend")
  const [group, setGroup] = useState("HTML, CSS, Javascript")
  const [description1, setDescription1] = useState()

  const [notes1, setNotes1] = useState(
    "An AI-powered content generator that transforms user input into high-quality, context-aware content using advanced artificial intelligence models. Whether you need engaging blog posts, marketing copy, social media content, product descriptions, or creative storytelling, this tool uses state-of-the-art language models to instantly craft tailored results based on your instructions."
  )

  const [privateDrop, setPrivateDrop] = useState()
  const [selectedModule, setSelectedModule] = useState(null)
  const [moduleWorkTypes, setModuleWorkTypes] = useState([])
  const getCompanyData = async () => {
    try {
      const response = await getCompanies();

      if (response && response.results) {
        // Transform company data to match the expected format
        const transformedCompanies = response.results.map((company, index) => ({
          name: company.name || company.company_name,
          color: "#000000",
          id: String(company.id || `company-${index}`), // Ensure ID is always a string
          statuses: ["Pending", "Processing", "Completed"],
          // Store original company data for reference
          __original: company
        }));
        const parentCompany = response.results.find(
          (c) => c.is_parent_company === true
        );
        setModuleWorkTypes(transformedCompanies);
        setSelectedModule(parentCompany ? String(parentCompany.id) : null);
        setCompanyOptions(transformedCompanies);
        // getallactivejobs(parentCompany ? String(parentCompany.id) : null);
      }
    } catch (error) {
      console.error("Error fetching companies:", error);
      // Keep the existing hardcoded companies as fallback
    }
  };
  useEffect(() => {
    getCompanyData();
  }, []);
  const moduleDropdownWorkTypes = [
    ...moduleWorkTypes,
    { id: "divider", disabled: true },
    { name: "Add Company", id: "create-new-work-type" },
    { name: "Edit Company", id: "edit-selected-work-type" },
  ]

  const handleModuleWorkTypesChange = updatedWorkTypes => {
    setModuleWorkTypes(updatedWorkTypes)
  }

  const handleModuleSelectionChange = selectedWorkType => {
    setSelectedModule(selectedWorkType)
  }

  // Company work type end


  // Project Manager start

  const [projectManagerWorkTypes, setProjectManagerWorkTypes] = useState([])
  const [DeliveryManagerOptions, setDeliveryManagerOptions] = useState(null)
  const projectManagerDropdownWorkTypes = [
    ...projectManagerWorkTypes,
    { id: "divider", disabled: true },
    { name: "Add Project Manager", id: "create-new-pm" },
    { name: "Edit Project Manager", id: "edit-selected-pm" },
  ]

  const handleProjectManagerWorkTypesChange = updatedWorkTypes => {
    setProjectManagerWorkTypes(updatedWorkTypes)
  }

  const [selectedProjectManager, setSelectedProjectManager] = useState(null)
  const [ProjectManagerOptions, setProjectManagerOptions] = useState([])
  const handleProjectManagerSelectionChange = selectedWorkType => {
    setSelectedProjectManager(selectedWorkType)
  }
  const getProjectManager = async (id) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Company_Contact}/company/employees/?designation__name=Project Manager&company=${selectedCompany}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.status === 200) {
        const apiData = response.data.results;

        setProjectManagerOptions(
          apiData.map((item) => ({
            name: item.full_name,
            id: item.id,
            email: item.primary_email,
          }))
        );
      }
    } catch (err) {
      console.error("Error fetching team data:", err);
    }
  };
  const getWorkTypeStatus = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Company_Contact}/company/lookups/?name=work_type_status`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        setWorkTypeStatus(response.data?.results?.results);
      }
    } catch (err) {
      console.error("Failed to load modules:", err);
    }
  };
  // useEffect(() => {
  //   getWorkTypeStatus();
  // }, []);
  // Project Manager end


  // status work type start

  const [moduleWorkTypes1, setModuleWorkTypes1] = useState([
    {
      name: "Open",
      color: "#000000",
      id: "custom-task1",
      statuses: ["Pending", "Processing", "Completed"],
    },
    {
      name: "In Progress",
      color: "#000000",
      id: "custom-task2",
      statuses: ["Pending", "Processing", "Completed"],
    },
    {
      name: "Under Review",
      color: "#000000",
      id: "custom-task",
      statuses: ["Pending", "Processing", "Completed"],
    },
    {
      name: "Approved",
      color: "#000000",
      id: "custom-task",
      statuses: ["Pending", "Processing", "Completed"],
    },
    {
      name: "On Hold",
      color: "#000000",
      id: "custom-task",
      statuses: ["Pending", "Processing", "Completed"],
    },
    {
      name: "Done",
      color: "#000000",
      id: "custom-task",
      statuses: ["Pending", "Processing", "Completed"],
    },
    {
      name: "Cancelled",
      color: "#000000",
      id: "custom-task",
      statuses: ["Pending", "Processing", "Completed"],
    },
  ])

  const moduleDropdownWorkTypes1 = [
    ...moduleWorkTypes1,
    { id: "divider", disabled: true },
    { name: "Add Status", id: "create-new-work-type" },
    { name: "Edit Status", id: "edit-selected-work-type" },
  ]



  // status work type end


  // subtype worktype  start


  const [statusWorkTypes1, setStatusWorkTypes1] = useState([
    {
      name: 'Introductory Call',
      color: '#000000',
      id: 'custom-task',
      statuses: ['Pending', 'Processing', 'Completed']
    },
    {
      name: 'Requirement Discussion',
      color: '#000000',
      id: 'in-active',
      statuses: ['Pending', 'Processing', 'Completed']
    },
    {
      name: 'Daily Stand-up',
      color: '#000000',
      id: 'dnd',
      statuses: ['Pending', 'Processing', 'Completed']
    },
    {
      name: 'Client Meeting',
      color: '#000000',
      id: 'custom-task',
      statuses: ['Pending', 'Processing', 'Completed']
    },
    {
      name: 'Feedback Session',
      color: '#000000',
      id: 'in-active',
      statuses: ['Pending', 'Processing', 'Completed']
    },
    {
      name: 'Follow-up Call',
      color: '#000000',
      id: 'dnd',
      statuses: ['Pending', 'Processing', 'Completed']
    },
    {
      name: 'Training Session',
      color: '#000000',
      id: 'dnd',
      statuses: ['Pending', 'Processing', 'Completed']
    },
  ]);


  const statusDropdownWorkTypes1 = [
    ...statusWorkTypes1,
    { id: 'divider', disabled: true },
    { name: 'Add Subtype', id: 'create-new-work-type' },
    { name: 'Edit Subtype', id: 'edit-selected-work-type' }
  ];

  const handleStatusWorkTypesChange1 = (updatedWorkTypes) => {
    setStatusWorkTypes1(updatedWorkTypes);
  };

  const handleStatusSelectionChange1 = (selectedWorkType) => {
    setSelectedProjectStatus(selectedWorkType);
  };

  // subtype worktype  end


  // Project status  start

  const [statusWorkTypes, setStatusWorkTypes] = useState([]);
  const statusDropdownWorkTypes = [
    ...statusWorkTypes,
    { id: 'divider', disabled: true },
    { name: 'Add Status', id: 'create-new-work-type' },
    { name: 'Edit Status', id: 'edit-selected-work-type' }
  ];

  const handleStatusWorkTypesChange = (updatedWorkTypes) => {
    setStatusWorkTypes(updatedWorkTypes);
  };

  const handleStatusSelectionChange = (selectedWorkType) => {
    // WorkType1 sends objects with an `id` property. We detect the reserved ids used in dropdownWorkTypes.
    if (!selectedWorkType) return setSelectedProjectStatus(selectedWorkType)
    const id = selectedWorkType.id || selectedWorkType;
    if (id === 'create-new-work-type') {
      setEditingLookup(false)
      setLookupFormValue('')
      setLookupModalContext('project_status')
      setLookupModalVisible(true)
      return
    }
    if (id === 'edit-selected-work-type') {
      // Use lastSelectedLookupId to prefill — ensure it's set from normal status selection elsewhere
      const selected = statusWorkTypes.find(s => s.id === lastSelectedLookupId)
      setEditingLookup(true)
      setLookupFormValue(selected ? selected.name : '')
      setLookupModalContext('project_status')
      setLookupModalVisible(true)
      return
    }
    // standard selection
    setLastSelectedLookupId(id)
    setSelectedProjectStatus(selectedWorkType)
  };
  const [selecteddropoptions, setselecteddropoptions] = useState(null)
  const [selectedEditdrop, setSelectedEditdrop] = useState(null)

  useEffect(() => {
    if (lookupModalContext === 'project_status') {
      setselecteddropoptions((statusWorkTypes || []).map(d => ({ id: d.id ?? d.code ?? d.value, name: d.value || d.name || d.label || String(d.id), code: d.code, raw: d })));
    } else if (lookupModalContext === 'project_groups') {
      setselecteddropoptions((groups || []).map(d => ({ id: d.id ?? d.code ?? d.value, value: d.value || d.name || d.label || String(d.id), code: d.code, raw: d })));
    } else {
      setselecteddropoptions([])
    }
  }, [lookupModalContext, categories, groups])
  // project status worktype  end

  // Watch for company changes and fetch project managers
  useEffect(() => {
    if (selectedProjectManagerCompany) {
      const companyId = selectedProjectManagerCompany.id || selectedProjectManagerCompany.value || selectedProjectManagerCompany;
      getProjectManagersByCompany(companyId);
    } else {
      setProjectManagerWorkTypes([]);
      setSelectedProjectManager(null);
    }
  }, [selectedProjectManagerCompany])
  const [submitloader,setsubmitloader] = useState(false)
  const handleDeleteProject = async (id) => {
    setsubmitloader(true)
    try {
      const response = await axios.delete(`${process.env.REACT_APP_Company_Contact}/company/projects/${id}/?type=hard`, {
        headers: { Authorization: `Bearer ${token}` },
      }
      );
      if (response.status === 200 || response.status === 204) {
        toast.current?.show({
          severity: "success",
          summary: "Deleted",
          detail: "Project Deleted successfully",
        });
        setSelectedJobsData([]);
        getallactivejobs(selectedModule)
        dispatch({ type: NOTIFICATION_API_STATUS_TRUE })
        setTimeout(() => {
        dispatch({ type: NOTIFICATION_API_STATUS_FALSE })
        }, 2000)
        setsubmitloader(false)
      }

    } catch (err) {
      console.log(err);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: err.response?.data?.message || "Failed to delete project",
        });
        setsubmitloader(false)

    }
  }
  const handleArchiveProject = (id) => {
    if (selectedJobsData && selectedJobsData.length > 0) {
      selectedJobsData.forEach(async (element) => {
        // Call the archive API for each selected employee
        try {
          const response = await axios.patch(`${process.env.REACT_APP_Company_Contact}/company/projects/${id}/`, { is_archived: true }, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          if (response.status === 200) {
            toast.current.show({ severity: 'success', summary: 'Success', detail: `Project archived successfully` });
            // getAllActive(pageState.page, pageState.rows);
            setSelectedJobsData([]);
            getallactivejobs(selectedModule)
          }
        } catch (error) {
          console.error(`Error archiving project ${element.id}:`, error);
        }
      });
    }
  }
  useEffect(() => {
    if (selectedModule) {
      getallactivejobs(selectedModule)
    }
  }, [selectedModule, first, rows])
  useEffect(() => {
    if (apiStatus === true) {
      setSelectedJobsData([])
      getallactivejobs(selectedModule)
    }
  }, [apiStatus])
  const getDocumentTypes = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/lookups/?name=work_type_document`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      if (response.status === 200) {
        const results = response.data?.results?.results || response.data?.results || [];
        const mapped = results.map((item) => ({
          id: item.id,
          name: (item.value || '').replace(/_/g, ' ').replace(/\b\w/g, (ch) => ch.toUpperCase())
        }));
        setDocumentTypes(mapped);
      }
    } catch (err) {
      console.error('Failed to load document types', err);
    }
  }

  const handleAddDocument = async () => {
    if (!selectedDocument || !subject) {
      toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Please fill all the fields.' });
      return;
    }

    try {
      const formData = new FormData();
      const workTypeId = selectedJobsData[0]?.id;

      // Document type and description
      formData.append('type', selectedDocument);
      formData.append('description', subject);

      // Append uploaded files
      if (uploadedFiles && uploadedFiles.length > 0) {
        uploadedFiles.forEach((file) => {
          formData.append('uploaded_files', file);
        });
      }

      // Send request
      const response = await axios.post(
        `${process.env.REACT_APP_Company_Contact}/company/projects/${workTypeId}/documents/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        }
      );

      if (response.status === 201 || response.status === 200) {
        // Reload documents and reset state
        getDocuments(workTypeId);
        setDisplayDialog(false);
        setSelectedDocument(null);
        setSubject('');
        setUploadedFiles([]);
        toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Document added successfully' });
      }

    } catch (err) {
      console.error('Failed to upload document', err);
      toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Failed to upload document' });
    }
  };

  const [FileNames, setFileNames] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedDocId, setSelectedDocId] = useState(null);
  const handleEdit = (doc) => {
    setDisplayDialog(true);
    setSelectedDocId(doc.id);
    setIsEdit(true);
    setSubject(doc.description);
    setSelectedDocument(doc.type);
    const LastFiles = Array.isArray(doc.files)
      ? doc.files.map((fileItem, index) => ({
        id: `${doc.id}-${index}`,
        selectedId: fileItem.id,
        name: fileItem.original_filename,
        url: fileItem.file,
      }))
      : doc.files
        ? [{ id: doc.id, name: doc.files.original_filename, url: doc.files.file }]
        : [];

    setFileNames(LastFiles);
  };

  const EditId = selectedJobsData[0]?.__raw?.id;

  const handleDelete = async (rowKey) => {

    try {
      const response = await axios.delete(`${process.env.REACT_APP_Company_Contact}/company/projects/${EditId}/documents/${rowKey}/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        getDocuments()
        toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Document deleted successfully', life: 3000 });
      }
    } catch (err) {
      console.log(err);

    }
  }
  const handleUpdateDocument = async () => {
    if (!selectedDocument || !subject) {
      alert('Please fill all the fields.');
      return;
    }

    try {
      const EditId = selectedJobsData[0]?.__raw?.id

      const formData = new FormData();

      // Document type
      const docTypeObj = documentTypes.find(dt => dt.id === selectedDocument);
      const docTypeName = docTypeObj ? docTypeObj.name : selectedDocument;
      formData.append('type', selectedDocument);
      formData.append('description', subject);

      // Append newly uploaded files
      if (uploadedFiles && uploadedFiles.length > 0) {
        uploadedFiles.forEach((file) => {
          formData.append('uploaded_files', file);
        });
      }
      if (FileNames && FileNames.length > 0) {
        FileNames.forEach((file) => {
          formData.append('files_to_keep', file.selectedId);
        });
      }

      const response = await axios.patch(
        `${process.env.REACT_APP_Company_Contact}/company/projects/${EditId}/documents/${selectedDocId}/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      if (response.status == 200 || response.status == 201) {
        getDocuments();
        setDisplayDialog(false);
        setSelectedDocument(null);
        setSubject('');
        setFileNames([]);
        setUploadedFiles([]);
        setIsEdit(false);
      }

      toast.current?.show({ severity: 'success', summary: 'Updated', detail: 'Document updated' });

    } catch (err) {
      console.error('Failed to update document', err);
      alert('Failed to update document');
    }
  };
  const [TaskeditId, setTaskeditId] = useState(null);
  const [ModuleeditId, setModuleeditId] = useState(null);
  const onSubmitTaskStatus = async (data) => {
    try {
      const projectId = selectedJobsData[0]?.__raw?.id;

      const payload = {
        name: data.statusName,
        project: projectId,
        description: data.description,
        colour: data.color?.startsWith('#') ? data.color : `#${data.color}`
      };

      const url = TaskeditId
        ? `${process.env.REACT_APP_Company_Contact}/company/task-status/${TaskeditId}/`
        : `${process.env.REACT_APP_Company_Contact}/company/task-status/`;

      const method = TaskeditId ? "patch" : "post";

      const response = await axios({
        method,
        url,
        data: payload,
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.status === 200 || response.status === 201) {
        GetTaskStatus(projectId, taskstatuspage, taskstatusperpage);
        setShowStatuspopup(false);
        resetTaskForm();
        setTaskeditId(null);
        toast.current?.show({
          severity: "success",
          summary: TaskeditId ? "Updated" : "Added",
          detail: TaskeditId
            ? "Task Status updated successfully"
            : "Task Status added successfully",
        });
      }
    } catch (error) {
      console.error("Error submitting task status:", error);
       toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: error?.response?.data?.error || "Failed to submit task status",
        });
    }

  };

  const onSubmitApprovalStatus = async (data) => {
    try {
      const projectId = selectedJobsData[0]?.__raw?.id;

      const payload = {
        name: data.statusName,
        project: projectId,
        description: data.description,
        colour: data.color?.startsWith('#') ? data.color : `#${data.color}`
      };

      const url = ApprovalStatusid
        ? `${process.env.REACT_APP_Company_Contact}/company/approval-status/${ApprovalStatusid}/`
        : `${process.env.REACT_APP_Company_Contact}/company/approval-status/`;

      const method = ApprovalStatusid ? "patch" : "post";

      const response = await axios({
        method,
        url,
        data: payload,
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.status === 200 || response.status === 201) {
        GetApprovalStatus(projectId, approvalstatuspage, approvalstatusperpage)
        setShowApprovalStatuspopup(false);
        resetApprovalForm();
        setApprovalStatusid(null);
        toast.current?.show({
          severity: "success",
          summary: ApprovalStatusid ? "Updated" : "Added",
          detail: ApprovalStatusid
            ? "Approval Status updated successfully"
            : "Approval Status added successfully",
        });
      }
    } catch (error) {
      console.error("Error submitting approval status:", error);
      toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: error?.response?.data?.error || "Failed to submit approval status",
        });
    }

  };
  const onSubmitModuleStatus = async (data) => {
    try {
      const projectId = selectedJobsData[0]?.__raw?.id;

      const payload = {
        name: data.statusName,
        project: projectId,
        description: data.description,
      };

      const url = ModuleeditId
        ? `${process.env.REACT_APP_Company_Contact}/company/modules/${ModuleeditId}/`
        : `${process.env.REACT_APP_Company_Contact}/company/modules/`;

      const method = ModuleeditId ? "patch" : "post";

      const response = await axios({
        method,
        url,
        data: payload,
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.status === 200 || response.status === 201) {
        GetModuleStatus(projectId, modulepage, modulesperpage);
        setShowModulepopup(false);
        resetModuleForm();
        setModuleeditId(null);
        toast.current?.show({
          severity: "success",
          summary: ModuleeditId ? "Updated" : "Added",
          detail: ModuleeditId
            ? "Module Status updated successfully"
            : "Module Status added successfully",
        });
      }
    } catch (error) {
      console.error("Error submitting module status:", error);
      toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: error?.response?.data?.error || "Failed to submit module status",
        });
    }

  };
  const [GroupeditId, setGroupeditId] = useState(null);
  const onSubmitGroupStatus = async (data) => {
    try {
      const projectId = selectedJobsData[0]?.__raw?.id;

      const payload = {
        group_name: data.groupName,
        employee_ids: selectedWatchersids,
      };

      const url = GroupeditId
        ? `${process.env.REACT_APP_Company_Contact}/company/${projectId}/groups/${GroupeditId}/`
        : `${process.env.REACT_APP_Company_Contact}/company/${projectId}/groups/`;

      const method = GroupeditId ? "put" : "post";

      const response = await axios({
        method,
        url,
        data: payload,
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.status === 200 || response.status === 201) {
        GetGroups(projectId,grouppage,groupperPage);
        setShowGrouppopup(false);
        resetGroupForm();
        setGroupeditId(null);
        setSelectedCompanies([]);
        setSelectedWatchersids([]);
        toast.current?.show({
          severity: "success",
          summary: GroupeditId ? "Updated" : "Added",
          detail: GroupeditId
            ? "Group updated successfully"
            : "Group added successfully",
        });
      }
    } catch (error) {
      console.error("Error submitting group status:", error);
      toast.current?.show({
          severity: "error",
          summary:"Error",
          detail: error?.response?.data?.error || "Failed to submit group",
        });
    }

  };
  const [viewGroupNames, setViewGroupNames] = useState('');
  const [showViewGrouppopup, setShowViewGrouppopup] = useState(false);
  const handleEditGroup = async (row) => {
    setShowGrouppopup(true);
    const companyIds = [
      ...new Set(row.members.map(m => String(m.company_id)))
    ];

    setSelectedCompanies(companyIds);
    const membersByCompany = row.members.reduce((acc, member) => {
      const cid = String(member.company_id);
      if (!acc[cid]) acc[cid] = [];
      acc[cid].push(member.id);
      return acc;
    }, {});
    for (const companyId of companyIds) {
      const data = await getEmployeesbyid(companyId);

      setCompanyDropdownData(prev => ({
        ...prev,
        [companyId]: {
          ...data,
          selected: membersByCompany[companyId] || []
        }
      }));
    }
    setSelectedWatchersids(row.members.map(m => m.id));
    setGroupeditId(row.id);
    setGroupValue("groupName", row.group_name);
  };


  const handleViewGroup = async (row) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/group-detail/${row.id}/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        setShowViewGrouppopup(true)
        const employeeData = response.data || response.data.results || response.data.data;
        setViewGroupNames(employeeData);
      }
    } catch (error) {
      console.error("Error extracting employee names:", error);
    }
  }
  const handleDeleteGroup = async (row) => {
    try {
      const projectId = selectedJobsData[0]?.__raw?.id;
      const response = await axios.delete(`${process.env.REACT_APP_Company_Contact}/company/${projectId}/groups/${row.id}/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200 || response.status === 204) {
        toast.current?.show({
          severity: "success",
          summary: "Deleted",
          detail: "Group Deleted successfully",
        });
        GetGroups(projectId,grouppage,groupperPage);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleEditModule = (row) => {
    setShowModulepopup(true)
    setModuleeditId(row.id);
    setModuleValue("statusName", row.name);
    setModuleValue("description", row.description);
  }
  const handleDeleteModule = async (row) => {
    try {
      const response = await axios.delete(`${process.env.REACT_APP_Company_Contact}/company/modules/${row.id}/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200 || response.status === 204) {
        toast.current?.show({
          severity: "success",
          summary: "Deleted",
          detail: "Module Deleted successfully",
        });
        const projectId = selectedJobsData[0]?.__raw?.id;
        GetModuleStatus(projectId, modulepage, modulesperpage);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleEditApprovalStatus = (row) => {
    setShowApprovalStatuspopup(true)
    setApprovalStatusid(row.id);
    setApprovalValue("statusName", row.name);
    setApprovalValue("description", row.description);
    setApprovalValue("color", row.colour);
  }
  const handleEditTaskStatus = (row) => {
    setShowStatuspopup(true)
    setTaskeditId(row.id);
    setTaskValue("statusName", row.name);
    setTaskValue("description", row.description);
    setTaskValue("color", row.colour);

  };

  const handleDeleteTaskStatus = async (row) => {
    try {
      const response = await axios.delete(`${process.env.REACT_APP_Company_Contact}/company/task-status/${row.id}/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.status === 200 || response.status === 204) {
        toast.current?.show({
          severity: "success",
          summary: "Deleted",
          detail: "Task Status Deleted successfully",
        });
        const projectId = selectedJobsData[0]?.__raw?.id;
        GetTaskStatus(projectId, taskstatuspage, taskstatusperpage);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleDeleteApprovalStatus = async (row) => {
    try {
      const response = await axios.delete(`${process.env.REACT_APP_Company_Contact}/company/approval-status/${row.id}/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.status === 200 || response.status === 204) {
        toast.current?.show({
          severity: "success",
          summary: "Deleted",
          detail: "Approval Status Deleted successfully",
        });
        const projectId = selectedJobsData[0]?.__raw?.id;
        GetApprovalStatus(projectId, approvalstatuspage, approvalstatusperpage)
      }
    } catch (err) {
      console.log(err);
    }
  };
  const { register: controlregister, reset: controlreset, setValue: controlsetValue, watch: controlwatch, control: stagescontrol } = useForm()
  const [stages, setStages] = useState([{ id: 1 }]);
  const blankStage = {
    stage_name: "",
    company: null,
    person: null,
    group: null
  };

  const handleCancel = () => {
    setStages((prev) => {
      // More than one → remove last
      if (prev.length > 1) {
        const updated = [...prev];
        updated.pop();
        reset({ stages: updated });
        return updated;
      }

      // Only one → just clear fields
      const cleared = [{
        stage_name: "",
        company: null,
        person: null,
        group: null
      }];

      reset({ stages: cleared });
      return cleared;
    });
  };


  const addMoreStage = () => {
    setStages(prev => [...prev, { id: Date.now() }]);
  };

  const removeStage = (id) => {
    setStages(prev => prev.filter(stage => stage.id !== id));
  };
  const rowClass = (data) => {
    return {
      'bg-green-100': data.mark_as_done === true
    };
  };
  const handleMarkDone = async (rowData) => {
    let req = {
      "stage_name": rowData.stage_name,
      "responsible_person": rowData.responsible_person,
      "responsible_person_company": rowData.responsible_person_company_id,
      "mark_as_done": rowData.mark_as_done ? false : true
    }

    try {
      setStagesLoading(true);
      const response = await axios.put(
        `${process.env.REACT_APP_Company_Contact}/company/projects/${EditId}/stages/${rowData.id}/`,
        req,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      if (response.status === 200) {
        getStages(EditId,page,perPage);
        setStagesLoading(false);
      }
    } catch (err) {
      console.log("Error fetching stages:", err);
      setStagesLoading(false);
    }
  };

  const StagesActions = (row) => {

    return (
      <div className="flex gap-2">
        {/* Edit */}
        <button
          className="btn btn-sm btn-primary"
          onClick={() => onEditStage(row)}
        >
          <i className="pi pi-pencil"></i>
        </button>

        {!row.mark_as_done && (
          <button
            className="btn btn-sm btn-danger"
            onClick={() => onDeleteStage(row)}
          >
            <i className="pi pi-trash"></i>
          </button>
        )}
      </div>
    );
  };
  const onEditStage = (row) => {
    setStageEditId(row.id)
    setshowStagepopup(true);
    setStageValue("statusName", row.stage_name);
    setSelectedGroup(row.group);
    getTeam(row.responsible_person_company_id)
    setSelectedresponsiblePersonCompany(row.responsible_person_company_id)
    setSelectedresponsiblePerson(row.responsible_person);
  };
  const onDeleteStage = async (row) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_Company_Contact}/company/projects/${EditId}/stages/${row.id}/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      if (response.status === 200) {
        getStages(EditId,page,perPage);
      }
    } catch (err) {
      console.log("Error fetching stages:", err);
    }
  };
const [TasksBasedOnstages, setTasksBasedOnstages] = useState([]);
const [taskbasedloader, settaskbasedloader] = useState(false);
const [selectedTask, setSelectedTask] = useState([]);
const getTasksonStage = async (stageId) => {
  try {
    settaskbasedloader(true);
    const response = await axios.get(
      `${process.env.REACT_APP_Company_Contact}/company/worktypes/?company_id=${selectedModule}&stage_id=${stageId}&project_id=${EditId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    if (response.status === 200) {
      setTasksBasedOnstages(response.data.results || response.data);
      settaskbasedloader(false);
    }
  } catch (err) {
    console.log("Error fetching tasks for stage:", err);
      settaskbasedloader(false);
  }
};
const rowClassName = (rowData) => {
  if (expandedRows?.[rowData.id]) {
    return "expanded-row-highlight";
  }
  if (rowData.mark_as_done) {
    return "row-done";
  }

  return "";
};

const handleassigntask = async () => {
  if (selectedTask.length === 0) {
    toast.current?.show({
      severity: "warn",
      summary: "No Tasks Selected",
      detail: "Please select at least one task to assign.",
    });
    return;
  }
}
 const rowExpansionTemplate = (rowData) => {
  return (
    <div
      key={rowData.id} // 🔑 force correct re-render per expanded row
      style={{ padding: "12px", background: "#f9fafb" }}
    >
      {/* Action bar */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "8px",
        }}
      >
        <button
          className="btn btn-sm btn-success"
          onClick={handleassigntask}
        >
          Assign
        </button>
      </div>

      {/* Table wrapper */}
      <div style={{ position: "relative" }}>
        <DataTable
          value={TasksBasedOnstages}   // ideally stage-based (see note below)
          dataKey="code"               // MUST be unique
          emptyMessage="No records found."
          selection={selectedTask}     // MUST be array
          onSelectionChange={(e) => setSelectedTask(e.value)}
        >
          {/* Checkbox column controls selection */}
          <Column selectionMode="multiple" headerStyle={{ width: "3em" }} />

          <Column field="code" header="Task Code" />
          <Column field="task_name" header="Task Name" />
          <Column field="assigned_to_name" header="Assigned To" />
          <Column field="status" header="Status" />
          <Column field="start_date" header="Start Date" />
          <Column field="end_date" header="End Date" />
          <Column field="priority" header="Priority" />
        </DataTable>

        {/* Loader overlay */}
        {taskbasedloader && (
          <div
            style={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "rgba(255,255,255,0.6)",
              zIndex: 10,
            }}
          >
            <div className="loader-spinner"></div>
          </div>
        )}
      </div>
    </div>
  );
};



  return (
    <React.Fragment>
      <div className="page-content allact-tabs">
        <Container fluid={true}>
          {submitloader ?
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backdropFilter: "blur(1px)",  // 💥 BLUR BACKGROUND
                  backgroundColor: "rgba(255, 255, 255, 0.4)", // soft overlay
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 9999
                }}
              >
                <div
                  style={{
                    width: "45px",
                    height: "45px",
                    border: "4px solid #ddd",
                    borderTopColor: "#126fa9",
                    borderRadius: "50%",
                    animation: "spin 0.8s linear infinite"
                  }}
                ></div>
              </div> : ""
            }
          <div className="page-title-box actjobbread">
            <Row className="align-items-center breadcrumb-card ac-items">
              <Col xxl={7} xl={12} lg={12} md={12} sm={12}>
                <span className="addcan-ac">
                  {selectedJobsData.length === 1 ? (
                    <span className="action-icons me-0">
                      <button
                        type="button"
                        className="btn btn-secondary import-res-btn me-0 md:w-8rem"
                      >
                        <i className="pi pi-briefcase"></i>{" "}
                        {selectedJobsData.length} Selected
                      </button>

                      <span className="icons-ac">
                        <Tooltip
                          target=".view"
                          content="View"
                          position="bottom"
                          style={{ marginTop: "5px" }}
                        />

                        <button
                          type="button"
                          class="btn btn-secondary icons-btn ms-1 view"
                          onClick={() => {
                            if (selectedJobsData.length === 1) {
                              viewJob(selectedJobsData[0]) // Use viewJob function for single selection
                              setActiveTabIndex(0)
                            }
                          }}
                        >
                          <i className="pi pi-eye"></i>
                        </button>

                        <Tooltip
                          target=".edit"
                          content="Edit"
                          position="top"
                          style={{ marginBottom: "5px" }}
                        />
                        <Link to={`/project-editform?id=${selectedJobsData[0]?.__raw?.id}`} className="p-link">
                          <button
                            type="button"
                            class="btn btn-secondary icons-btn ms-1 edit"
                          >
                            <i className="pi pi-pencil"></i>
                          </button>
                        </Link>

                        <Tooltip
                          target=".delete"
                          content="Delete"
                          position="bottom"
                          style={{ marginTop: "5px" }}
                        />

                        <button
                          type="button"
                          class="btn btn-secondary icons-btn ms-1 delete"
                          onClick={() => handleDeleteProject(selectedJobsData[0]?.__raw?.id)}
                        >
                          <i className="pi pi-trash"></i>
                        </button>

                        <Tooltip
                          target=".archived"
                          content="Archive"
                          position="top"
                          style={{ marginBottom: "5px" }}
                        />

                        <button
                          type="button"
                          class="btn btn-secondary icons-btn ms-1 archived"
                          onClick={() => handleArchiveProject(selectedJobsData[0]?.__raw?.id)}
                        >
                          <i class="pi pi-check-circle"></i>
                        </button>
                      </span>
                    </span>
                  ) : (
                    <>
                    <button
                      type="button"
                      className="btn btn-secondary import-res-btn md:w-9rem me-1"
                      onClick={() => {
                        setVisibleRight(true)
                      }}
                    >
                      <i className="pi pi-briefcase me-1"></i> Add a Project
                    </button>
                     <button
                      type="button"
                      className="btn btn-secondary import-res-btn md:w-9rem me-1"
                      onClick={() => {
                        navigate('/createprojectwithteam')
                      }}
                    >
                      <i className="pi pi-briefcase me-1"></i> Create with ai
                    </button>
                    </>
                  )}
                </span>

                <span className="drop-ac">

                  {selectedJobsData.length === 1 && (
                    <div className="d-inline-flex align-items-center">
                      {/* <Button
                        type="button"
                        className="btn btn-secondary import-res-btn me-1 ms-2"
                        label="Phase Tracker  "
                        onClick={() => {
                          if (selectedJobsData.length === 1) {
                            viewJob(selectedJobsData[0]) // Use viewJob function
                            setActiveTabIndex(1)
                          }
                        }} // Use the correct index for your tab
                      /> */}
                      <Button
                        type="button"
                        className="btn btn-secondary import-res-btn me-1 ms-2"
                        label="Add Stage/Level"
                        onClick={() => {
                          if (selectedJobsData.length === 1) {
                            viewJob(selectedJobsData[0])
                            setActiveTabIndex(1)
                          }
                        }} // Use the correct index for your tab
                      />
                      {/* <Button
      type="button"
      className="btn btn-secondary import-res-btn me-1"
      label="Add WorkType"   
       onClick={() => {setVisibleViewRight(true)
        setActiveTabIndex(3)}}
    /> */}

                      <WorkTypeSidebar
                        visible={showWorkTypeSidebar}
                        onHide={() => setShowWorkTypeSidebar(false)}
                        id={selectedJobsData[0]?.__raw?.id}
                      />

                    </div>
                  )}




                  <SubmitProjecttoWorkType className="me-2" id={selectedJobsData[0]?.__raw?.id} />


                  {/* <CascadeSelect
                    onChange={handleScheduleChange}
                    options={actScheduleOptions}
                    optionLabel="name"
                    optionGroupLabel="name"
                    className="md:w-10rem me-1 ms-2"
                    optionGroupChildren={["subItems", "subItems"]}
                    breakpoint="767px"
                    placeholder="Schedule"
                  />
                  <LinkWorkType SelectedData={selectedJobsData}/> */}
                </span>
              </Col>

              <Col xxl={5} xl={12} lg={12} sm={12}>
                <div className="clr-icons">
                  <label className="me-2 mt-2" style={{ width: "100%" }}>Select Company:</label>
                  <Dropdown
                    id="company"
                    value={selectedModule}
                    options={moduleWorkTypes}
                    onChange={e => { { setSelectedModule(e.value) } }}
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Select Company"
                    className="w-full bgclr"
                    style={{ marginRight: "5px", backgroundColor: "#fff" }}
                    label="Select Company"
                  />
                  {/* {selectedJobsData.length === 1 ? <NotesJobs id={selectedJobsData} /> : <NotesJobs1 />} */}
                  <Tooltip
                    target=".expbtn"
                    content="Export"
                    position="bottom"
                    style={{ marginTop: "5px" }}
                  />

                  <button
                    type="button"
                    className="btn btn-secondary icons-btn me-1 expbtn"
                    title="Export"
                    onClick={() => setImportCsvIcons(!importCsvIcons)}
                  >
                    <i className="pi pi-file-export"></i>
                  </button>

                  {importCsvIcons && <span>{headerBtn}</span>}

                  <Tooltip
                    target=".clear"
                    content="Clear"
                    position="bottom"
                    style={{ marginTop: "5px" }}
                  />

                  <button
                    type="button"
                    className="btn btn-secondary icons-btn clear"
                    onClick={handleClearSearchJobs}
                  >
                    <i className="pi pi-sync"></i>
                  </button>
                </div>
              </Col>
            </Row>

            <Row>
              <Col sm={12}>
                <section className="allactjobs-table">
                  {/* Toast for notifications */}
                  <Toast ref={toast} />

                  {/* ContextMenu for right-click actions */}
                  <ContextMenu
                    model={menuModel}
                    ref={cm}
                    onHide={() => setSelectedJob(null)}
                  />

                  <div className="card1 mt-3 actjobsumtable" id="AllActiveProjectsTable">
                    {loader ? (
                      <div
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          zIndex: 9999,
                        }}
                      >
                        <div className="loader-spinner"></div>
                      </div>
                    ) :
                      <DataTable
                        // ref={dt} // Reference for CSV export
                        // value={jobsData.slice(first, first + rows)}
                        // rows={rows}
                        ref={dt}
                        first={first}
                        value={jobsData}
                        rows={rows}
                        onPage={onPage}
                        dataKey="job_id"
                        loading={loading}
                        scrollable
                        emptyMessage="No records found."
                        selection={selectedJobsData}
                        onSelectionChange={e => setSelectedJobsData(e.value)}
                        selectionMode="multiple"
                        filters={filters}
                        filterDisplay="row"
                        resizableColumns
                        reorderableColumns
                        columnResizeMode="expand"
                        className="jobsallactive-table"
                        onContextMenu={e => {
                          cm.current.show(e.originalEvent) // Show the context menu
                          setSelectedJob(e.data) // Set the selected job
                        }}
                        contextMenuSelection={selectedJob}
                        onContextMenuSelectionChange={e =>
                          setSelectedJob(e.value)
                        }
                      >
                        <Column
                          selectionMode="multiple"
                          headerStyle={{ width: "3em" }}
                        />
                        <Column
                          field="job_id"
                          header="Project Code"
                          sortable
                          frozen
                          filter
                          style={{ minWidth: "8rem" }}
                          body={rowData => (
                            <span
                              style={{ cursor: "pointer" }}
                              className="project-code-hover"
                            // onClick={() => {
                            //   viewJob(rowData) // Use the viewJob function to handle project viewing
                            // }}
                            >
                              {rowData.job_id}
                            </span>
                          )}
                        />
                        <Column
                          field="job_title"
                          header="Project Name"
                          sortable
                          filter
                        />
                        <Column
                          field="openings"
                          header="Project Manager"
                          sortable
                          filter
                        />
                        <Column
                          field="delivery_manager"
                          header="Delivery Manager"
                          sortable
                          filter
                        />


                        {/* <Column
                          field="status"
                          header="Status"
                          sortable
                          filter
                        /> */}
                        <Column
                          field="job_start_date"
                          header="Start Date"
                          sortable
                          filter
                          body={(row) => formatDate(row.job_start_date)}
                        />

                        <Column
                          field="job_end_date"
                          header="End Date"
                          sortable
                          filter
                          body={(row) => formatDate(row.job_end_date)}
                        />

                        <Column
                          field="workplace_type"
                          header="Reason for Delay"
                          sortable
                          filter
                        />
                        <Column
                          field="job_type"
                          header="Extended End Date"
                          sortable
                          filter
                        />
                        {/* <Column
                        field="hiring_manager"
                        header="# Tasks"
                        sortable
                        filter
                        style={{ textAlign: "center" }}
                      /> */}
                        {/* <Column
                          field="company"
                          header="Company Name"
                          sortable
                          filter
                        /> */}
                      </DataTable>
                    }
                  </div>
                </section>
              </Col>
            </Row>
            {/* ================================== */}
            <Sidebar
              visible={visibleRight}
              position="right"
              className="sidebar"
              onHide={() => setVisibleRight(true)}
              style={{ width: "800px" }}
            >
              <div className="sidebar-header">
                <h3>Create a Project</h3>
                <Button
                  icon="pi pi-times"
                  className="p-button-text close-btn"
                  onClick={() => setVisibleRight(false)}
                  disabled={loading}
                />
              </div>

              <form onSubmit={handleSubmit(createProjectSubmit)}>
                <div className="card sidebardetails">

                  {/* ---------- Project Name ---------- */}
                  <Row>
                    <Col lg={6}>
                      <label className="mb-1">
                        Project Name <span className="text-danger">*</span>
                      </label>

                      <Controller
                        name="projectName"
                        control={control}
                        rules={{ required: "Project Name is required" }}
                        render={({ field }) => (
                          <InputText {...field} className="w-full" placeholder="Enter Project Name" disabled={loading} />
                        )}
                      />
                      {errors.projectName && <p className="text-danger">{errors.projectName.message}</p>}
                    </Col>

                    {/* ---------- Company ---------- */}
                    <Col lg={6}>
                      <label>Company <span className="text-danger">*</span></label>

                      <Controller
                        name="company"
                        control={control}
                        rules={{ required: "Company is required" }}
                        render={({ field }) => (
                          <Dropdown
                            {...field}
                            options={compamyitem.length ? compamyitem : companies}
                            optionLabel="label"
                            placeholder="Select Company"
                            className="w-full"
                            disabled={loading}
                          />
                        )}
                      />
                      {errors.company && <p className="text-danger">{errors.company.message}</p>}
                    </Col>
                  </Row>

                  {/* ---------- Delivery Manager Company ---------- */}
                  <Row className="mt-3">
                    <Col lg={6}>
                      <label>Delivery Manager Company <span className="text-danger">*</span></label>

                      <Controller
                        name="deliveryManagerCompany"
                        control={control}
                        rules={{ required: "Delivery Manager Company is required" }}
                        render={({ field }) => (
                          <Dropdown
                            {...field}
                            options={compamyitem.length ? compamyitem : companies}
                            onChange={(e) => {
                              field.onChange(e.value);
                              getdeliveryManager(e.value);
                            }}
                            optionLabel="label"
                            optionValue="id"
                            placeholder="Select Delivery Manager Company"
                            className="w-full"
                            filter
                            disabled={loading}
                          />
                        )}
                      />
                      {errors.deliveryManagerCompany && (
                        <p className="text-danger">{errors.deliveryManagerCompany.message}</p>
                      )}
                    </Col>
                    <Col lg={6}>
                      <label>Delivery Manager <span className="text-danger">*</span></label>

                      <Controller
                        name="deliveryManager"
                        control={control}
                        rules={{ required: "Delivery Manager is required" }}
                        render={({ field }) => (
                          <Dropdown
                            {...field}
                            options={manageroptions}
                            optionLabel={(opt) => `${opt.first_name} (${opt.primary_email})`}
                            optionValue="id"
                            placeholder="Select Delivery Manager"
                            className="w-full"
                            filter
                            loading={apiLoader}
                            disabled={loading}
                          />
                        )}
                      />

                      {errors.deliveryManager && (
                        <p className="text-danger">{errors.deliveryManager.message}</p>
                      )}
                    </Col>
                  </Row>

                  {/* ---------- Project Manager Company ---------- */}
                  <Row className="mt-3">
                    <Col lg={6}>
                      <label>Project Manager Company <span className="text-danger">*</span></label>

                      <Controller
                        name="projectManagerCompany"
                        control={control}
                        rules={{ required: "Project Manager Company is required" }}

                        render={({ field }) => (
                          <Dropdown
                            {...field}
                            options={compamyitem.length ? compamyitem : companies}
                            optionLabel="label"
                            optionValue="id"
                            placeholder="Select Project Manager Company"
                            className="w-full"
                            onChange={(e) => {
                              field.onChange(e.value);
                              getTeam(e.value);
                            }}
                            filter
                            disabled={loading}
                          />
                        )}
                      />

                      {errors.projectManagerCompany && (
                        <p className="text-danger">{errors.projectManagerCompany.message}</p>
                      )}
                    </Col>
                    <Col lg={6}>
                      <label>Project Manager <span className="text-danger">*</span></label>

                      <Controller
                        name="projectManager"
                        control={control}
                        rules={{ required: "Project Manager is required" }}
                        render={({ field }) => (
                          <Dropdown
                            {...field}
                            options={teamData}
                            optionLabel="name"
                            optionValue="id"
                            placeholder="Select Project Manager"
                            className="w-full"
                            filter
                            loading={apiLoader}
                            disabled={loading}
                          />
                        )}
                      />

                      {errors.projectManager && (
                        <p className="text-danger">{errors.projectManager.message}</p>
                      )}
                    </Col>
                  </Row>

                  {/* ---------- Dates ---------- */}
                  <Row className="mt-3">
                    <Col lg={6}>
                      <label>Project Start Date <span className="text-danger">*</span></label>

                      <Controller
                        name="startDate"
                        control={control}
                        rules={{ required: "Start Date is required" }}
                        render={({ field }) => (
                          <Calendar {...field} showIcon placeholder="Start Date" className="w-full" disabled={loading} />
                        )}
                      />
                      {errors.startDate && <p className="text-danger">{errors.startDate.message}</p>}
                    </Col>

                    <Col lg={6}>
                      <label>Project End Date <span className="text-danger">*</span></label>

                      <Controller
                        name="endDate"
                        control={control}
                        rules={{
                          required: "End Date is required",
                          validate: (v) =>
                            v >= startDateWatch || "End Date must be after Start Date",
                        }}
                        render={({ field }) => (
                          <Calendar
                            {...field}
                            showIcon
                            placeholder="End Date"
                            className="w-full"
                            minDate={startDateWatch}
                            disabled={loading}

                          />
                        )}
                      />
                      {errors.endDate && <p className="text-danger">{errors.endDate.message}</p>}
                    </Col>
                  </Row>
                  {/* <div style={{marginTop:"10px"}}>Team Responsibilities</div> */}
                  {/* <div style={{border:"1px solid #e0e0e8", padding:"10px", borderRadius:"5px", marginTop:"10px"}}> */}
                  <div>

                    {stages.map((stage, index) => (
                      <div key={stage.id} className="stage-block mt-3">
                        <Row className="align-items-center">

                          <Col lg={3}>
                            <label>Stage / Level</label>
                            <InputText
                              placeholder="Enter Stage / Level"
                              className="w-100"
                              {...register(`stages[${index}].stage_name`)}
                            disabled={loading}
                              
                            />
                          </Col>

                          <Col lg={3}>
                            <label>Company</label>
                            <Controller
                              name={`stages[${index}].responsible_person_company`}
                              control={control}
                              render={({ field }) => (
                                <Dropdown
                                  {...field}
                                  options={compamyitem.length ? compamyitem : companies}
                                  optionLabel="label"
                                  optionValue="id"
                                  placeholder="Select Company"
                                  className="w-100"
                                  filter
                                  onChange={(e) => {
                                    field.onChange(e.value);
                                    getTeam(e.value);
                                  }}
                            disabled={loading}

                                />
                              )}
                            />
                          </Col>

                          <Col lg={3}>
                            <label>Responsible Person</label>
                            <Controller
                              name={`stages[${index}].responsible_person_name`}
                              control={control}
                              render={({ field }) => (
                                <Dropdown
                                  {...field}
                                  options={teamData}
                                  optionLabel="name"
                                  optionValue="id"
                                  placeholder="Select Person"
                                  className="w-100"
                                  filter
                                  loading={apiLoader}
                                  disabled={loading}
                                />
                              )}
                            />
                          </Col>

                          <Col lg={3}>
                            <label>Group</label>
                            <Controller
                              name={`stages[${index}].group`}
                              control={control}
                              render={({ field }) => (
                                <Dropdown
                                  {...field}
                                  options={groupOptions}
                                  optionLabel="name"
                                  optionValue="id"
                                  placeholder="Select Group"
                                  className="w-100"
                                  filter
                            disabled={loading}

                                />
                              )}
                            />
                          </Col>

                        </Row>
                      </div>
                    ))}

                    <Col lg={12} className="mt-2 d-flex gap-2">
                      <button
                        type="button"
                        className="btn"
                        style={{ backgroundColor: "#0f527d", color: "#fff" }}
                        onClick={addMoreStage}
                            disabled={loading}

                      >
                        + Add More
                      </button>

                      <button
                        type="button"
                        className="btn btn-danger"
                        // style={{ backgroundColor: "#0f527d", color: "#fff" }}
                        onClick={handleCancel}
                            disabled={loading}

                      >
                        Remove
                      </button>
                    </Col>


                    {/* <Row className="mt-3">
            <label>Stage / Level </label>
          <Col lg={12}>
          <InputText 
          type="text"
          placeholder="Enter Stage / Level"
          />
        </Col>
        </Row>
        <Row className="mt-3">
          <Col lg={6}>
            <label>Responsible Person Company </label>

            <Controller
              name="projectManagerCompany"
              control={control}
              
              render={({ field }) => (
                <Dropdown
                  {...field}
                  options={compamyitem.length ? compamyitem : companies}
                  optionLabel="label"
                  optionValue="id"
                  placeholder="Select Responsible Person Company"
                  className="w-full"
                  onChange={(e) => {
                  field.onChange(e.value);
                  getProjectManagersByCompany(e.value);
                 }}
                 filter
                />
              )}
            />

            {errors.projectManagerCompany && (
              <p className="text-danger">{errors.projectManagerCompany.message}</p>
            )}
          </Col>
          <Col lg={6}>
            <label>Responsible Person </label>

            <Controller
              name="projectManager"
              control={control}
              render={({ field }) => (
                <Dropdown
                  {...field}
                  options={projectManagerWorkTypes}
                  optionLabel="name"
                  optionValue="id"
                  placeholder="Select Responsible Person"
                  className="w-full"
                  filter
                />
              )}
            />

            {errors.projectManager && (
              <p className="text-danger">{errors.projectManager.message}</p>
            )}
          </Col> */}

                    {/* <Col lg={12} className="mt-3">
            <label>Group </label>
            <Dropdown
                  options={projectManagerWorkTypes}
                  optionLabel="name"
                  optionValue="id"
                  placeholder="Select Group"
                  className="w-full"
                  filter
                />
            </Col> */}
                    {/* <div className="pt-2 mb-3">
                  <label
                    className="form-label form-field-label formFieldLabel"
                    for=""
                  >
                    Group
                  </label>
                  <div className="d-flex align-items-center flex-wrap">
                    <div className="WatcherBlock pe-3"></div>
                  </div>
                </div>
          {companyOptions.map((company, i) => (
                            <Row className="mb-2" key={i}>
                              <Col lg={6}>
                                <div className="form-check d-flex align-items-center gap-2">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id={`company_${i}`}
                                    checked={selectedCompanies.includes(company.id)}
                                    onChange={(e) => handleCompanySelect(e, company.id)}
                                  />
                                  <label htmlFor={`company_${i}`}>{company.name}</label>
                                </div>
                              </Col>
                              {selectedCompanies.includes(company.id) && (
                                <Col lg={6}>
                                  <MultiSelect
                                    id={`company_multi_${company.id}`}
                                    value={companyDropdownData[company.id]?.selected || []}
                                    onChange={(e) => handleMultiSelectChange(company.id, e)}
                                    options={
                                      companyDropdownData[company.id]
                                        ? Object.values(companyDropdownData[company.id])
                                          .filter(item => item && typeof item === "object" && item.id)
                                        : []
                                    }
          
          
                                    optionLabel={(option) => `${option.full_name} (${option.primary_email})`}
                                    optionValue="id"
                                    display="chip"
                                    filter
                                    placeholder="Select Employees"
                                    className="w-full"
                                  />
                                </Col>
                              )}
          
          
                            </Row>
                          ))} */}
                    {/* </Row> */}
                  </div>

                  {/* ---------- Description ---------- */}
                  <Row className="mt-3">
                    <Col lg={12}>
                      <label>Description <span className="text-danger">*</span></label>

                      <Controller
                        name="description"
                        control={control}
                        rules={{ required: "Description is required" }}
                        render={({ field }) => (
                          <InputTextarea
                            {...field}
                            rows={4}
                            placeholder="Enter Description"
                            className="w-full"
                            autoResize
                            disabled={loading}
                          />
                        )}
                      />

                      {errors.description && (
                        <p className="text-danger">{errors.description.message}</p>
                      )}
                    </Col>
                    <Col lg={12} className="mt-3">
                      <label
                        htmlFor="createProjectFileUpload"
                        className="form-field-label formFieldLabel"
                      >
                        Files Upload
                      </label>

                      <input
                        type="file"
                        className="form-control createProjectFileUpload"
                        name="createProjectFileUpload"
                        id="createProjectFileUpload"
                        accept=".pdf, .doc, .docx, .xls, .xlsx, .zip"
                        {...register("attachment_file")}
                        onChange={(e) => {
                          trigger("attachment_file");
                          if (e.target.files.length > 0) {
                            setImageNamepan(e.target.files[0].name);
                            setHaveImagePan(true);
                            setUploadedFiles(e.target.files);
                          }

                        }}
                            disabled={loading}

                      />

                      <small className="text-muted">Eg: (pdf, word, excel, zip)</small>


                      {errors.files && (
                        <p className="text-danger">{errors.files.message}</p>
                      )}
                      {HaveImagePan ? (
                        <div className=''>
                          <p className="mt-1 font_13">{imageNamepan}  <span
                            className='text-danger'
                            disabled={loading}
                            onClick={() => removeFileFromHerepan()}>
                            <i className='fa fa-close'></i>
                          </span> </p>

                        </div>
                      ) : (
                        ""
                      )}
                    </Col>


                  </Row>
                  <Row className="mt-3">
                    <Col lg={12} className="d-flex justify-content-end">
                      <Button type="submit" className="btn btn-primary btn-main" disabled={loading}>
                        Create
                      </Button>
                    </Col>
                  </Row>
                </div>
              </form>
            </Sidebar>
            {/* ================================== */}
            {/* Side bar start */}
            <Row>
              <Col lg={12}>
                <Sidebar
                  // visible={visibleRight}
                  position="right"
                  className="sidebar"
                  onHide={() => setVisibleRight(false)}
                >
                  <div className="sidebar-header">
                    <h3>Create a Project</h3>
                    <div className="d-flex align-items-center">

                      {/* <Link to={`/project-editform?id=${selectedJobsData[0]?.__raw?.id}`}>
                        <p className="mb-0 text-white">
                          {" "}
                          <i class="fa-regular fa-pen-to-square me-3"></i>{" "}
                        </p>
                      </Link> */}
                      <Button
                        icon="pi pi-times"
                        className="p-button-text close-btn"
                        onClick={() => { setVisibleRight(false); resetForm(); }}
                      />
                    </div>
                  </div>

                  <div className="card sidebardetails">
                    <Row className="mb-0">
                      {/* <Col lg={6}>
                        <div className="field">
                          <label htmlFor="jobId" className="mb-1">
                            Project Code{" "}
                          </label>
                          <InputText
                            id="jobId"
                            placeholder="Job-101"
                            className="w-full"
                            value={jobid}
                            onChange={e => setJobid(e.target.value)}
                          />
                        </div>
                      </Col> */}
                      <Col lg={6}>
                        <div className="p-field">
                          <label htmlFor="jobTitle" className="p-d-block">
                            Project Name <span className="text-danger">*</span>
                          </label>
                          <InputText
                            id="jobTitle"
                            placeholder="Enter Project Name"
                            className="p-d-block"
                            value={jobtitle}
                            onChange={e => { setJobtitle(e.target.value); setProjecterror(''); }}
                          />
                        </div>
                        <p className="text-danger">{Projecterror}</p>
                      </Col>
                      <Col lg={6}>
                        {/* <div className="p-field">
                          <label htmlFor="hiringManager">Select Company</label>
                          <select
                            className="form-select profileDetailsInput w-full"
                            id="MyPro_EmpDet_Team_WorkInfo_DesSelBox"
                            aria-label="Default select example"
                          >
                            <option value="">Varun Digital Media</option>
                            <option value="Office">Varun Digital Media</option>
                            <option value="Remote">
                              Pranathi Software Services
                            </option>
                            <option value="Hybrid">
                              Vitel Global Communications
                            </option>
                          </select>
                        </div> */}
                        <label htmlFor="hiringManager">Company <span className="text-danger">*</span></label>
                        <Dropdown
                          id="company"
                          value={selectedCompany}
                          options={compamyitem.length ? compamyitem : companies}
                          onChange={e => { setSelectedCompany(e.value); }}
                          optionLabel="label"
                          placeholder="Select Company"
                          className="w-full"
                          filter
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3 mt-3">
                      <Col lg={6}>
                        <label htmlFor="hiringManager">Delivery Manager Company <span className="text-danger">*</span></label>
                        <Dropdown
                          id="company"
                          value={selectedManagerCompany}
                          options={compamyitem.length ? compamyitem : companies}
                          onChange={e => { setSelectedManagerCompany(e.value); getdeliveryManager(e.value); }}
                          optionLabel="label"
                          optionValue="id"
                          placeholder="Select Delivery Manager Company"
                          className="w-full"
                          filter
                        />
                      </Col>

                      <Col lg={6}>
                        <label htmlFor="hiringManager">Delivery Manager <span className="text-danger">*</span></label>
                        <Dropdown
                          id="company"
                          value={selectedManager}
                          options={manageroptions}
                          onChange={e => setSelectedManager(e.value)}
                          optionLabel={(option) => `${option.first_name} (${option.primary_email})`}
                          optionValue="id"
                          placeholder="Select Delivery Manager"
                          className="w-full"
                          loading={loader}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3 mt-1">
                      <Col lg={6}>
                        <div className="p-field">
                          <label htmlFor="hiringManager">Project Manager Company <span className="text-danger">*</span></label>
                          <Dropdown
                            id="project"
                            value={selectedProjectManagerCompany}
                            options={compamyitem.length ? compamyitem : companies}
                            onChange={(e) => setSelectedProjectManagerCompany(e.value)}
                            placeholder="Select Project Manager Company"
                            className="w-full bgclr"
                            optionLabel="label"
                            optionValue="id"
                            filter
                          />
                        </div>
                      </Col>

                      {/* <Col lg={6}>
                        <div className="p-field">
                          <label htmlFor="hiringManager">Project Manager</label>
                          <select
                            className="form-select profileDetailsInput w-full"
                            id="MyPro_EmpDet_Team_WorkInfo_DesSelBox"
                            aria-label="Default select example"
                          >
                            <option value="">Mahesh Kumar Bhoga</option>
                            <option value="Office">Mahesh Kumar Bhoga</option>
                            <option value="Remote">Salmanuddin Sayyad</option>
                            <option value="Hybrid">Girish Bodepudi</option>
                          </select>
                        </div>
                      </Col> */}

                      <Col lg={6}>
                        <div className="p-field">
                          <label htmlFor="hiringManager">Project Manager <span className="text-danger">*</span></label>
                          <Dropdown
                            id="project"
                            value={selectedProjectManager}
                            onChange={(e) => setSelectedProjectManager(e.value)}
                            options={projectManagerWorkTypes}
                            placeholder="Select Project"
                            className="w-full bgclr"
                            optionLabel={(option) => `${option.name}`}
                            // optionLabel="name"
                            optionValue="id"
                            filter
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col lg={6}>
                        <label htmlFor="ProjectStartDate" className="p-mb-2">
                          Project Start Date <span className="text-danger">*</span>
                        </label>
                        <Calendar
                          id="ProjectStartDate"
                          value={ProjectStartDate}
                          onChange={e => setProjectStartDate(e.value)}
                          dateFormat="dd/mm/yy"
                          placeholder="Project Start Date"
                          className="w-full activejobdrop"
                          showIcon
                        />
                      </Col>
                      <Col lg={6}>
                        <label htmlFor="ProjectEndDate" className="mr-2">
                          Project End Date <span className="text-danger">*</span>
                        </label>
                        <Calendar
                          id="ProjectEndDate"
                          value={ProjectEndDate}
                          minDate={ProjectStartDate}
                          onChange={e => setProjectEndDate(e.value)}
                          dateFormat="dd/mm/yy"
                          placeholder="Project End Date"
                          className="w-full activejobdrop"
                          showIcon
                        />
                      </Col>
                    </Row>

                    <Row className="mb-2 d-flex justify-content-between align-items-end">
                      <Col lg={6}>
                        <div className="">
                          <label htmlFor="descriptionEditor">Description <span className="text-danger">*</span></label>
                        </div>
                      </Col>
                      <Col lg={6} className="d-flex justify-content-end mt-2">
                        <Button
                          color="primary"
                          className="btn btn-primary aibtn"
                        >
                          <i class="pi pi-star me-1"></i>
                          Write with AI
                        </Button>
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col lg={12}>
                        <div className="">
                          <Editor
                            value={text}
                            onTextChange={e => setText(e.htmlValue)}
                            headerTemplate={header}
                            style={{ height: "140px" }}
                          />
                        </div>
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      {/* <Col lg={12}>
                        <label
                          htmlFor="availabilityDate"
                          className="mb-0 avbdate"
                        >
                          Files Upload
                        </label>

                        <FileUpload
                          ref={fileUploadRef}
                          name="files[]"
                          accept="image/jpg,image/jpeg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                          maxFileSize={5242880}
                          multiple
                          customUpload
                          auto={false}
                          onSelect={(e) => {
                            // Get current files (previously uploaded ones)
                            const currentFiles = uploadedFiles || [];
                            
                            // Validate individual file types first for new files
                            const allowedTypes = [
                              'image/jpg', 'image/jpeg', 'image/png', 
                              'application/pdf',
                              'application/msword', // .doc
                              'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
                              'text/plain', // .txt
                              'application/vnd.ms-excel', // .xls
                              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' // .xlsx
                            ];
                            
                            const validNewFiles = e.files.filter(file => allowedTypes.includes(file.type));
                            const invalidFiles = e.files.filter(file => !allowedTypes.includes(file.type));
                            
                            if (invalidFiles.length > 0) {
                              toast.current?.show({
                                severity: "error",
                                summary: "Invalid File Type",
                                detail: `File(s) rejected: ${invalidFiles.map(f => f.name).join(', ')}. Only Images (JPG, JPEG, PNG), PDF, DOC, DOCX, TXT, XLS, XLSX are allowed.`,
                                life: 5000
                              });
                              
                              // If there are valid files, continue with them; otherwise clear and return
                              if (validNewFiles.length === 0) {
                                // Clear the component and restore previous files
                                setTimeout(() => {
                                  if (fileUploadRef.current) {
                                    fileUploadRef.current.clear();
                                    // Restore previous files to the component
                                    if (currentFiles.length > 0) {
                                      fileUploadRef.current.setFiles(currentFiles);
                                    }
                                  }
                                }, 0);
                                return;
                              }
                            }
                            
                            // Combine current files with valid new files
                            const allFiles = [...currentFiles, ...validNewFiles];
                            
                            // Calculate total size of all files (current + new valid files)
                            const totalSize = allFiles.reduce((sum, file) => sum + file.size, 0);
                            const maxTotalSize = 5242880; // 5MB total limit (5 * 1024 * 1024)
                            const totalSizeMB = totalSize / (1024 * 1024);
                            
                            console.log(`File validation - Current files: ${currentFiles.length}, New files: ${validNewFiles.length}, Total files: ${allFiles.length}, Total size: ${totalSizeMB.toFixed(3)}MB, Limit: ${(maxTotalSize / (1024 * 1024)).toFixed(1)}MB`);
                            
                            if (totalSize > maxTotalSize) {
                              const currentSizeMB = currentFiles.reduce((sum, file) => sum + file.size, 0) / (1024 * 1024);
                              const newSizeMB = validNewFiles.reduce((sum, file) => sum + file.size, 0) / (1024 * 1024);
                              
                              toast.current?.show({
                                severity: "error",
                                summary: "File Size Error",
                                detail: `Cannot add ${validNewFiles.length} file(s) (${newSizeMB.toFixed(2)}MB). Current files: ${currentSizeMB.toFixed(2)}MB, Total would be: ${totalSizeMB.toFixed(2)}MB. Maximum allowed: 5MB.`,
                                life: 5000
                              });
                              
                              // Clear the component and restore only previous files
                              setTimeout(() => {
                                if (fileUploadRef.current) {
                                  fileUploadRef.current.clear();
                                  // Restore only the previous files, not the new ones
                                  if (currentFiles.length > 0) {
                                    fileUploadRef.current.setFiles(currentFiles);
                                  }
                                }
                              }, 0);
                              return;
                            }
                            
                            // Success - files are valid
                            toast.current?.show({
                              severity: "success",
                              summary: "Files Added",
                              detail: `${validNewFiles.length} file(s) added. Total: ${allFiles.length} files (${totalSizeMB.toFixed(2)}MB)`,
                              life: 3000
                            });
                            
                            setUploadedFiles(allFiles);
                            console.log(`Upload ready - Total files: ${allFiles.length}, Total size: ${totalSizeMB.toFixed(3)}MB`);
                          }}
                          uploadHandler={(e) => {
                            // This will be called when files are manually uploaded
                            console.log('Upload handler called', e.files);
                          }}
                          onClear={() => {
                            console.log("Files cleared")
                            setUploadedFiles([])
                          }}
                        />
                        <small className="text-muted">
                          Maximum total file size: 5MB. Accepted formats: Images (JPG, JPEG, PNG), PDF, DOC, DOCX, TXT, XLS, XLSX
                        </small>

                        {PoliciesfilesErrorMessagepan && (
                          <small className="text-danger">
                            {" "}
                            {PoliciesfilesErrorMessagepan}
                          </small>
                        )}
                        <small className="text-muted">
                          Eg: (pdf,word,excel,zip)
                        </small>
                      </Col> */}

                      <Col lg={6}>
                        <div className="p-field mt-3">
                          <label htmlFor="ProjectType">Categories</label>
                          <TreeSelect
                            value={selectedCategoryKey}
                            onChange={e => setSelectedCategoryKey(e.value)}
                            options={categories}
                            filter
                            className="w-full"
                            placeholder="Select Project Type"
                          ></TreeSelect>
                        </div>
                      </Col>

                      <Col lg={6}>
                        <div className="p-field mt-3">
                          <label htmlFor="ProjectType">Groups</label>
                          <Dropdown
                            id="project"
                            value={selectedGroupKey}
                            onChange={(e) => setSelectedGroupKey(e.value)}
                            options={[...groups, { id: lookupAddSentinel, value: 'Add New Group', _sentinel: true }, { id: lookupEditSentinel, value: 'Edit Selected Group', _sentinel: true }]}
                            placeholder="Select Group"
                            className="w-full bgclr"
                            optionLabel="value"
                            optionValue="id"
                            filter
                            itemTemplate={(option) => {
                              if (!option) return null
                              if (option._sentinel) {
                                return (
                                  <div className="flex align-items-center">
                                    <i className={`pi ${option.id === lookupAddSentinel ? 'pi-plus' : 'pi-pencil'} mr-2`} />
                                    <div>{option.value}</div>
                                  </div>
                                )
                              }
                              return <div>{option.value}</div>
                            }}
                          />
                          {/* <TreeSelect
                            value={selectedGroupKey}
                            onChange={e => setSelectedGroupKey(e.value)}
                            options={groups}
                            filter
                            className="w-full"
                            placeholder="Select Project Domain"
                          ></TreeSelect> */}
                        </div>
                      </Col>

                      <Col lg={6}>
                        <div className="p-field mt-3">
                          <label htmlFor="status">Status <span className="text-danger">*</span></label>
                          <Dropdown
                            id="project"
                            value={selectedStatusWorkType}
                            onChange={(e) => setSelectedStatusWorkType(e.value)}
                            options={[...statusWorkTypes, { id: lookupAddSentinel, name: 'Add New Status', _sentinel: true }, { id: lookupEditSentinel, name: 'Edit Selected Status', _sentinel: true }]}
                            placeholder="Select Status"
                            className="w-full bgclr"
                            optionLabel="name"
                            optionValue="id"
                            filter
                            itemTemplate={(option) => {
                              if (!option) return null
                              if (option._sentinel) {
                                return (
                                  <div className="flex align-items-center">
                                    <i className={`pi ${option.id === lookupAddSentinel ? 'pi-plus' : 'pi-pencil'} mr-2`} />
                                    <div>{option.name}</div>
                                  </div>
                                )
                              }
                              return <div>{option.name}</div>
                            }}
                          />
                          {/* <WorkType1
                            initialWorkTypes={statusWorkTypes}
                            dropdownWorkTypes={statusDropdownWorkTypes}
                            onWorkTypesChange={handleStatusWorkTypesChange}
                            onSelectionChange={handleStatusSelectionChange}
                          /> */}
                          <Dialog
                            header={
                              editingLookup
                                ? lookupModalContext === "project_groups"
                                  ? "Edit Group"
                                  : lookupModalContext === "project_status"
                                    ? "Edit Status"
                                    : "Edit"
                                : lookupModalContext === "project_groups"
                                  ? "Add Group"
                                  : lookupModalContext === "project_status"
                                    ? "Add Status"
                                    : "Add"
                            }

                            visible={lookupModalVisible}
                            style={{ width: "30vw" }}
                            onHide={() => { setLookupModalVisible(false); setdescription(''); setSelectedGroupKey(null); setLastSelectedLookupId(null); }}
                          >
                            <div className="p-fluid">
                              {/* Dropdown - only visible when editing */}
                              {editingLookup && (
                                <>
                                  <label className="mb-1">Select to edit</label>
                                  <Dropdown
                                    id="worktype"
                                    value={selectedEditdrop}
                                    onChange={(e) => {
                                      setSelectedEditdrop(e.value);

                                      const selectedOption = selecteddropoptions.find(opt => opt.id === e.value);
                                      if (selectedOption) {
                                        setLookupFormValue(
                                          lookupModalContext === "project_status" ? selectedOption.name : selectedOption.value
                                        );
                                      }
                                    }}
                                    options={selecteddropoptions}
                                    placeholder="Select Work Type"
                                    className="w-full bgclr mb-2"
                                    optionLabel={lookupModalContext === 'project_status' ? 'name' : 'value'}
                                    optionValue="id"
                                    filter
                                  />
                                </>
                              )}

                              {/* Work type name */}
                              <label className="mb-1">
                                {lookupModalContext === "project_groups" ? "Group Name" : "Status Name"} <span className="text-danger">*</span>
                              </label>
                              <InputText
                                value={lookupFormValue}
                                onChange={(e) => setLookupFormValue(e.target.value)}
                                className="w-full mb-3"
                              />

                              {/* Description */}
                              <label className="mb-1">Description</label>
                              <InputTextarea
                                value={description}
                                onChange={(e) => setdescription(e.target.value)}
                                rows={3}
                                className="w-full"
                              />
                            </div>

                            {/* Buttons */}
                            <div className="gap-2 d-flex justify-content-end mt-3">
                              <Button
                                label="Cancel"
                                className="p-button-text"
                                onClick={() => setLookupModalVisible(false)}
                              />
                              <Button label="Save" className="p-ml-2" onClick={handleLookupSave} />
                            </div>
                          </Dialog>

                        </div>
                      </Col>


                    </Row>

                    <Row className="justify-content-start align-items-end mt-2">
                      <Col xl={2}>
                        <div className="d-flex align-items-center mt-4">
                          <Checkbox
                            inputId="checkbox"
                            checked={popchecked2}
                            onChange={handlePopupCheckbox2}
                          />
                          <label htmlFor="username" className="ms-1 mt-2">
                            Private
                          </label>
                        </div>
                      </Col>

                      {popchecked2 && (
                        <Col xl={4}>
                          <label htmlFor="username">User Id's</label>
                          <MultiSelect
                            value={privateDrop}
                            onChange={e => setPrivateDrop(e.value)}
                            options={PrivetDropdownValues}
                            optionLabel={(option) => `${option.name} (${option.email})`}
                            optionValue="code"
                            placeholder="Select Users"
                            className="w-full"
                            style={{ border: '1px solid #ced4da' }}
                            display="comma"
                          />
                        </Col>
                      )}
                    </Row>

                    <Row className="justify-content-start align-items-end mt-2">


                      <Col lg={12} className="d-flex justify-content-end">
                        <Button
                          color="primary"
                          className="btn btn-primary waves-effect waves-light me-2 btn-main"
                          onClick={() => createProjectSubmit()}
                          disabled={loading}
                        >
                          Create
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </Sidebar>
              </Col>
            </Row>
            {/* Side bar end */}
          </div>
        </Container>
      </div>

      {/* view page starts */}
      <Row>
        <Col lg={12}>
          <Sidebar
            visible={visibleViewRight}
            position="right"
            onHide={() => {
              setVisibleViewRight(false)
              setSelectedProjectForView(null) // Clear selected project data when closing
            }}
            className="view-form-sidebar"
          >
            <div className="sidebar-header">
              <h3 className="head">
                <i className="pi pi-folder me-1"></i> Project - {selectedProjectForView ? selectedProjectForView.job_title : 'Project Name'}
              </h3>
              <div className="d-flex align-items-center">
                <Link to={`/project-editform?id=${selectedJobsData[0]?.__raw?.id}`}>
                  <p className="mb-0 text-white">
                    {" "}
                    <i class="fa-regular fa-pen-to-square me-3"></i>{" "}
                  </p>
                </Link>
                <Button
                  icon="pi pi-times"
                  className="p-button-text close-btn"
                  onClick={() => {
                    setVisibleViewRight(false)
                    setSelectedProjectForView(null)
                    setSelectedJobsData([]) // Clear selected project data when closing
                  }}
                />
              </div>
            </div>
            <TabView className="mt-4" activeIndex={activeTabIndex} onTabChange={e => setActiveTabIndex(e.index)}>
              <TabPanel header="Project" leftIcon="pi pi-folder mr-2">
                <Row>
                  <Col lg={12}>
                    <Accordion activeIndex={0}>
                      <AccordionTab
                        header={
                          <span className="flex align-items-center gap-2 w-full">
                            <span className="white-space-nowrap">
                              PROFILE INFORMATION
                            </span>
                            <Badge value="-" className="ml-auto" />
                          </span>
                        }
                      >
                        <Row>
                          <Col lg={4}>
                            <div className="field">
                              <label htmlFor="jobId">Project Code</label>
                              <InputText
                                id="jobId"
                                placeholder="Job-101"
                                className="w-full"
                                value={selectedProjectForView ? selectedProjectForView.job_id : ''}
                                readOnly
                              />
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div className="field">
                              <label htmlFor="jobTitle">Project Name</label>
                              <InputText
                                id="jobTitle"
                                placeholder="Web Developer"
                                className="w-full"
                                value={selectedProjectForView ? selectedProjectForView.job_title : ''}
                                readOnly
                              />
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div className="field">
                              <label htmlFor="company">Company</label>
                              <InputText
                                id="company"
                                placeholder="Varun Digital Media"
                                className="w-full"
                                value={selectedProjectForView ? selectedProjectForView.company : ''}
                                readOnly
                              />
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col lg={4}>
                            <div className="field">
                              <label htmlFor="hiringManager">
                                Project Manager
                              </label>
                              <InputText
                                id="hiringManager"
                                placeholder="Project Manager"
                                className="w-full"
                                value={selectedProjectForView ? selectedProjectForView?.__raw?.project_manager_name : ''}
                                readOnly
                              />
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div className="p-field">
                              <label htmlFor="ProjectType">Delivery Manager</label>
                              <InputText
                                id="status"
                                placeholder=" Delivery Manager"
                                className="block w-full"
                                value={selectedProjectForView ? selectedProjectForView.delivery_manager : ''}
                                readOnly
                              />
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div className="p-field">
                              <label htmlFor="ProjectType">Status</label>
                              <InputText
                                id="status"
                                placeholder="Project Status"
                                className="block w-full"
                                value={selectedProjectForView ? selectedProjectForView.status : ''}
                                readOnly
                              />
                            </div>
                          </Col>
                          {/* <Col lg={4}>
                            <div className="p-field">
                              <label htmlFor="ProjectType">Categories</label>
                              <InputText
                                id="categories"
                                placeholder="Categories"
                                className="block w-full"
                                value={selectedProjectForView ? (selectedProjectForView.categories || '') : ''}
                                readOnly
                              />
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div className="p-field">
                              <label htmlFor="ProjectType">Groups</label>
                              <InputText
                                id="groups"
                                placeholder="Groups"
                                className="block w-full"
                                value={selectedProjectForView ? (selectedProjectForView.groups || '') : ''}
                                readOnly
                              />
                            </div>
                          </Col> */}
                        </Row>

                        <Row>
                          {/* <Col lg={4}>
                            <div className="field">
                              <label htmlFor="workplaceType">
                                Workplace Type
                              </label>
                              <InputText
                                id="workplaceType"
                                placeholder="Workplace Type"
                                className="w-full"
                                value={selectedProjectForView ? selectedProjectForView.workplace_type : ''}
                                readOnly
                              />
                            </div>
                          </Col> */}
                          <Col lg={4}>
                            <div className="field">
                              <label htmlFor="ProjectStartDate" className="block">
                                Project Start Date
                              </label>
                              <InputText
                                id="ProjectStartDate"
                                placeholder="01-01-2025"
                                className="block w-full"
                                value={selectedProjectForView ? formatDate(selectedProjectForView.job_start_date || '') : ''}
                                readOnly
                              />
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div className="field">
                              <label htmlFor="ProjectEndDate" className="block">
                                Project End Date
                              </label>
                              <InputText
                                id="ProjectEndDate"
                                placeholder="31-12-2025"
                                className="block w-full"
                                value={selectedProjectForView ? formatDate(selectedProjectForView.job_end_date || '') : ''}
                                readOnly
                              />
                            </div>
                          </Col>


                        </Row>

                        <Row className="mt-3">
                          <Col lg={12}>
                            <div className="field">
                              <label htmlFor="description">Description</label>
                              <InputTextarea
                                id="description"
                                placeholder=""
                                rows={4}
                                cols={30}
                                className="w-full"
                                value={selectedProjectForView ? (selectedProjectForView.description || '') : ''}
                                readOnly
                              />
                            </div>
                          </Col>
                        </Row>

                        {/* <Row>
                          <Col lg={12}>
                            <div className="p-field">
                              <label htmlFor="ProjectType" className="block">
                                Notes
                              </label>
                              <InputTextarea
                                // autoResize
                                // rows={2}
                                // cols={20}
                                placeholder=""
                                className="w-full"
                                value={selectedProjectForView ? (selectedProjectForView.notes || '') : ''}
                              />
                            </div>
                          </Col>
                        </Row> */}
                      </AccordionTab>
                      {/* <AccordionTab
                        header={
                          <span className="flex align-items-center gap-2 w-full">
                            <span className="white-space-nowrap">DOCUMENTS</span>
                            <Badge value="-" className="ml-auto" />
                          </span>
                        }
                      >
                        <Row>
                          <Col lg={12}>
                            <div className="doc-table">

                              <DataTable
                                value={documents}
                                rows={5}
                                className="p-datatable-gridlines"
                                emptyMessage={<div className="empty-message-custom">No documents found.</div>}
                              >
                                <Column
                                  field="type_name"
                                  header="Document Type"
                                />
                                <Column
                                  field="description"
                                  header="Subject"
                                />
                                <Column
                                  field="created_at"
                                  header="Uploaded On"
                                  body={(rowData) => new Date(rowData.created_at).toLocaleDateString()}
                                />
                                <Column
                                  header="Attachments"
                                  body={(rowData) => rowData.files && rowData.files.length > 0 ? (
                                    <ul className="list-unstyled mb-0">
                                      {rowData.files.map((fileItem) => (
                                        <li key={fileItem.id}>
                                          <a href={fileItem.file} target="_blank" rel="noopener noreferrer">
                                            {fileItem.original_filename} ({(fileItem.file_size / 1024).toFixed(2)} KB)
                                          </a>
                                        </li>
                                      ))}
                                    </ul>
                                  ) : 'No file'}
                                />
                                <Column
                                  header="Actions"
                                  body={(rowData) => (
                                    <div className="d-flex gap-2">
                                      <Button
                                        type="button"
                                        icon="pi pi-pencil"
                                        tooltip="Edit"
                                        onClick={() => handleEdit(rowData)}
                                      />
                                      <Button
                                        icon="pi pi-trash"
                                        tooltip="Delete"
                                        type="button"
                                        onClick={() => handleDelete(rowData.id)}
                                      />
                                    </div>
                                  )}
                                />
                              </DataTable>
                            </div>
                          </Col>
                        </Row>
                      </AccordionTab> */}
                    </Accordion>
                  </Col>
                </Row>
              </TabPanel>
              <TabPanel
                header="Stage/Level Tracker"
                leftIcon="pi pi-sitemap mr-2"
              >
                <Row>
                  <Col lg={12}>
                    <Row>
                      <Col lg={12}>
                        <section className="job-datatable-section">
                          <div className=" mb-3 d-flex justify-content-end align-items-center">
                            <Button onClick={() => setshowStagepopup(true)}>Add Stage/Level</Button>
                          </div>
                          <div className="card1 mt-3 mb-4 actjobsumtable">
                            <div style={{ position: "relative" }}>
                              <DataTable
                                value={stageList}
                                dataKey="id"
                                responsiveLayout="scroll"
                                paginator
                                rows={perPage}
                                first={(page - 1) * perPage}
                                totalRecords={totalStagesCount}
                                rowsPerPageOptions={[5, 10, 20, 50]}
                                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                                showCurrentPageReport
                                emptyMessage={stagesLoading ? " " : "No Stages found"}
                                onPage={handleStagePageChange}
                                expandedRows={expandedRows}
                                onRowExpand={(e) => {
                                  setExpandedRows({ [e.data.id]: true });
                                  getTasksonStage(e.data.id);
                                }}
                                onRowCollapse={() => {
                                  setExpandedRows({});
                                }}
                                rowExpansionTemplate={rowExpansionTemplate}
                                // onRowExpand={(e) => getTasksonStage(e.data.id)}
                                rowClassName={rowClassName}
                                
                              >
                                <Column expander style={{ width: "3rem" }} />
                                <Column field="stage_name" header="Stage / Level Name" />
                                <Column field="responsible_person_name" header="Responsible Person" />
                                <Column field="group_name" header="Group" />
                                <Column
                                  header="Mark As Done"
                                  body={(rowData) => (
                                    <Checkbox
                                      checked={rowData.mark_as_done}
                                      onChange={() => handleMarkDone(rowData)}
                                    />
                                  )}
                                />
                                <Column
                                  header="Completed Date"
                                  body={(row) =>
                                    row.mark_as_done ? (
                                      <span className="font-semibold">
                                        {new Date(row.updated_at).toLocaleDateString('en-GB').replace(/\//g, '-')}
                                      </span>
                                    ) : (
                                      <span className="text-orange-600 font-semibold">
                                        ---
                                      </span>
                                    )
                                  }
                                />
                                <Column
                                  header="Actions"
                                  body={(rowData) => StagesActions(rowData)}
                                  style={{ width: "130px", textAlign: "center" }}
                                />
                              </DataTable>
                              {stagesLoading && (
                                <div
                                  style={{
                                    position: "absolute",
                                    inset: 0,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: "rgba(255,255,255,0.6)",
                                    zIndex: 10,
                                  }}
                                >
                                  <div className="loader-spinner"></div>
                                </div>
                              )}
                            </div>
                          </div>
                        </section>
                      </Col>
                    </Row>
                    <Accordion activeIndex={0}></Accordion>
                  </Col>
                </Row>
              </TabPanel>
              {/* <TabPanel
                header="Phase Tracker"
                leftIcon="pi pi-sitemap mr-2"
              >
                <Row>
                  <Col lg={12}>
                    <EstimateTable id={selectedJobsData[0]?.__raw?.id} />
                    <Accordion activeIndex={0}></Accordion>
                  </Col>
                </Row>
              </TabPanel> */}
              <TabPanel header="Group" leftIcon="pi pi-users mr-2">
                <Row>
                  <Col lg={12}>
                    <section className="job-datatable-section">
                      <div className=" mb-3 d-flex justify-content-end align-items-center">
                        <Button onClick={() => setShowGrouppopup(true)}>Add Group</Button>
                      </div>
                      <div className="card1 mt-3 mb-4 actjobsumtable">
                        <div style={{ position: "relative" }}>
                        <DataTable
                          responsive
                          showGridlines
                          value={GroupsList}
                          tableStyle={{
                            minWidth: "50rem",
                            borderRadius: "8px",
                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                          }}
                          paginator
                          rows={groupperPage}
                          first={(grouppage - 1) * groupperPage}
                          totalRecords={totalGroupsCount}
                          rowsPerPageOptions={[5, 10, 20, 50]}
                          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
                          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                          onPage={handleGroupPageChange}
                          emptyMessage={groupLoading ? " " : "No Groups found"}
                          showCurrentPageReport
                        >
                          <Column
                            header="S.No"
                            style={{ minWidth: "6rem" }}
                            body={(rowData, options) => options.rowIndex + 1}
                          />
                          <Column
                            header="Group Name"
                            sortable
                            style={{ minWidth: "10rem" }}
                            body={(rowData) => (
                              <span style={{ color: rowData.colour }}>
                                {rowData.group_name}
                              </span>
                            )}
                          />
                          <Column
                            field="member_count"
                            header="No of Members"
                            sortable
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            header="Actions"
                            body={(rowData) => (
                              <div className="d-flex gap-2">
                                <button
                                  type="button"
                                  className="btn btn-secondary  Edit"
                                  onClick={() => handleViewGroup(rowData)}
                                >
                                  <i className="pi pi-eye"></i>
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-secondary  Edit"
                                  onClick={() => handleEditGroup(rowData)}
                                >
                                  <i className="pi pi-pencil"></i>
                                </button>

                                <button
                                  type="button"
                                  className="btn btn-secondary icons-btn Delete"
                                  onClick={() => handleDeleteGroup(rowData)}
                                >
                                  <i className="pi pi-trash"></i>
                                </button>
                              </div>

                            )}
                            style={{ minWidth: "8rem" }}
                          />

                          </DataTable>
                          {groupLoading && (
                            <div
                              style={{
                                position: "absolute",
                                inset: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                background: "rgba(255,255,255,0.6)",
                                zIndex: 10,
                              }}
                            >
                              <div className="loader-spinner"></div>
                            </div>
                          )}
                        </div>
                      </div>
                    </section>
                  </Col>
                </Row>
              </TabPanel>
              <TabPanel header="Team" leftIcon="pi pi-slack mr-2">
                <Row>
                  <Col lg={12} sm={12}>
                    <section className="job-datatable-section">
                      <div className="card1 mt-3 mb-4 actjobsumtable">
                        <div className="add-team mb-3 d-flex justify-content-end align-items-center">
                          <SubmitProjecttoWorkType id={selectedJobsData[0]?.__raw?.id} companyid={selectedJobsData[0]?.company_id} />
                        </div>
                         <div style={{ position: "relative" }}>
                        <DataTable
                          responsive
                          showGridlines
                          value={Employees}
                          paginator
                          rows={employeeperPage}
                          first={(employeepage - 1) * employeeperPage}
                          totalRecords={totalEmployeesCount}
                          rowsPerPageOptions={[5, 10, 20, 50]}
                          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
                          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                          onPage={handleEmployeePageChange}
                          showCurrentPageReport
                        >
                          {/* <Column
                            selectionMode="multiple"
                            headerStyle={{ width: "3em" }}
                          /> */}
                          <Column
                            field="full_name"
                            header="Name"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          {/* <Column
                            field="description"
                            header="Designation"
                            sortable
                            filter
                            style={{ minWidth: "15rem" }}
                          /> */}
                          {/* <Column
                            field="role"
                            header="Project Role"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          /> */}
                          <Column
                            field="primary_email"
                            header="Email"
                            sortable
                            filter
                            style={{ minWidth: "15rem" }}
                          />
                          <Column
                            field="office_phone"
                            header="Phone No"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                        </DataTable>
                        {employeeLoading && (
                            <div
                              style={{
                                position: "absolute",
                                inset: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                background: "rgba(255,255,255,0.6)",
                                zIndex: 10,
                              }}
                            >
                              <div className="loader-spinner"></div>
                            </div>
                          )}
                          </div>
                      </div>
                    </section>
                  </Col>
                </Row>
              </TabPanel>

              <TabPanel header="Tasks" leftIcon="pi pi-check-square mr-2">
                <Row>
                  <Col lg={12}>
                    <div className="pipelinetabs">
                      {/* <TabView
                        scrollable
                        style={{ maxWidth: "1200px", overflow: "hidden" }}
                        activeIndex={activeWorkTypeTabIndex}
                        onTabChange={e => setActiveWorkTypeTabIndex(e.index)}
                      >
                        {TasksStatusList.map(status => {
                          const jobsForStatus = tasksData.filter(job => job.work_type_status === status.id);
                          return (
                            <TabPanel
                              key={status.id}
                              header={status.name}
                              rightIcon={
                                <Badge
                                  value={jobsForStatus.length}
                                  severity="success"
                                  className="ml-2"
                                />
                              }
                              leftIcon="pi pi-cog mr-1"
                            > */}
                      <Row>
                        <Col lg={12}>
                          <section className="job-datatable-section">
                            <div className="d-flex justify-content-end">
                              <button
                                type="button"
                                 className="btn btn-secondary import-res-btn md:w-10rem me-1"
                                 style={{backgroundColor:"#2271a3"}}
                                onClick={handlegetEmail}
                              >
                                Send Report
                              </button>
                            </div>

                            <div className="card1 mt-4 mb-4 actjobsumtable">
                              <div style={{ position: "relative" }}>
                                <DataTable
                                  ref={dt}
                                  value={tasksData}
                                  dataKey="task_code"
                                  scrollable
                                  emptyMessage="No records found."
                                  filterDisplay="row"
                                  reorderableRows
                                  resizableColumns
                                  reorderableColumns
                                  columnResizeMode="expand"
                                  selection={selectedTasksData}
                                  onSelectionChange={e => setSelectedTasksData(e.value)}
                                  selectionMode="multiple"
                                  paginator
                                  rows={tasksperpage}
                                  first={(taskpage - 1) * tasksperpage}
                                  totalRecords={totalTasksCount}
                                  rowsPerPageOptions={[5, 10, 20, 50]}
                                  onPage={handleTaskPageChange}
                                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                                showCurrentPageReport
                              >
                                <Column
                                  selectionMode="multiple"
                                  headerStyle={{ width: "3em" }}
                                />
                                {availableColumns
                                  .map(col => (
                                    <Column
                                      key={col.field}
                                      field={col.field}
                                      header={col.header}
                                      sortable
                                      filter
                                      style={col.style}
                                    />
                                  ))}
                              </DataTable>
                              {taskLoading && (
                                <div
                                  style={{
                                    position: "absolute",
                                    inset: 0,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: "rgba(255,255,255,0.6)",
                                    zIndex: 10,
                                  }}
                                >
                                  <div className="loader-spinner"></div>
                                </div>
                              )}
                              </div>
                            </div>
                          </section>
                        </Col>
                      </Row>
                      {/* </TabPanel>);
                        })}
                      </TabView> */}
                    </div>
                  </Col>
                </Row>
              </TabPanel>
              {/* ====================================================================
      ===================================================================== */}




              <TabPanel header="Modules" leftIcon="pi pi-database mr-2">
                <Row>
                  <Col lg={12}>
                    <section className="job-datatable-section">
                      <div className=" mb-3 d-flex justify-content-end align-items-center">
                        <Button onClick={() => setShowModulepopup(true)}>Add Module</Button>
                      </div>
                      <div className="card1 mt-3 mb-4 actjobsumtable">
                         <div style={{ position: "relative" }}>
                        <DataTable
                          responsive
                          showGridlines
                          value={ModulesList}
                          tableStyle={{
                            minWidth: "50rem",
                            borderRadius: "8px",
                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                          }}
                          paginator
                          rows={modulesperpage}
                          first={(modulepage - 1) * modulesperpage}
                          totalRecords={totalModulesCount}
                          rowsPerPageOptions={[5, 10, 20, 50]}
                          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
                          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                          onPage={handleModulePageChange}
                          showCurrentPageReport
                          emptyMessage={modulesloading ? " " : "No Modules found"}
                        >
                          <Column
                            header="S.No"
                            style={{ minWidth: "6rem" }}
                            body={(rowData, options) => options.rowIndex + 1}
                          />
                          <Column
                            header="Module Name"
                            sortable
                            style={{ minWidth: "10rem" }}
                            body={(rowData) => (
                              <span style={{ color: rowData.colour }}>
                                {rowData.name}
                              </span>
                            )}
                          />

                          <Column
                            field="description"
                            header="Description"
                            sortable
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="task_count"
                            header="Task Count"
                            sortable
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            header="Actions"
                            body={(rowData) => (
                              <div className="d-flex gap-2">
                                <button
                                  type="button"
                                  className="btn btn-secondary  Edit"
                                  onClick={() => handleEditModule(rowData)}
                                >
                                  <i className="pi pi-pencil"></i>
                                </button>

                                <button
                                  type="button"
                                  className="btn btn-secondary icons-btn Delete"
                                  onClick={() => handleDeleteModule(rowData)}
                                >
                                  <i className="pi pi-trash"></i>
                                </button>
                              </div>

                            )}
                            style={{ minWidth: "8rem" }}
                          />

                        </DataTable>
                        {modulesloading && (
                            <div
                              style={{
                                position: "absolute",
                                inset: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                background: "rgba(255,255,255,0.6)",
                                zIndex: 10,
                              }}
                            >
                              <div className="loader-spinner"></div>
                            </div>
                          )}
                          </div>
                      </div>
                    </section>
                  </Col>
                </Row>
              </TabPanel>
              <TabPanel header="Task Status" leftIcon="pi pi-clock mr-2">
                <Row>
                  <Col lg={12}>
                    <section className="job-datatable-section">
                      <div className=" mb-3 d-flex justify-content-end align-items-center">
                        <Button onClick={() => setShowStatuspopup(true)}>Add Task Status</Button>
                      </div>
                      <div className="card1 mt-3 mb-4 actjobsumtable">
                         <div style={{ position: "relative" }}>
                        <DataTable
                          responsive
                          showGridlines
                          value={TasksStatusList}
                          tableStyle={{
                            minWidth: "50rem",
                            borderRadius: "8px",
                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                          }}
                          paginator
                          rows={taskstatusperpage}
                          first={(taskstatuspage - 1) * taskstatusperpage}
                          totalRecords={totalTaskstatusCount}
                          rowsPerPageOptions={[5, 10, 20, 50]}
                          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
                          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                          onPage={handleTaskStatusPageChange}
                          showCurrentPageReport
                        >
                          <Column
                            header="S.No"
                            style={{ minWidth: "6rem" }}
                            body={(rowData, options) => options.rowIndex + 1}
                          />
                          <Column
                            header="Task Status"
                            sortable
                            style={{ minWidth: "10rem" }}
                            body={(rowData) => (
                              <span style={{ color: rowData.colour }}>
                                {rowData.name}
                              </span>
                            )}
                          />

                          <Column
                            field="description"
                            header="Description"
                            sortable
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            header="Actions"
                            body={(rowData) => (
                              <div className="d-flex gap-2">
                                <button
                                  type="button"
                                  className="btn btn-secondary  Edit"
                                  onClick={() => handleEditTaskStatus(rowData)}
                                >
                                  <i className="pi pi-pencil"></i>
                                </button>

                                <button
                                  type="button"
                                  className="btn btn-secondary icons-btn Delete"
                                  onClick={() => handleDeleteTaskStatus(rowData)}
                                >
                                  <i className="pi pi-trash"></i>
                                </button>
                              </div>

                            )}
                            style={{ minWidth: "8rem" }}
                          />

                        </DataTable>
                        {taskstatusloading && (
                            <div
                              style={{
                                position: "absolute",
                                inset: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                background: "rgba(255,255,255,0.6)",
                                zIndex: 10,
                              }}
                            >
                              <div className="loader-spinner"></div>
                            </div>
                          )}
                          </div>
                      </div>
                    </section>
                  </Col>
                </Row>
              </TabPanel>
              <TabPanel header="Approval Status" leftIcon="pi pi-check-circle mr-2">
                <Row>
                  <Col lg={12}>
                    <section className="job-datatable-section">
                      <div className=" mb-3 d-flex justify-content-end align-items-center">
                        <Button onClick={() => setShowApprovalStatuspopup(true)}>Add Approval Status</Button>
                      </div>
                      <div className="card1 mt-3 mb-4 actjobsumtable">
                         <div style={{ position: "relative" }}>
                        <DataTable
                          responsive
                          showGridlines
                          value={ApprovalStatusList}
                          tableStyle={{
                            minWidth: "50rem",
                            borderRadius: "8px",
                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                          }}
                          paginator
                          rows={approvalstatusperpage}
                          first={(approvalstatuspage - 1) * approvalstatusperpage}
                          totalRecords={totalApprovalstatusCount}
                          rowsPerPageOptions={[5, 10, 20, 50]}
                          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
                          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                          onPage={handleApprovalStatusPageChange}
                          showCurrentPageReport
                        >
                          <Column
                            header="S.No"
                            style={{ minWidth: "6rem" }}
                            body={(rowData, options) => options.rowIndex + 1}
                          />
                          <Column
                            header="Task Status"
                            sortable
                            style={{ minWidth: "10rem" }}
                            body={(rowData) => (
                              <span style={{ color: rowData.colour }}>
                                {rowData.name}
                              </span>
                            )}
                          />

                          <Column
                            field="description"
                            header="Description"
                            sortable
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            header="Actions"
                            body={(rowData) => (
                              <div className="d-flex gap-2">
                                <button
                                  type="button"
                                  className="btn btn-secondary  Edit"
                                  onClick={() => handleEditApprovalStatus(rowData)}
                                >
                                  <i className="pi pi-pencil"></i>
                                </button>

                                <button
                                  type="button"
                                  className="btn btn-secondary icons-btn Delete"
                                  onClick={() => handleDeleteApprovalStatus(rowData)}
                                >
                                  <i className="pi pi-trash"></i>
                                </button>
                              </div>

                            )}
                            style={{ minWidth: "8rem" }}
                          />

                        </DataTable>
                        {approvalstatusloading && (
                            <div
                              style={{
                                position: "absolute",
                                inset: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                background: "rgba(255,255,255,0.6)",
                                zIndex: 10,
                              }}
                            >
                              <div className="loader-spinner"></div>
                            </div>
                          )}
                          </div>
                      </div>
                    </section>
                  </Col>
                </Row>
              </TabPanel>
              {/* ====================================================================
      ===================================================================== */}
              {/* <TabPanel header="Activities" leftIcon="pi pi-calendar mr-2" disabled>
                <Row>
                  <Col lg={12}>
                    <section className="job-datatable-section">
                      <div className="card1 mt-3 mb-4 actjobsumtable">
                        <DataTable
                          responsive
                          showGridlines
                          value={activities}
                          tableStyle={{
                            minWidth: "50rem",
                            borderRadius: "8px",
                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                          }}
                          paginator
                          rows={5}
                          rowsPerPageOptions={[5, 10, 25, 50]}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          filters={activitiesFilters}
                          filterDisplay="row"
                          globalFilterFields={[
                            "type",
                            "sub_type",
                            "priority",
                            "subject",
                            "date_time",
                            "user_id",
                          ]}
                          emptyMessage="No activities found."
                          selection={selectedActivities}
                          onSelectionChange={e =>
                            setSelectedActivities(e.value)
                          }
                          selectionMode="multiple"
                          resizableColumns
                          columnResizeMode="expand"
                        >
                          <Column
                            selectionMode="multiple"
                            headerStyle={{ width: "3em" }}
                          />
                          <Column
                            field="type"
                            header="Type"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="sub_type"
                            header="Sub Type"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="priority"
                            header="Priority"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="subject"
                            header="Subject"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="date_time"
                            header="Date and Time"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="user_id"
                            header="User ID"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                        </DataTable>
                      </div>
                    </section>
                  </Col>
                </Row>
              </TabPanel>

              <TabPanel header="History" leftIcon="pi pi-clock mr-2" disabled>
                <Row>
                  <Col lg={12} sm={12}>
                    <section className="job-datatable-section">
                      <div className="card1 mt-3 mb-4 actjobsumtable">
                        <DataTable
                          responsive
                          showGridlines
                          value={history}
                          tableStyle={{
                            minWidth: "50rem",
                            borderRadius: "8px",
                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                          }}
                          paginator
                          rows={5}
                          rowsPerPageOptions={[5, 10, 25, 50]}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          filters={historyFilters}
                          filterDisplay="row"
                          globalFilterFields={[
                            "type",
                            "sub_type",
                            "priority",
                            "subject",
                            "date_time",
                            "user_id",
                          ]}
                          emptyMessage="No history found."
                          selection={selectedHistory}
                          onSelectionChange={e => setSelectedHistory(e.value)}
                          selectionMode="multiple"
                          resizableColumns
                          columnResizeMode="expand"
                        >
                          <Column
                            selectionMode="multiple"
                            headerStyle={{ width: "3em" }}
                          />
                          <Column
                            field="type"
                            header="Type"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="sub_type"
                            header="Sub Type"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="priority"
                            header="Priority"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="subject"
                            header="Subject"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="date_time"
                            header="Date and Time"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                          <Column
                            field="user_id"
                            header="User ID"
                            sortable
                            filter
                            style={{ minWidth: "10rem" }}
                          />
                        </DataTable>
                      </div>
                    </section>
                  </Col>
                </Row>
              </TabPanel>
              <TabPanel header="Notes" leftIcon="pi pi-pencil mr-2">
                <Row>
                  <Col lg={12}>
                    <div className="d-flex justify-content-end">
                      <Button
                        type="button"
                        label="Add Notes"
                        icon="pi pi-plus"
                        className="btn btn-primary waves-effect waves-light me-2 sidebarbtn"
                        onClick={handleAddNotes}
                      />
                    </div>
                  </Col>
                </Row>

                {isEditorVisible && (
                  <Row className="mt-4">
                    <Col lg={12}>
                      <Editor
                        value={editorContent}
                        onTextChange={e => setEditorContent(e.htmlValue)}
                        style={{ height: "200px" }}
                        placeholder="Enter your notes here..."
                      />
                      <div className="d-flex justify-content-end mt-2">
                        <Button
                          type="button"
                          label="Save"
                          icon="pi pi-save"
                          className="btn btn-success me-2"
                          onClick={handleSaveNotes}
                        />
                        <Button
                          color="primary"
                          className="btn btn-primary waves-effect waves-light me-2 cancel-outlinebtn"
                          onClick={handleCancelNotes}
                        >
                          <i className="pi pi-times me-1"></i>
                          Cancel
                        </Button>
                      </div>
                    </Col>
                  </Row>
                )}

                <Row className="mt-4 notes">
                  <Col lg={12}>
                    {candidateNotes.length > 0 && (
                      <Card className="pt-0 pb-0">
                        {candidateNotes.map((note, index) => (
                          <div key={index}>
                            <div className="d-flex mt-0">
                              <strong className="text-muted me-4">{note.created_by_name}</strong>
                              <strong className="text-muted">{note.created_at}</strong>
                            </div>
                            <div className="d-flex justify-content-between mt-2 mb-0">
                              <div dangerouslySetInnerHTML={{ __html: note.content }} />
                              <div>
                                <Button
                                  icon="pi pi-pencil"
                                  className="btn btn-warning editbtn p-0"
                                  onClick={() => handleEditNote(note)}
                                />
                                <Button
                                  icon="pi pi-trash"
                                  className="btn btn-danger deletebtn"
                                  onClick={() => handleDeleteNote(note.id)}
                                />
                              </div>
                            </div>
                            <hr />
                          </div>
                        ))}
                      </Card>
                    )}
                  </Col>
                </Row>
              </TabPanel> */}
            </TabView>
          </Sidebar>
        </Col>
      </Row>

      <Dialog
        header="Schedule Interview"
        visible={interviewpop}
        className="interview-popup"
        style={{ width: "50vw" }}
        onHide={() => {
          SetInterviewpop(false)
        }}
      >
        <form>
          <p className="bg-form">
            <div className="mb-4">
              <Row className="mb-2">
                <Col xl={6}>
                  <div className="p-field flex flex-column">
                    <label htmlFor="interview">Type</label>
                    <InputText
                      disabled
                      value={intertype}
                      onChange={e => setintertype(e.target.value)}
                    />
                  </div>
                </Col>

                <Col xl={6}>
                  <div className="p-field flex flex-column">
                    <label htmlFor="integer" className=" block">
                      Sub-Type
                    </label>
                    <Dropdown
                      value={subtype}
                      onChange={e => setSubtype(e.value)}
                      options={typeInterview1}
                      optionLabel="name"
                      placeholder="Subtype"
                      className="w-full search-option"
                    />
                  </div>
                </Col>
              </Row>

              <Row>
                <Col xl={6}>
                  <Row className="mb-2">
                    <Col xl={6}>
                      <div className="p-field flex-auto">
                        <label htmlFor="buttondisplay" className="block">
                          Start date
                        </label>
                        <Calendar
                          value={startdate}
                          onChange={e => setStartdate(e.value)}
                          showIcon
                        />
                      </div>
                    </Col>

                    <Col xl={6}>
                      <div className="p-field flex-auto">
                        <label htmlFor="buttondisplay" className="block">
                          Time
                        </label>
                        <Calendar
                          value={starttime}
                          onChange={e => setStarttime(e.value)}
                          showIcon
                          timeOnly
                          icon={() => <i className="pi pi-clock" />}
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>

                <Col xl={6}>
                  <Row className="mb-2">
                    <Col xl={6}>
                      <div className="flex-auto">
                        <label htmlFor="buttondisplay" className="block">
                          End date
                        </label>
                        <Calendar
                          value={enddate}
                          onChange={e => setenddate(e.value)}
                          showIcon
                        />
                      </div>
                    </Col>

                    <Col xl={6}>
                      <div className="flex-auto">
                        <label htmlFor="buttondisplay" className="block">
                          Time
                        </label>

                        <Calendar
                          value={endtime}
                          onChange={e => setendtime(e.value)}
                          showIcon
                          timeOnly
                          icon={() => <i className="pi pi-clock" />}
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>

            <div className="mb-4">
              <Row className="mb-2">
                <Col xl={6}>
                  <div className="flex flex-column">
                    <label For="Priority">Job Status</label>
                    <Dropdown
                      value={subtypeget}
                      onChange={e => setsubtypeget(e.value)}
                      options={typeInterview}
                      optionLabel="name"
                      placeholder="Select a Status"
                      className="w-full search-option"
                    />
                  </div>
                </Col>

                <LinkJobsPopup />
              </Row>

              <Row className="mb-2">
                <Col xl={6}>
                  <div className="p-field flex flex-column">
                    <label For="Candidate">Candidate</label>
                    <MultiSelect
                      value={condidatevalu}
                      disabled
                      onChange={e => {
                        condidatelist(e)
                      }}
                      options={typeInterviewcondi}
                      optionLabel="name"
                      placeholder={`Select Candidates`}
                      maxSelectedLabels={0}
                      className="w-full"
                    />
                  </div>
                </Col>
                <Col xl={6}>
                  <div className="p-field flex flex-column">
                    <label htmlFor="username">Subject</label>
                    <InputText
                      placeholder="Subject"
                      value={subjectval}
                      onChange={e => setsubjectval(e.target.value)}
                    />
                  </div>
                </Col>
              </Row>

              <Row className="mb-2 mt-3">
                <Col xl={12}>
                  <div className="">
                    <InputTextarea
                      className="w-full"
                      value={popTextares}
                      onChange={e => setPopTextares(e.target.value)}
                      placeholder="Interview Test"
                      rows={3}
                      cols={20}
                    />
                  </div>
                </Col>
              </Row>
            </div>

            <div>
              <Row className="mb-2">
                <Col lg={6}>
                  <Row>
                    <Col xl={6}>
                      <div className="p-field flex flex-column">
                        <label For="Priority" className=" block">
                          Priority
                        </label>
                        <Dropdown
                          value={priority}
                          onChange={e => setPriority(e.value)}
                          options={priorityValue}
                          optionLabel="name"
                          placeholder="Priority"
                          className="w-full search-option"
                        />
                      </div>
                    </Col>
                    <Col xl={6}>
                      <Row className="mt-2">
                        <Col xl={6}>
                          <div className="d-flex align-items-center mt-4">
                            <Checkbox
                              inputId="checkbox"
                              checked={popchecked}
                              onChange={handlePopupCheckbox}
                            />
                            <label htmlFor="username" className="ms-1 mt-2">
                              Completed
                            </label>
                          </div>
                        </Col>

                        <Col xl={6}>
                          <div className="d-flex align-items-center mt-4">
                            <Checkbox
                              inputId="checkbox"
                              checked={popchecked2}
                              onChange={handlePopupCheckbox2}
                            />
                            <label htmlFor="username" className="ms-1 mt-2">
                              Private
                            </label>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
                <Col xl={6}>
                  <label htmlFor="username">User Id's</label>
                  <Chips
                    value={userid}
                    onChange={e => setUserid(e.value)}
                    itemTemplate={customChip}
                    className="w-full"
                  />
                </Col>
              </Row>
            </div>

            <Row className="">
              <Col xl={12}>
                <div className="d-flex justify-content-end">
                  <button
                    type="submit"
                    class="btn btn-primary waves-effect waves-light btn btn-primary me-2 btn-main"
                  >
                    <i className="pi pi-save me-1"></i>
                    Save
                  </button>
                  <button
                    color="primary"
                    className="btn btn-primary waves-effect waves-light me-2 cancel-outlinebtn"
                  >
                    <i className="pi pi-times me-1"></i>
                    Cancel
                  </button>
                </div>
              </Col>
            </Row>
          </p>
        </form>
      </Dialog>
      {/* Interview schedule end */}

      {/* Interview schedule call start */}
      <Dialog
        header="Schedule Call"
        visible={interviewpopCall}
        className="interview-popup"
        style={{ width: "50vw" }}
        // onHide={() => { if (!interviewpop) return; SetInterviewpop(false); }}
        onHide={() => {
          SetInterviewpopCall(false)
        }}
      >
        <form>
          <p className="bg-form">
            {/* <div className="mb-4"> */}
            <Row className="mb-2">
              <Col xl={6}>
                <div className="p-field flex flex-column">
                  <label htmlFor="interview">Type</label>
                  <InputText
                    disabled
                    value={intertype3}
                    onChange={e => setintertype1(e.target.value)}
                  />
                </div>
              </Col>

              <Col xl={6}>
                <div className="p-field flex flex-column">
                  <label htmlFor="integer" className=" block">
                    Sub-Type
                  </label>
                  {/* <Dropdown
                      value={subtype}
                      onChange={e => setSubtype(e.value)}
                      options={typeCall}
                      optionLabel="name"
                      placeholder="Subtype"
                      className="w-full search-option"
                    /> */}

                  <WorkType1
                    initialWorkTypes={statusWorkTypes1}
                    dropdownWorkTypes={statusDropdownWorkTypes1}
                    onWorkTypesChange={handleStatusWorkTypesChange1}
                    onSelectionChange={handleStatusSelectionChange1}
                  />


                </div>
              </Col>
            </Row>

            <Row>
              <Col xl={6}>
                <Row className="mb-1">
                  <Col xl={6}>
                    <div className="p-field flex-auto">
                      <label htmlFor="buttondisplay" className="block">
                        Start date
                      </label>
                      <Calendar
                        value={startdate}
                        onChange={e => setStartdate(e.value)}
                        showIcon
                        dateFormat="dd/mm/yy"
                      />
                    </div>
                  </Col>

                  <Col xl={6}>
                    <div className="p-field flex-auto">
                      <label htmlFor="buttondisplay" className="block">
                        Time
                      </label>
                      <Calendar
                        value={starttime}
                        onChange={e => setStarttime(e.value)}
                        showIcon
                        timeOnly
                        icon={() => <i className="pi pi-clock" />}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>

              <Col xl={6}>
                <Row className="mb-2">
                  <Col xl={6}>
                    <div className="flex-auto">
                      <label htmlFor="buttondisplay" className="block">
                        End date
                      </label>
                      <Calendar
                        value={enddate}
                        onChange={e => setenddate(e.value)}
                        showIcon
                        dateFormat="dd/mm/yy"
                      />
                    </div>
                  </Col>

                  <Col xl={6}>
                    <div className="flex-auto">
                      <label htmlFor="buttondisplay" className="block">
                        Time
                      </label>

                      <Calendar
                        value={endtime}
                        onChange={e => setendtime(e.value)}
                        showIcon
                        timeOnly
                        icon={() => <i className="pi pi-clock" />}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
            {/* </div> */}

            {/* <div className="mb-4"> */}
            <Row className="mb-0">

              <Col xl={6}>
                <div className="p-field flex flex-column">
                  <label For="Candidate">Project</label>
                  <MultiSelect
                    value={condidatevalu}
                    disabled
                    onChange={e => {
                      condidatelist(e)
                    }}
                    options={typeInterviewcondi}
                    optionLabel="name"
                    placeholder={`AI Generator (Proj-101)`}
                    maxSelectedLabels={0}
                    className="w-full"
                  />
                </div>
              </Col>




              <LinkJobsPopup />
            </Row>

            <Row className="mb-2">
              {/* <Col xl={6}>
                  <div className="p-field flex flex-column">
                    <label For="Candidate">Project</label>
                    <MultiSelect
                      value={condidatevalu}
                      disabled
                      onChange={e => {
                        condidatelist(e)
                      }}
                      options={typeInterviewcondi}
                      optionLabel="name"
                      placeholder={`AI Generator`}
                      maxSelectedLabels={0}
                      className="w-full"
                    />
                  </div>
                </Col> */}

              {/* <Col xl={6}>
                  <div className="flex flex-column">
                    <label For="Priority">Project Status</label>
                   
                     <WorkType1
                       initialWorkTypes={statusWorkTypes}
                      dropdownWorkTypes={statusDropdownWorkTypes}
                      onWorkTypesChange={handleStatusWorkTypesChange}
                      onSelectionChange={handleStatusSelectionChange}
                    />
                  </div>
                </Col> */}
              <Col xl={6}>
                <div className="p-field flex flex-column">
                  <label htmlFor="username">Subject</label>
                  <InputText
                    placeholder="Call Request to Discuss Project Updates"
                    value={subjectval}
                    onChange={e => setsubjectval(e.target.value)}
                  />
                </div>
              </Col>
            </Row>

            <Row className="mb-1 mt-3">
              <Col xl={12}>
                <div className="">
                  <InputTextarea
                    className="w-full"
                    value={popTextares}
                    onChange={e => setPopTextares(e.target.value)}
                    placeholder="This is to schedule a quick sync-up regarding our ongoing tasks and any blockers. We’ll keep it short and focused on progress tracking and planning ahead."
                    rows={3}
                    cols={20}
                  />
                </div>
              </Col>
            </Row>
            {/* </div> */}

            <div>
              <Row className="mb-2">
                <Col lg={6}>
                  <Row>
                    <Col xl={6}>
                      <div className="p-field flex flex-column">
                        <label For="Priority" className=" block">
                          Priority
                        </label>
                        <Dropdown
                          value={priority}
                          onChange={e => setPriority(e.value)}
                          options={priorityValue}
                          optionLabel="name"
                          placeholder="High"
                          className="w-full search-option"
                        />
                      </div>
                    </Col>
                    <Col xl={6}>
                      <Row className="mt-2">
                        <Col xl={6}>
                          <div className="d-flex align-items-center mt-4">
                            <Checkbox
                              inputId="checkbox"
                              checked={popchecked}
                              onChange={handlePopupCheckbox}

                            />
                            <label htmlFor="username" className="ms-1 mt-2">
                              Completed
                            </label>
                          </div>
                        </Col>

                        <Col xl={6}>
                          <div className="d-flex align-items-center mt-4">
                            <Checkbox
                              inputId="checkbox"
                              checked={popchecked2}
                              onChange={handlePopupCheckbox2}
                            />
                            <label htmlFor="username" className="ms-1 mt-2">
                              Private
                            </label>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
                {popchecked2 && (

                  <Col xl={6}>
                    <label htmlFor="username">User Id's</label>
                    <MultiSelect
                      value={privateDrop}
                      onChange={e => setPrivateDrop(e.value)}
                      options={PrivetDropdownValues}
                      optionLabel="name"
                      optionValue="value"
                      placeholder="Select Users"
                      className="w-full"
                      style={{ border: '1px solid #ced4da' }}
                      display="comma"
                      maxSelectedLabels={3}
                    />
                  </Col>
                  // <Col xl={6}>
                  //   <label htmlFor="username">User Id's</label>
                  //   <Chips
                  //     value={userid}
                  //     onChange={e => setUserid(e.value)}
                  //     itemTemplate={customChip}
                  //     className="w-full"
                  //   />
                  // </Col>
                )}
              </Row>

              {popchecked && (
                <Row>
                  <Col xl={12} className="mt-2">
                    <label className="mb-1">Minutes of Meeting</label>
                    <div className="schedule-editor">
                      <Editor
                        value={scheduleText}
                        onTextChange={e => setScheduleText(e.htmlValue)}
                        style={{ height: "auto" }}
                      />
                    </div>
                  </Col>
                </Row>
              )}
            </div>

            <Row className="mt-3">
              <Col xl={12}>
                <div className="d-flex justify-content-end">
                  <button
                    type="submit"
                    class="btn btn-primary waves-effect waves-light btn btn-primary me-2 btn-main"
                  >
                    <i className="pi pi-save me-1"></i>
                    Save
                  </button>
                  <button
                    color="primary"
                    className="btn btn-primary waves-effect waves-light me-2 cancel-outlinebtn"
                  >
                    <i className="pi pi-times me-1"></i>
                    Cancel
                  </button>
                </div>
              </Col>
            </Row>
          </p>
        </form>
      </Dialog>
      {/* Interview schedule call end */}

      {/* Interview schedule meeting start */}
      <Dialog
        header="Schedule Meeting"
        visible={interviewpopMeeting}
        className="interview-popup"
        style={{ width: "50vw" }}
        onHide={() => {
          SetInterviewpopMeeting(false)
        }}
      >
        <form>

          <p className="bg-form">
            {/* <div className="mb-4"> */}
            <Row className="mb-2">
              <Col xl={6}>
                <div className="p-field flex flex-column">
                  <label htmlFor="interview">Type</label>
                  <InputText
                    disabled
                    value={intertype2}
                    onChange={e => setintertype(e.target.value)}
                  />
                </div>
              </Col>

              <Col xl={6}>
                <div className="p-field flex flex-column">
                  <label htmlFor="integer" className=" block">
                    Sub-Type
                  </label>
                  {/* <Dropdown
                      value={subtype}
                      onChange={e => setSubtype(e.value)}
                      options={typeCall}
                      optionLabel="name"
                      placeholder="Subtype"
                      className="w-full search-option"
                    /> */}

                  <WorkType1
                    initialWorkTypes={statusWorkTypes1}
                    dropdownWorkTypes={statusDropdownWorkTypes1}
                    onWorkTypesChange={handleStatusWorkTypesChange1}
                    onSelectionChange={handleStatusSelectionChange1}
                  />


                </div>
              </Col>
            </Row>

            <Row>
              <Col xl={6}>
                <Row className="mb-1">
                  <Col xl={6}>
                    <div className="p-field flex-auto">
                      <label htmlFor="buttondisplay" className="block">
                        Start date
                      </label>
                      <Calendar
                        value={startdate}
                        onChange={e => setStartdate(e.value)}
                        showIcon
                        dateFormat="dd/mm/yy"
                      />
                    </div>
                  </Col>

                  <Col xl={6}>
                    <div className="p-field flex-auto">
                      <label htmlFor="buttondisplay" className="block">
                        Time
                      </label>
                      <Calendar
                        value={starttime}
                        onChange={e => setStarttime(e.value)}
                        showIcon
                        timeOnly
                        icon={() => <i className="pi pi-clock" />}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>

              <Col xl={6}>
                <Row className="mb-2">
                  <Col xl={6}>
                    <div className="flex-auto">
                      <label htmlFor="buttondisplay" className="block">
                        End date
                      </label>
                      <Calendar
                        value={enddate}
                        onChange={e => setenddate(e.value)}
                        showIcon
                        dateFormat="dd/mm/yy"
                      />
                    </div>
                  </Col>

                  <Col xl={6}>
                    <div className="flex-auto">
                      <label htmlFor="buttondisplay" className="block">
                        Time
                      </label>

                      <Calendar
                        value={endtime}
                        onChange={e => setendtime(e.value)}
                        showIcon
                        timeOnly
                        icon={() => <i className="pi pi-clock" />}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
            {/* </div> */}

            {/* <div className="mb-4"> */}
            <Row className="mb-0">

              <Col xl={6}>
                <div className="p-field flex flex-column">
                  <label For="Candidate">Project</label>
                  <MultiSelect
                    value={condidatevalu}
                    disabled
                    onChange={e => {
                      condidatelist(e)
                    }}
                    options={typeInterviewcondi}
                    optionLabel="name"
                    placeholder={`AI Generator (Proj-101)`}
                    maxSelectedLabels={0}
                    className="w-full"
                  />
                </div>
              </Col>




              <LinkJobsPopup />
            </Row>

            <Row className="mb-2">
              {/* <Col xl={6}>
                  <div className="p-field flex flex-column">
                    <label For="Candidate">Project</label>
                    <MultiSelect
                      value={condidatevalu}
                      disabled
                      onChange={e => {
                        condidatelist(e)
                      }}
                      options={typeInterviewcondi}
                      optionLabel="name"
                      placeholder={`AI Generator`}
                      maxSelectedLabels={0}
                      className="w-full"
                    />
                  </div>
                </Col> */}

              {/* <Col xl={6}>
                  <div className="flex flex-column">
                    <label For="Priority">Project Status</label>
                   
                     <WorkType1
                       initialWorkTypes={statusWorkTypes}
                      dropdownWorkTypes={statusDropdownWorkTypes}
                      onWorkTypesChange={handleStatusWorkTypesChange}
                      onSelectionChange={handleStatusSelectionChange}
                    />
                  </div>
                </Col> */}
              <Col xl={6}>
                <div className="p-field flex flex-column">
                  <label htmlFor="username">Subject</label>
                  <InputText
                    placeholder="Call Request to Discuss Project Updates"
                    value={subjectval}
                    onChange={e => setsubjectval(e.target.value)}
                  />
                </div>
              </Col>
            </Row>

            <Row className="mb-1 mt-3">
              <Col xl={12}>
                <div className="">
                  <InputTextarea
                    className="w-full"
                    value={popTextares}
                    onChange={e => setPopTextares(e.target.value)}
                    placeholder="This is to schedule a quick sync-up regarding our ongoing tasks and any blockers. We’ll keep it short and focused on progress tracking and planning ahead."
                    rows={3}
                    cols={20}
                  />
                </div>
              </Col>
            </Row>
            {/* </div> */}

            <div>
              <Row className="mb-2">
                <Col lg={6}>
                  <Row>
                    <Col xl={6}>
                      <div className="p-field flex flex-column">
                        <label For="Priority" className=" block">
                          Priority
                        </label>
                        <Dropdown
                          value={priority}
                          onChange={e => setPriority(e.value)}
                          options={priorityValue}
                          optionLabel="name"
                          placeholder="High"
                          className="w-full search-option"
                        />
                      </div>
                    </Col>
                    <Col xl={6}>
                      <Row className="mt-2">
                        <Col xl={6}>
                          <div className="d-flex align-items-center mt-4">
                            <Checkbox
                              inputId="checkbox"
                              checked={popchecked}
                              onChange={handlePopupCheckbox}

                            />
                            <label htmlFor="username" className="ms-1 mt-2">
                              Completed
                            </label>
                          </div>
                        </Col>

                        <Col xl={6}>
                          <div className="d-flex align-items-center mt-4">
                            <Checkbox
                              inputId="checkbox"
                              checked={popchecked2}
                              onChange={handlePopupCheckbox2}
                            />
                            <label htmlFor="username" className="ms-1 mt-2">
                              Private
                            </label>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
                {popchecked2 && (

                  <Col xl={6}>
                    <label htmlFor="username">User Id's</label>
                    <MultiSelect
                      value={privateDrop}
                      onChange={e => setPrivateDrop(e.value)}
                      options={PrivetDropdownValues}
                      optionLabel="name"
                      optionValue="value"
                      placeholder="Select Users"
                      className="w-full"
                      style={{ border: '1px solid #ced4da' }}
                      display="comma"
                      maxSelectedLabels={3}
                    />
                  </Col>
                  // <Col xl={6}>
                  //   <label htmlFor="username">User Id's</label>
                  //   <Chips
                  //     value={userid}
                  //     onChange={e => setUserid(e.value)}
                  //     itemTemplate={customChip}
                  //     className="w-full"
                  //   />
                  // </Col>
                )}
              </Row>

              {popchecked && (
                <Row>
                  <Col xl={12} className="mt-2">
                    <label className="mb-1">Minutes of Meeting</label>
                    <div className="schedule-editor">
                      <Editor
                        value={scheduleText}
                        onTextChange={e => setScheduleText(e.htmlValue)}
                        style={{ height: "auto" }}
                      />
                    </div>
                  </Col>
                </Row>
              )}
            </div>

            <Row className="mt-3">
              <Col xl={12}>
                <div className="d-flex justify-content-end">
                  <button
                    type="submit"
                    class="btn btn-primary waves-effect waves-light btn btn-primary me-2 btn-main"
                  >
                    <i className="pi pi-save me-1"></i>
                    Save
                  </button>
                  <button
                    color="primary"
                    className="btn btn-primary waves-effect waves-light me-2 cancel-outlinebtn"
                  >
                    <i className="pi pi-times me-1"></i>
                    Cancel
                  </button>
                </div>
              </Col>
            </Row>
          </p>

        </form>
      </Dialog>
      {/* Interview schedule meeting end */}

      {/* Interview schedule Task start */}
      <Dialog
        header="Schedule Task"
        visible={interviewpopTask}
        className="interview-popup"
        style={{ width: "50vw" }}
        // onHide={() => { if (!interviewpop) return; SetInterviewpop(false); }}
        onHide={() => {
          SetInterviewpopTask(false)
        }}
      >
        <form>


          <p className="bg-form">
            {/* <div className="mb-4"> */}
            <Row className="mb-2">
              <Col xl={6}>
                <div className="p-field flex flex-column">
                  <label htmlFor="interview">Type</label>
                  <InputText
                    disabled
                    value={intertype4}
                    onChange={e => setintertype1(e.target.value)}
                  />
                </div>
              </Col>

              <Col xl={6}>
                <div className="p-field flex flex-column">
                  <label htmlFor="integer" className=" block">
                    Sub-Type
                  </label>
                  {/* <Dropdown
                      value={subtype}
                      onChange={e => setSubtype(e.value)}
                      options={typeCall}
                      optionLabel="name"
                      placeholder="Subtype"
                      className="w-full search-option"
                    /> */}

                  <WorkType1
                    initialWorkTypes={statusWorkTypes1}
                    dropdownWorkTypes={statusDropdownWorkTypes1}
                    onWorkTypesChange={handleStatusWorkTypesChange1}
                    onSelectionChange={handleStatusSelectionChange1}
                  />


                </div>
              </Col>
            </Row>

            <Row>
              <Col xl={6}>
                <Row className="mb-1">
                  <Col xl={6}>
                    <div className="p-field flex-auto">
                      <label htmlFor="buttondisplay" className="block">
                        Start date
                      </label>
                      <Calendar
                        value={startdate}
                        onChange={e => setStartdate(e.value)}
                        showIcon
                        dateFormat="dd/mm/yy"
                      />
                    </div>
                  </Col>

                  <Col xl={6}>
                    <div className="p-field flex-auto">
                      <label htmlFor="buttondisplay" className="block">
                        Time
                      </label>
                      <Calendar
                        value={starttime}
                        onChange={e => setStarttime(e.value)}
                        showIcon
                        timeOnly
                        icon={() => <i className="pi pi-clock" />}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>

              <Col xl={6}>
                <Row className="mb-2">
                  <Col xl={6}>
                    <div className="flex-auto">
                      <label htmlFor="buttondisplay" className="block">
                        End date
                      </label>
                      <Calendar
                        value={enddate}
                        onChange={e => setenddate(e.value)}
                        showIcon
                        dateFormat="dd/mm/yy"
                      />
                    </div>
                  </Col>

                  <Col xl={6}>
                    <div className="flex-auto">
                      <label htmlFor="buttondisplay" className="block">
                        Time
                      </label>

                      <Calendar
                        value={endtime}
                        onChange={e => setendtime(e.value)}
                        showIcon
                        timeOnly
                        icon={() => <i className="pi pi-clock" />}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
            {/* </div> */}

            {/* <div className="mb-4"> */}
            <Row className="mb-0">

              <Col xl={6}>
                <div className="p-field flex flex-column">
                  <label For="Candidate">Project</label>
                  <MultiSelect
                    value={condidatevalu}
                    disabled
                    onChange={e => {
                      condidatelist(e)
                    }}
                    options={typeInterviewcondi}
                    optionLabel="name"
                    placeholder={`AI Generator (Proj-101)`}
                    maxSelectedLabels={0}
                    className="w-full"
                  />
                </div>
              </Col>




              <LinkJobsPopup />
            </Row>

            <Row className="mb-2">
              {/* <Col xl={6}>
                  <div className="p-field flex flex-column">
                    <label For="Candidate">Project</label>
                    <MultiSelect
                      value={condidatevalu}
                      disabled
                      onChange={e => {
                        condidatelist(e)
                      }}
                      options={typeInterviewcondi}
                      optionLabel="name"
                      placeholder={`AI Generator`}
                      maxSelectedLabels={0}
                      className="w-full"
                    />
                  </div>
                </Col> */}

              {/* <Col xl={6}>
                  <div className="flex flex-column">
                    <label For="Priority">Project Status</label>
                   
                     <WorkType1
                       initialWorkTypes={statusWorkTypes}
                      dropdownWorkTypes={statusDropdownWorkTypes}
                      onWorkTypesChange={handleStatusWorkTypesChange}
                      onSelectionChange={handleStatusSelectionChange}
                    />
                  </div>
                </Col> */}
              <Col xl={6}>
                <div className="p-field flex flex-column">
                  <label htmlFor="username">Subject</label>
                  <InputText
                    placeholder="Call Request to Discuss Project Updates"
                    value={subjectval}
                    onChange={e => setsubjectval(e.target.value)}
                  />
                </div>
              </Col>
            </Row>

            <Row className="mb-1 mt-3">
              <Col xl={12}>
                <div className="">
                  <InputTextarea
                    className="w-full"
                    value={popTextares}
                    onChange={e => setPopTextares(e.target.value)}
                    placeholder="This is to schedule a quick sync-up regarding our ongoing tasks and any blockers. We’ll keep it short and focused on progress tracking and planning ahead."
                    rows={3}
                    cols={20}
                  />
                </div>
              </Col>
            </Row>
            {/* </div> */}

            <div>
              <Row className="mb-2">
                <Col lg={6}>
                  <Row>
                    <Col xl={6}>
                      <div className="p-field flex flex-column">
                        <label For="Priority" className=" block">
                          Priority
                        </label>
                        <Dropdown
                          value={priority}
                          onChange={e => setPriority(e.value)}
                          options={priorityValue}
                          optionLabel="name"
                          placeholder="High"
                          className="w-full search-option"
                        />
                      </div>
                    </Col>
                    <Col xl={6}>
                      <Row className="mt-2">
                        <Col xl={6}>
                          <div className="d-flex align-items-center mt-4">
                            <Checkbox
                              inputId="checkbox"
                              checked={popchecked}
                              onChange={handlePopupCheckbox}

                            />
                            <label htmlFor="username" className="ms-1 mt-2">
                              Completed
                            </label>
                          </div>
                        </Col>

                        <Col xl={6}>
                          <div className="d-flex align-items-center mt-4">
                            <Checkbox
                              inputId="checkbox"
                              checked={popchecked2}
                              onChange={handlePopupCheckbox2}
                            />
                            <label htmlFor="username" className="ms-1 mt-2">
                              Private
                            </label>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
                {popchecked2 && (

                  <Col xl={6}>
                    <label htmlFor="username">User Id's</label>
                    <MultiSelect
                      value={privateDrop}
                      onChange={e => setPrivateDrop(e.value)}
                      options={PrivetDropdownValues}
                      optionLabel="name"
                      optionValue="value"
                      placeholder="Select Users"
                      className="w-full"
                      style={{ border: '1px solid #ced4da' }}
                      display="comma"
                      maxSelectedLabels={3}
                    />
                  </Col>
                  // <Col xl={6}>
                  //   <label htmlFor="username">User Id's</label>
                  //   <Chips
                  //     value={userid}
                  //     onChange={e => setUserid(e.value)}
                  //     itemTemplate={customChip}
                  //     className="w-full"
                  //   />
                  // </Col>
                )}
              </Row>

              {popchecked && (
                <Row>
                  <Col xl={12} className="mt-2">
                    <label className="mb-1">Minutes of Meeting</label>
                    <div className="schedule-editor">
                      <Editor
                        value={scheduleText}
                        onTextChange={e => setScheduleText(e.htmlValue)}
                        style={{ height: "auto" }}
                      />
                    </div>
                  </Col>
                </Row>
              )}
            </div>

            <Row className="mt-3">
              <Col xl={12}>
                <div className="d-flex justify-content-end">
                  <button
                    type="submit"
                    class="btn btn-primary waves-effect waves-light btn btn-primary me-2 btn-main"
                  >
                    <i className="pi pi-save me-1"></i>
                    Save
                  </button>
                  <button
                    color="primary"
                    className="btn btn-primary waves-effect waves-light me-2 cancel-outlinebtn"
                  >
                    <i className="pi pi-times me-1"></i>
                    Cancel
                  </button>
                </div>
              </Col>
            </Row>
          </p>

        </form>
      </Dialog>
      {/* Interview schedule Task end */}

      {/* Interview schedule Event start */}
      <Dialog
        header="Schedule Event"
        visible={interviewpopEvent}
        className="interview-popup"
        style={{ width: "50vw" }}
        // onHide={() => { if (!interviewpop) return; SetInterviewpop(false); }}
        onHide={() => {
          SetInterviewpopEvent(false)
        }}
      >
        <form>



          <p className="bg-form">
            {/* <div className="mb-4"> */}
            <Row className="mb-2">
              <Col xl={6}>
                <div className="p-field flex flex-column">
                  <label htmlFor="interview">Type</label>
                  <InputText
                    disabled
                    value={intertype4}
                    onChange={e => setintertype4(e.target.value)}
                  />
                </div>
              </Col>

              <Col xl={6}>
                <div className="p-field flex flex-column">
                  <label htmlFor="integer" className=" block">
                    Sub-Type
                  </label>
                  {/* <Dropdown
                      value={subtype}
                      onChange={e => setSubtype(e.value)}
                      options={typeCall}
                      optionLabel="name"
                      placeholder="Subtype"
                      className="w-full search-option"
                    /> */}

                  <WorkType1
                    initialWorkTypes={statusWorkTypes1}
                    dropdownWorkTypes={statusDropdownWorkTypes1}
                    onWorkTypesChange={handleStatusWorkTypesChange1}
                    onSelectionChange={handleStatusSelectionChange1}
                  />


                </div>
              </Col>
            </Row>

            <Row>
              <Col xl={6}>
                <Row className="mb-1">
                  <Col xl={6}>
                    <div className="p-field flex-auto">
                      <label htmlFor="buttondisplay" className="block">
                        Start date
                      </label>
                      <Calendar
                        value={startdate}
                        onChange={e => setStartdate(e.value)}
                        showIcon
                        dateFormat="dd/mm/yy"
                      />
                    </div>
                  </Col>

                  <Col xl={6}>
                    <div className="p-field flex-auto">
                      <label htmlFor="buttondisplay" className="block">
                        Time
                      </label>
                      <Calendar
                        value={starttime}
                        onChange={e => setStarttime(e.value)}
                        showIcon
                        timeOnly
                        icon={() => <i className="pi pi-clock" />}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>

              <Col xl={6}>
                <Row className="mb-2">
                  <Col xl={6}>
                    <div className="flex-auto">
                      <label htmlFor="buttondisplay" className="block">
                        End date
                      </label>
                      <Calendar
                        value={enddate}
                        onChange={e => setenddate(e.value)}
                        showIcon
                        dateFormat="dd/mm/yy"
                      />
                    </div>
                  </Col>

                  <Col xl={6}>
                    <div className="flex-auto">
                      <label htmlFor="buttondisplay" className="block">
                        Time
                      </label>

                      <Calendar
                        value={endtime}
                        onChange={e => setendtime(e.value)}
                        showIcon
                        timeOnly
                        icon={() => <i className="pi pi-clock" />}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
            {/* </div> */}

            {/* <div className="mb-4"> */}
            <Row className="mb-0">

              <Col xl={6}>
                <div className="p-field flex flex-column">
                  <label For="Candidate">Project</label>
                  <MultiSelect
                    value={condidatevalu}
                    disabled
                    onChange={e => {
                      condidatelist(e)
                    }}
                    options={typeInterviewcondi}
                    optionLabel="name"
                    placeholder={`AI Generator (Proj-101)`}
                    maxSelectedLabels={0}
                    className="w-full"
                  />
                </div>
              </Col>




              <LinkJobsPopup />
            </Row>

            <Row className="mb-2">
              {/* <Col xl={6}>
                  <div className="p-field flex flex-column">
                    <label For="Candidate">Project</label>
                    <MultiSelect
                      value={condidatevalu}
                      disabled
                      onChange={e => {
                        condidatelist(e)
                      }}
                      options={typeInterviewcondi}
                      optionLabel="name"
                      placeholder={`AI Generator`}
                      maxSelectedLabels={0}
                      className="w-full"
                    />
                  </div>
                </Col> */}

              {/* <Col xl={6}>
                  <div className="flex flex-column">
                    <label For="Priority">Project Status</label>
                   
                     <WorkType1
                       initialWorkTypes={statusWorkTypes}
                      dropdownWorkTypes={statusDropdownWorkTypes}
                      onWorkTypesChange={handleStatusWorkTypesChange}
                      onSelectionChange={handleStatusSelectionChange}
                    />
                  </div>
                </Col> */}
              <Col xl={6}>
                <div className="p-field flex flex-column">
                  <label htmlFor="username">Subject</label>
                  <InputText
                    placeholder="Call Request to Discuss Project Updates"
                    value={subjectval}
                    onChange={e => setsubjectval(e.target.value)}
                  />
                </div>
              </Col>
            </Row>

            <Row className="mb-1 mt-3">
              <Col xl={12}>
                <div className="">
                  <InputTextarea
                    className="w-full"
                    value={popTextares}
                    onChange={e => setPopTextares(e.target.value)}
                    placeholder="This is to schedule a quick sync-up regarding our ongoing tasks and any blockers. We’ll keep it short and focused on progress tracking and planning ahead."
                    rows={3}
                    cols={20}
                  />
                </div>
              </Col>
            </Row>
            {/* </div> */}

            <div>
              <Row className="mb-2">
                <Col lg={6}>
                  <Row>
                    <Col xl={6}>
                      <div className="p-field flex flex-column">
                        <label For="Priority" className=" block">
                          Priority
                        </label>
                        <Dropdown
                          value={priority}
                          onChange={e => setPriority(e.value)}
                          options={priorityValue}
                          optionLabel="name"
                          placeholder="High"
                          className="w-full search-option"
                        />
                      </div>
                    </Col>
                    <Col xl={6}>
                      <Row className="mt-2">
                        <Col xl={6}>
                          <div className="d-flex align-items-center mt-4">
                            <Checkbox
                              inputId="checkbox"
                              checked={popchecked}
                              onChange={handlePopupCheckbox}

                            />
                            <label htmlFor="username" className="ms-1 mt-2">
                              Completed
                            </label>
                          </div>
                        </Col>

                        <Col xl={6}>
                          <div className="d-flex align-items-center mt-4">
                            <Checkbox
                              inputId="checkbox"
                              checked={popchecked2}
                              onChange={handlePopupCheckbox2}
                            />
                            <label htmlFor="username" className="ms-1 mt-2">
                              Private
                            </label>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
                {popchecked2 && (

                  <Col xl={6}>
                    <label htmlFor="username">User Id's</label>
                    <MultiSelect
                      value={privateDrop}
                      onChange={e => setPrivateDrop(e.value)}
                      options={PrivetDropdownValues}
                      optionLabel="name"
                      optionValue="value"
                      placeholder="Select Users"
                      className="w-full"
                      style={{ border: '1px solid #ced4da' }}
                      display="comma"
                      maxSelectedLabels={3}
                    />
                  </Col>
                  // <Col xl={6}>
                  //   <label htmlFor="username">User Id's</label>
                  //   <Chips
                  //     value={userid}
                  //     onChange={e => setUserid(e.value)}
                  //     itemTemplate={customChip}
                  //     className="w-full"
                  //   />
                  // </Col>
                )}
              </Row>

              {popchecked && (
                <Row>
                  <Col xl={12} className="mt-2">
                    <label className="mb-1">Minutes of Meeting</label>
                    <div className="schedule-editor">
                      <Editor
                        value={scheduleText}
                        onTextChange={e => setScheduleText(e.htmlValue)}
                        style={{ height: "auto" }}
                      />
                    </div>
                  </Col>
                </Row>
              )}
            </div>

            <Row className="mt-3">
              <Col xl={12}>
                <div className="d-flex justify-content-end">
                  <button
                    type="submit"
                    class="btn btn-primary waves-effect waves-light btn btn-primary me-2 btn-main"
                  >
                    <i className="pi pi-save me-1"></i>
                    Save
                  </button>
                  <button
                    color="primary"
                    className="btn btn-primary waves-effect waves-light me-2 cancel-outlinebtn"
                  >
                    <i className="pi pi-times me-1"></i>
                    Cancel
                  </button>
                </div>
              </Col>
            </Row>
          </p>

        </form>
      </Dialog>
      {/* Interview schedule Event end */}

      {/* Interview schedule Other start */}
      <Dialog
        header="Schedule"
        visible={interviewpopOther}
        className="interview-popup"
        style={{ width: "50vw" }}
        onHide={() => {
          SetInterviewpopOther(false)
        }}
      >
        <form>
          <p className="bg-form">
            <div className="mb-4">
              <Row className="mb-2">
                <Col xl={6}>
                  <div className="p-field flex flex-column">
                    <label htmlFor="interview">Type</label>
                    <InputText
                      disabled
                      value={intertype5}
                      onChange={e => setintertype1(e.target.value)}
                    />
                  </div>
                </Col>

                <Col xl={6}>
                  <div className="p-field flex flex-column">
                    <label htmlFor="integer" className=" block">
                      Sub-Type
                    </label>
                    <Dropdown
                      value={subtype}
                      onChange={e => setSubtype(e.value)}
                      options={typeInterview}
                      optionLabel="name"
                      placeholder="Subtype"
                      className="w-full search-option"
                    />
                  </div>
                </Col>
              </Row>

              <Row>
                <Col xl={6}>
                  <Row className="mb-2">
                    <Col xl={6}>
                      <div className="p-field flex-auto">
                        <label htmlFor="buttondisplay" className="block">
                          Start date
                        </label>
                        <Calendar
                          value={startdate}
                          onChange={e => setStartdate(e.value)}
                          showIcon
                        />
                      </div>
                    </Col>

                    <Col xl={6}>
                      <div className="p-field flex-auto">
                        <label htmlFor="buttondisplay" className="block">
                          Time
                        </label>
                        <Calendar
                          value={starttime}
                          onChange={e => setStarttime(e.value)}
                          showIcon
                          timeOnly
                          icon={() => <i className="pi pi-clock" />}
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>

                <Col xl={6}>
                  <Row className="mb-2">
                    <Col xl={6}>
                      <div className="flex-auto">
                        <label htmlFor="buttondisplay" className="block">
                          End date
                        </label>
                        <Calendar
                          value={enddate}
                          onChange={e => setenddate(e.value)}
                          showIcon
                        />
                      </div>
                    </Col>

                    <Col xl={6}>
                      <div className="flex-auto">
                        <label htmlFor="buttondisplay" className="block">
                          Time
                        </label>

                        <Calendar
                          value={endtime}
                          onChange={e => setendtime(e.value)}
                          showIcon
                          timeOnly
                          icon={() => <i className="pi pi-clock" />}
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>

            <div className="mb-4">
              <Row className="mb-2">
                <Col xl={6}>
                  <div className="flex flex-column">
                    <label For="Priority">Project</label>
                    <Dropdown
                      value={subtypeget}
                      onChange={e => setsubtypeget(e.value)}
                      options={jobStatusDrop}
                      optionLabel="name"
                      placeholder="Select a Status"
                      className="w-full search-option"
                    />
                  </div>
                </Col>

                <LinkContactsPopup />
              </Row>

              <Row className="mb-2">
                <Col xl={6}>
                  <div className="p-field flex flex-column">
                    <label For="Candidate">Task</label>
                    <MultiSelect
                      value={condidatevalu}
                      disabled
                      onChange={e => {
                        condidatelist(e)
                      }}
                      options={typeInterviewcondi}
                      optionLabel="name"
                      placeholder={`Lavankumar Kalvala`}
                      maxSelectedLabels={0}
                      className="w-full"
                    />
                  </div>
                </Col>
                <Col xl={6}>
                  <div className="p-field flex flex-column">
                    <label htmlFor="username">Subject</label>
                    <InputText
                      placeholder="Subject"
                      value={subjectval}
                      onChange={e => setsubjectval(e.target.value)}
                    />
                  </div>
                </Col>
              </Row>

              <Row className="mb-2 mt-3">
                <Col xl={12}>
                  <div className="">
                    <InputTextarea
                      className="w-full"
                      value={popTextares}
                      onChange={e => setPopTextares(e.target.value)}
                      placeholder="Test"
                      rows={3}
                      cols={20}
                    />
                  </div>
                </Col>
              </Row>
            </div>

            <div>
              <Row className="mb-2">
                <Col lg={6}>
                  <Row>
                    <Col xl={6}>
                      <div className="p-field flex flex-column">
                        <label For="Priority" className=" block">
                          Priority
                        </label>
                        <Dropdown
                          value={priority}
                          onChange={e => setPriority(e.value)}
                          options={priorityValue}
                          optionLabel="name"
                          placeholder="Priority"
                          className="w-full search-option"
                        />
                      </div>
                    </Col>
                    <Col xl={6}>
                      <Row className="mt-2">
                        <Col xl={6}>
                          <div className="d-flex align-items-center mt-4">
                            <Checkbox
                              inputId="checkbox"
                              checked={popchecked}
                              onChange={handlePopupCheckbox}
                            />
                            <label htmlFor="username" className="ms-1 mt-2">
                              Completed
                            </label>
                          </div>
                        </Col>

                        <Col xl={6}>
                          <div className="d-flex align-items-center mt-4">
                            <Checkbox
                              inputId="checkbox"
                              checked={popchecked2}
                              onChange={handlePopupCheckbox2}
                            />
                            <label htmlFor="username" className="ms-1 mt-2">
                              Private
                            </label>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
                {popchecked2 && (

                  <Col xl={6}>
                    <label htmlFor="username">User Id's</label>
                    <MultiSelect
                      value={privateDrop}
                      onChange={e => setPrivateDrop(e.value)}
                      options={PrivetDropdownValues}
                      optionLabel="name"
                      optionValue="value"
                      placeholder="Select Users"
                      className="w-full"
                      style={{ border: '1px solid #ced4da' }}
                      display="comma"
                      maxSelectedLabels={3}
                    />
                  </Col>
                  // <Col xl={6}>
                  //   <label htmlFor="username">User Id's</label>
                  //   <Chips
                  //     value={userid}
                  //     onChange={e => setUserid(e.value)}
                  //     itemTemplate={customChip}
                  //     className="w-full"
                  //   />
                  // </Col>
                )}
              </Row>
              {popchecked && (
                <Row>
                  <Col xl={12} className="mt-2">
                    <div className="schedule-editor">
                      <Editor
                        value={scheduleText}
                        onTextChange={e => setScheduleText(e.htmlValue)}
                        style={{ height: "auto" }}
                      />
                    </div>
                  </Col>
                </Row>
              )}
            </div>

            <Row className="mt-3">
              <Col xl={12}>
                <div className="d-flex justify-content-end">
                  <button
                    type="submit"
                    class="btn btn-primary waves-effect waves-light btn btn-primary me-2 btn-main"
                  >
                    <i className="pi pi-save me-1"></i>
                    Save
                  </button>
                  <button
                    color="primary"
                    className="btn btn-primary waves-effect waves-light me-2 cancel-outlinebtn"
                  >
                    <i className="pi pi-times me-1"></i>
                    Cancel
                  </button>
                </div>
              </Col>
            </Row>
          </p>
        </form>
      </Dialog>
      {/* Interview schedule Other end */}

      {/* <WorkTypeSidebar style={{dis}}
        visible={showWorkTypeSidebar}
        onHide={() => setShowWorkTypeSidebar(false)}
      /> */}
      <Dialog
        header={isEdit ? "Edit Document" : "Add Document"}
        visible={displayDialog}
        onHide={() => setDisplayDialog(false)}
        style={{ width: "30vw" }}
        footer={
          <div className="d-flex justify-content-end gap-2">
            {isEdit ?
              <Button color="primary btn-main mr-2" onClick={handleUpdateDocument}>
                <i className="pi pi-pencil me-1"></i>
                Update
              </Button> :
              <Button color="primary btn-main mr-2" onClick={handleAddDocument}>
                <i className="pi pi-plus me-1"></i>
                Add Document
              </Button>
            }
            <Button color="btn btn-primary cancel-outlinebtn" onClick={() => setDisplayDialog(false)}>
              <i className="pi pi-times me-1"></i>
              Cancel
            </Button>
          </div>
        }
      >
        <Row className="mt-2 align-items-center">
          <Col xl={3}>
            <label htmlFor="documentType" className="block mb-2">
              Document Type
            </label>
          </Col>
          <Col xl={9}>
            <Dropdown
              id="documentType"
              value={selectedDocument}
              onChange={(e) => setSelectedDocument(e.value)}
              // options={[
              //   ...documentTypes,
              //   { id: 'add', name: 'Add New', value: 'Add New', icon: 'pi pi-plus' },
              //   ...(selectedDocument ? [{ id: 'edit', name: 'Edit Selected', value: 'Edit Selected', icon: 'pi pi-pencil' }] : []),
              // ]}
              options={documentTypes}
              optionLabel="name"
              optionValue="id"
              className="w-full bgclr"
              style={{ border: '1px solid #ced4da' }}
              placeholder="Select Document Type"
              itemTemplate={(option) => (
                <div className="flex align-items-center gap-2">
                  {option?.icon && <i className={option.icon}></i>}
                  <span>{option.name || option.value}</span>
                </div>
              )}
            />
          </Col>
        </Row>

        <Row className="mt-2 align-items-center">
          <Col xl={3}>
            <label htmlFor="documentSubject" className="block mb-2">
              Document Subject
            </label>
          </Col>
          <Col xl={9}>
            <InputText
              id="documentSubject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              className="w-full"
              style={{ border: '1px solid #ced4da' }}
              placeholder="Enter document subject or description"
            />
          </Col>
        </Row>

        <Row className="mt-2 align-items-center">
          <Col xl={3}>
            <label htmlFor="documentAttachment" className="block mb-2">
              File Attachment
            </label>
          </Col>
          <Col xl={9}>
            <FileUpload
              ref={fileUploadRef}
              name="files[]"
              accept="image/jpg,image/jpeg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              maxFileSize={5242880}
              multiple
              customUpload
              auto={false}
              onSelect={(e) => {
                const currentFiles = uploadedFiles || [];
                const newFiles = e.files || [];

                // Calculate total size including existing files
                const currentTotalSize = currentFiles.reduce((total, file) => total + (file.size || 0), 0);
                const newTotalSize = newFiles.reduce((total, file) => total + (file.size || 0), 0);
                const totalSize = currentTotalSize + newTotalSize;

                // Check total size limit (5MB = 5,242,880 bytes)
                if (totalSize > 5242880) {
                  toast.current?.show({
                    severity: 'error',
                    summary: 'File Size Error',
                    detail: `Total file size exceeds 5MB limit. Current total: ${(totalSize / 1024 / 1024).toFixed(2)}MB`
                  });

                  // Clear the new selection but preserve existing files
                  if (fileUploadRef.current) {
                    fileUploadRef.current.clear();
                    if (currentFiles.length > 0) {
                      fileUploadRef.current.setFiles(currentFiles);
                    }
                  }
                  return;
                }

                // Check file types
                const allowedTypes = [
                  'image/jpeg', 'image/jpg', 'image/png',
                  'application/pdf',
                  'application/msword',
                  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                  'text/plain',
                  'application/vnd.ms-excel',
                  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                ];

                const invalidFiles = newFiles.filter(file => !allowedTypes.includes(file.type));
                if (invalidFiles.length > 0) {
                  toast.current?.show({
                    severity: 'error',
                    summary: 'Invalid File Type',
                    detail: `Invalid file types: ${invalidFiles.map(f => f.name).join(', ')}. Only Images, PDF, DOC, DOCX, TXT, XLS, XLSX are allowed.`
                  });

                  // Clear the new selection but preserve existing files
                  if (fileUploadRef.current) {
                    fileUploadRef.current.clear();
                    if (currentFiles.length > 0) {
                      fileUploadRef.current.setFiles(currentFiles);
                    }
                  }
                  return;
                }

                // All validations passed, update the files
                const combinedFiles = [...currentFiles, ...newFiles];
                setUploadedFiles(combinedFiles);
              }}
              // uploadHandler={(e) => {
              // }}
              onClear={() => {
                setUploadedFiles([]);
              }}
            />
            <small className="text-muted">
              Maximum total file size: 5MB. Accepted formats: Images (JPG, JPEG, PNG), PDF, DOC, DOCX, TXT, XLS, XLSX
            </small>
          </Col>
        </Row>

        {FileNames && FileNames.length > 0 && (
          <Row className="mt-2 align-items-center">
            <Col xl={3}>
              <label className="block mb-2">Previously Attached Files</label>
            </Col>
            <Col xl={9}>
              {FileNames.map((file) => (
                <div key={file.id} className="d-flex align-items-center mb-2">
                  <a
                    href={file.url || file.name}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="me-2"
                  >
                    {file.name.split('/').pop()}
                  </a>
                  <i
                    className="pi pi-times"
                    style={{ cursor: "pointer", color: "red" }}
                    onClick={() => {
                      setFileNames(prev => prev.filter(f => f.id !== file.id));
                    }}
                  ></i>
                </div>
              ))}
            </Col>
          </Row>
        )}
      </Dialog>
      {/* ================================================================= */}
      <Dialog
        header={TaskeditId === null ? "Add Task Status" : "Edit Task Status"}
        visible={showStatuspopup}
        onHide={() => { setShowStatuspopup(false); resetTaskForm(); setTaskeditId(null); }}
        style={{ width: "35vw", maxWidth: "600px" }}
        footer={
          <div className="flex gap-2 justify-content-end">
            <Button
              label="Cancel"
              icon="pi pi-times"
              className="p-button-secondary"
              onClick={() => { setShowStatuspopup(false); resetTaskForm(); setTaskeditId(null); }}
            />

            <Button
              label="Save"
              icon="pi pi-check"
              className="p-button-success"
              onClick={taskSubmit(onSubmitTaskStatus)}
            />
          </div>
        }
      >
        <form className="grid">

          {/* Status Name */}
          <div className="col-12">
            <label className="block mb-2">
              Status Name <span className="text-red-500">*</span>
            </label>

            <InputText
              className={`w-full ${taskErrors.statusName && "p-invalid"}`}
              placeholder="Enter status name"
              {...taskRegister("statusName", {
                required: "Status Name is required"
              })}
            />

            {taskErrors.statusName && (
              <small className="p-error">
                {taskErrors.statusName.message}
              </small>
            )}
          </div>

          {/* Description */}
          <div className="col-12">
            <label className="block mb-2">
              Description <span className="text-red-500">*</span>
            </label>

            <InputTextarea
              rows={3}
              className={`w-full ${taskErrors.description && "p-invalid"}`}
              placeholder="Enter description"
              {...taskRegister("description", {
                required: "Description is required"
              })}
            />

            {taskErrors.description && (
              <small className="p-error">
                {taskErrors.description.message}
              </small>
            )}
          </div>
          <div className="col-12">
            <label className="block mb-2">Choose Color</label>

            <Controller
              name="color"
              control={taskControl}
              defaultValue="#000000"
              render={({ field }) => (
                <ColorPicker
                  format="hex"
                  value={field.value}
                  onChange={(e) => field.onChange(e.value)}
                  className="w-full"
                />
              )}
            />
          </div>


        </form>
      </Dialog>

      <Dialog
        header={ApprovalStatusid === null ? "Add Approval Status" : "Edit Approval Status"}
        visible={showApprovalStatuspopup}
        onHide={() => { setShowApprovalStatuspopup(false); resetApprovalForm(); setApprovalStatusid(null); }}
        style={{ width: "35vw", maxWidth: "600px" }}
        footer={
          <div className="flex gap-2 justify-content-end">
            <Button
              label="Cancel"
              icon="pi pi-times"
              className="p-button-secondary"
              onClick={() => { setShowApprovalStatuspopup(false); resetApprovalForm(); setApprovalStatusid(null); }}
            />

            <Button
              label="Save"
              icon="pi pi-check"
              className="p-button-success"
              onClick={approvalSubmit(onSubmitApprovalStatus)}
            />
          </div>
        }
      >
        <form className="grid">

          {/* Status Name */}
          <div className="col-12">
            <label className="block mb-2">
              Status Name <span className="text-red-500">*</span>
            </label>

            <InputText
              className={`w-full ${approvalErrors.statusName && "p-invalid"}`}
              placeholder="Enter status name"
              {...approvalRegister("statusName", {
                required: "Status Name is required"
              })}
            />

            {approvalErrors.statusName && (
              <small className="p-error">
                {approvalErrors.statusName.message}
              </small>
            )}
          </div>

          {/* Description */}
          <div className="col-12">
            <label className="block mb-2">
              Description <span className="text-red-500">*</span>
            </label>

            <InputTextarea
              rows={3}
              className={`w-full ${approvalErrors.description && "p-invalid"}`}
              placeholder="Enter description"
              {...approvalRegister("description", {
                required: "Description is required"
              })}
            />

            {approvalErrors.description && (
              <small className="p-error">
                {approvalErrors.description.message}
              </small>
            )}
          </div>
          <div className="col-12">
            <label className="block mb-2">Choose Color</label>

            <Controller
              name="color"
              control={approvalControl}
              defaultValue="#000000"
              render={({ field }) => (
                <ColorPicker
                  format="hex"
                  value={field.value}
                  onChange={(e) => field.onChange(e.value)}
                  className="w-full"
                />
              )}
            />
          </div>


        </form>
      </Dialog>

      <Dialog
        header={ModuleeditId === null ? "Add Module Status" : "Edit Module Status"}
        visible={showModulepopup}
        onHide={() => { setShowModulepopup(false); resetModuleForm(); setModuleeditId(null); }}
        style={{ width: "35vw", maxWidth: "600px" }}
        footer={
          <div className="flex gap-2 justify-content-end">
            <Button
              label="Cancel"
              icon="pi pi-times"
              className="p-button-secondary"
              onClick={() => { setShowModulepopup(false); resetModuleForm(); setModuleeditId(null); }}
            />

            <Button
              label="Save"
              icon="pi pi-check"
              className="p-button-success"
              onClick={moduleSubmit(onSubmitModuleStatus)}
            />
          </div>
        }
      >
        <form className="grid">

          {/* Status Name */}
          <div className="col-12">
            <label className="block mb-2">
              Module Name <span className="text-red-500">*</span>
            </label>

            <InputText
              className={`w-full ${moduleErrors.statusName && "p-invalid"}`}
              placeholder="Enter status name"
              {...moduleRegister("statusName", {
                required: "Status Name is required"
              })}
            />

            {moduleErrors.statusName && (
              <small className="p-error">
                {moduleErrors.statusName.message}
              </small>
            )}
          </div>

          {/* Description */}
          <div className="col-12">
            <label className="block mb-2">
              Description <span className="text-red-500">*</span>
            </label>

            <InputTextarea
              rows={3}
              className={`w-full ${moduleErrors.description && "p-invalid"}`}
              placeholder="Enter description"
              {...moduleRegister("description", {
                required: "Description is required"
              })}
            />

            {moduleErrors.description && (
              <small className="p-error">
                {moduleErrors.description.message}
              </small>
            )}
          </div>
        </form>
      </Dialog>
      <Dialog
        header={GroupeditId === null ? "Add Group" : "Edit Group"}
        visible={ShowGrouppopup}
        onHide={() => { setShowGrouppopup(false); resetGroupForm(); setGroupeditId(null); setSelectedCompanies([]); setSelectedWatchersids([]); }}
        style={{ width: "500px", maxWidth: "600px" }}
        footer={
          <div className="flex gap-2 justify-content-end">
            <Button
              label="Cancel"
              icon="pi pi-times"
              className="p-button-secondary"
              onClick={() => { setShowGrouppopup(false); resetGroupForm(); setGroupeditId(null); setSelectedCompanies([]); setSelectedWatchersids([]); }}
            />

            <Button
              label="Save"
              icon="pi pi-check"
              className="p-button-success"
              disabled={apiLoader}
              onClick={groupSubmit(onSubmitGroupStatus)}
            />
          </div>
        }
      >
        <form className="grid">

          {/* Group Name */}
          <div className="col-12">
            <label className="block mb-2">
              Group Name <span className="text-red-500">*</span>
            </label>

            <InputText
              className={`w-full ${groupErrors.groupName && "p-invalid"}`}
              placeholder="Enter group name"
              {...groupRegister("groupName", {
                required: " Group Name is required"
              })}
              disabled={apiLoader}
            />

            {groupErrors.groupName && (
              <small className="p-error">
                {groupErrors.groupName.message}
              </small>
            )}
          </div>
          {companyOptions.map((company, i) => (
            <Row className="mb-2" key={i}>
              <Col lg={12}>
                <div className="form-check d-flex align-items-center gap-2">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id={`company_${i}`}
                    checked={selectedCompanies.includes(company.id)}
                    onChange={(e) => handleCompanySelect(e, company.id)}
                  />
                  <label htmlFor={`company_${i}`}>{company.name}</label>
                </div>
              </Col>
              {selectedCompanies.includes(company.id) && (
  <Col lg={12} style={{ maxWidth: '460px' }} className="mt-2">
    <MultiSelect
      id={`company_multi_${company.id}`}
      value={companyDropdownData[company.id]?.selected || []}
      onChange={(e) => handleMultiSelectChange(company.id, e)}
      options={getSortedOptions(company.id)}   // ✅ sorted
      optionLabel={(option) =>
        `${option.full_name} (${option.primary_email})`
      }
      optionValue="id"
      display="chip"
      filter
      placeholder="Select Employees"
      className="w-full"
      loading={apiLoader}
    />
  </Col>
)}



            </Row>
          ))}
        </form>
      </Dialog>
      <Dialog
        header="Group Details"
        visible={showViewGrouppopup}
        onHide={() => { setShowViewGrouppopup(false) }}
        style={{ width: "35vw", maxWidth: "600px" }}
        footer={
          <div className="flex gap-2 justify-content-end">
            <Button
              label="Cancel"
              icon="pi pi-times"
              className="p-button-secondary"
              onClick={() => { setShowViewGrouppopup(false); }}
            />
          </div>
        }
      >
        <div className="col-12">
          <label className="block mb-2">
            Group Name
          </label>

          <InputText
            className="w-full"
            value={viewGroupNames?.group_name}
            readOnly
          />
        </div>
        <div className="col-12">
          <div className="doc-table">
            <label className="block mb-2">
              Group Members Info
            </label>
            <DataTable
              value={viewGroupNames?.members || []}
              rows={5}
              className="p-datatable-gridlines"
              emptyMessage={<div className="empty-message-custom">No members found.</div>}
            >
              <Column
                field="employee_code"
                header="Employee Code"
              />
              <Column
                field="name"
                header="Employee Name"
              />

            </DataTable>
          </div>
        </div>
      </Dialog>
      <Dialog
        header="Add Stage"
        visible={showStagepopup}
        onHide={handleCancelStagePopup}
        style={{ width: "35vw", maxWidth: "600px" }}
        footer={
          <div className="flex gap-2 justify-content-end">
            <Button
              label="Cancel"
              icon="pi pi-times"
              className="p-button-secondary"
              onClick={handleCancelStagePopup}
            />

            <Button
              label="Save"
              icon="pi pi-check"
              className="p-button-success"
              onClick={stageSubmit(onSubmitStages)}
            />
          </div>
        }
      >
        <form className="grid">
          <Col lg={12}>
            <label className="block mb-2 mt-2">
              Stage / Level <span className="text-red-500">*</span>
            </label>
            <InputText
              className={`w-full ${StageErrors.statusName && "p-invalid"}`}
              placeholder="Enter Stage / Level name"
              {...StageRegister("statusName", {
                required: "Stage  is required"
              })}
            />

            {StageErrors.statusName && (
              <small className="p-error">
                {StageErrors.statusName.message}
              </small>
            )}
          </Col>
          <Col lg={12}>
            <label htmlFor="city" className="mb-1 mt-4">
              Company <span style={{ color: "red" }}>*</span>
            </label>
            <Dropdown
              id="status"
              value={selectedresponsiblePersonCompany}
              onChange={(e) => { setSelectedresponsiblePersonCompany(e.value); getTeam(e.value); }}
              options={compamyitem}
              placeholder="Select Responsible Person"
              className="w-full bgclr"
              optionLabel="name"
              optionValue="id"
              filter
            />
          </Col>
          <Col lg={12}>
            <label htmlFor="city" className="mb-1 mt-4">
              Responsible Person <span style={{ color: "red" }}>*</span>
            </label>
            <Dropdown
              id="status"
              value={selectedresponsiblePerson}
              onChange={(e) => setSelectedresponsiblePerson(e.value)}
              options={teamData}
              placeholder="Select Responsible Person"
              className="w-full bgclr"
              optionLabel="name"
              optionValue="id"
              filter
              loading={apiLoader}
            />
          </Col>
          <Col lg={12}>
            <label htmlFor="city" className="mb-1 mt-4">
              Group
            </label>
            <Dropdown
              id="status"
              value={selectedGroup}
              onChange={(e) => setSelectedGroup(e.value)}
              options={GroupsList}
              placeholder="Select Group"
              className="w-full bgclr"
              optionLabel="group_name"
              optionValue="id"
              filter
            />
          </Col>
        </form>
      </Dialog>
          <Dialog
                header="Add CC Email"
                visible={sendReportDialog}
                onHide={() => { setSendReportDialog(false); sendReset(); setSelectedTasksData([]); }}
                style={{ width: "32rem" }}
                modal
                draggable={false}
                footer={<div className="dialog-footer">
                  <Button
                    label="CLOSE"
                    className="p-button-success p-button-sm"
                    onClick={() => { setSendReportDialog(false); sendReset(); setSelectedTasksData([]); }}
                  />
                  <Button
                    label="SEND"
                    className="p-button-success p-button-sm ms-2"
                    onClick={sendHandleSubmit(onSendReport)}
                  />
                </div>}
              >
                <form className="add-cc-form">
                  <div className="field">
                    <label>To:</label>
                    <input
                      type="text"
                      className="p-inputtext p-component disabled-input w-full"
                      // value={toEmails}
                       {...sendRegister("toemails")}
                      disabled
                    />
                  </div>
                  <div className="field">
                    <label>CC:</label>
                    <input
                      type="text"
                      className="p-inputtext p-component w-full"
                      placeholder="Enter CC email(s)"
                      {...sendRegister("cc", {
                        pattern: {
                          value: /^([\w.+-]+@[\w-]+\.[\w.-]+)(,\s*[\w.+-]+@[\w-]+\.[\w.-]+)*$/,
                          message: "Enter valid comma-separated emails"
                        }
                      })}
                    />
                    {sendErrors.cc && (
                      <small className="p-error">{sendErrors.cc.message}</small>
                    )}
                  </div>
                  <div className="field">
                    <label>Comments</label>
                    <InputTextarea
                      rows={4}
                      className="w-full"
                      placeholder="Enter comments"
                      {...sendRegister("comments")}
                    />
                  </div>
                </form>
              </Dialog>
    </React.Fragment>
  )
}
export default ProjectAllActive
